export const ptLangDashboard = {
  headerSearch: {
    placeholder: 'Buscar produtos',
    cancel: 'Cancelar',
    empty: 'Nenhum produto encontrado',
    noShop: 'Ainda não há produtos para buscar',
  },
  common: {
    elements: 'Elementos',
    of: 'de',
    itemsLower: 'itens',
    extraContent: 'Conteúdo adicional',
    you: 'Você',
    post: 'Publicação',
    article: 'Artigo',
    create: 'Criar',
    message: 'Mensagem',
    popular: 'Popular',
    emptyIntegrations: 'Você precisa adicionar integrações primeiro',
    categories: 'Categorias',
    edit: 'Editar',
    share: 'Compartilhar',
    plan: 'Plano',
    sort: 'Ordenar',
    addArticle: 'Adicionar artigo',
    articles: 'Artigos',
    users: 'usuários',
    scans: 'escaneamentos',
    clicks: 'cliques',
    copy: 'Copiar',
    customize: 'Personalizar',
    link: 'link',
    save: 'Salvar',
    uploadFile: 'Enviar Arquivo',
    customImage: 'Imagem Personalizada',
    customImageTooltip: 'Enviar imagem personalizada',
    size: 'Tamanho',
    sizeTooltip: 'Arraste o controle para definir o tamanho',
    auto: 'Auto',
    rectangle: 'Retângulo',
    custom: 'Personalizado',
    clean: 'Limpar',
    cleaning: 'Limpando',
    download: 'Baixar',
    downloading: 'Baixando',
    preview: 'PRÉ-VISUALIZAR',
    cover: 'Capa',
    coverTooltip: 'Envie uma foto de capa',
    title: 'Título',
    new: 'Novo',
    pro: 'Pro',
    free: 'Grátis',
    limit: 'Limite',
    websites: 'sites',
    site: 'Site',
    apiKey: 'API Key',
    name: 'Nome',
    passwordChange: 'Alterar senha',
    draft: 'Rascunho',
    page: 'Página',
    areYouSure: 'Tem certeza?',
    drop: 'Soltar',
    video: 'vídeo',
    image: 'imagem',
    chooseFile: 'Escolher arquivo',
    nothingFound: 'Nada Encontrado',
    enterCorrectLink: 'Insira um link correto',
    off: 'Desligado',
    disconnect: 'DESCONECTAR',
    connect: 'CONECTAR',
    copied: 'Copiado',
    saved: 'Salvo',
    lostConnection: 'Conexão perdida',
    addedCategory: 'Categoria adicionada',
    none: 'Nenhum',
    left: 'Esquerda',
    right: 'Direita',
    solid: 'Sólido',
    double: 'Duplo',
    welcome: 'Bem-vindo',
    category: 'Categoria',
    product: 'Produto',
    website: 'Site',
    items: 'Itens',
    square: 'Quadrado',
    round: 'Redondo',
    border: 'Borda',
    shadow: 'Sombra',
    subtle: 'Sutil',
    soft: 'Suave',
    hard: 'Forte',
    block: 'Bloco',
    primary: 'Primário',
    additional: 'Adicional',
    normal: 'Normal',
    bold: 'Negrito',
    uploadVideo: 'Enviar vídeo',
    compact: 'Compacto',
    card: 'Cartão',
    top: 'Topo',
    center: 'Centro',
    bottom: 'Inferior',
    button: 'Botão',
    addNewItem: 'Adicionar novo item',
    price: 'Preço',
    priceCaption: 'Adicione o preço do seu produto',
    oldPrice: 'Preço antigo',
    oldPriceCaption: 'O preço antigo será riscado',
    areYouSureDeleteItem: 'Tem certeza de que deseja remover este item?',
    add: 'Adicionar',
    active: 'Ativo',
    isActive: 'está ativo',
    isDisabled: 'está desativado',
    uploadImage: 'Enviar imagem',
    design: 'Design',
    addAccount: 'Adicionar conta',
    hey: 'Olá',
    activeBackground: 'Fundo ativo',
    activeText: 'Texto ativo',
    connectDomain: 'Conectar Domínio',
    shortLink: 'Link Curto',
    appearanceSaved: 'Aparência salva!',
    blockAdded: 'Bloco adicionado!',
    comingSoon: 'Em breve',
    easyMoney: 'Dinheiro fácil',
    content: 'Conteúdo',
    audience: 'Público',
    view: 'Visualizar',
    delete: 'Excluir',
    file: 'Arquivo',
    type: 'Tipo',
    from: 'De',
    to: 'Para',
    fullName: 'Nome completo',
    lastTimeUsed: 'Último uso',
    noMediaFiles: 'Sem arquivos de mídia ainda...',
    withdraw: 'Sacar',
    congrats: 'Parabéns!',
    makeMoneyOnline: 'Ganhe dinheiro online!',
    thin: 'Fina',
    blockEmptyTitle: 'Ainda não há nada aqui',
    blockEmptyText: 'Este bloco ainda não tem itens. Adicione um para o ver na sua página.',
    noItemsTitle: 'Ainda não tem itens',
    noItemsText: 'Adicione o seu primeiro item para preencher este bloco.',
  },
  sort: {
    title: 'Ordenar',
    search: 'Buscar',
    default: 'Ordenação padrão',
    dateNew: 'Data: Mais Recente para Mais Antigo',
    dateOld: 'Data: Mais Antigo para Mais Recente',
    priceLow: 'Preço: Menor para Maior',
    priceHigh: 'Preço: Maior para Menor',
    nameA: 'Nome: A a Z',
    nameZ: 'Nome: Z a A',
    popular: 'Mais populares',
  },
  emailMenu: {
    broadcasts: 'Transmissões',
    automations: 'Automações',
    templates: 'Modelos',
    log: 'Registro',
    settings: 'Configurações',
    noEmails: 'Nenhum e-mail ainda',
    newBroadcast: 'Novas Transmissões',
  },
  aiContent: {
    title: 'Crie seu primeiro conteúdo com IA!',
    text: 'Planeje e publique conteúdo em todas as redes sociais de uma vez!',
    create: 'Criar conteúdo com IA',
  },
  pageDesign: {
    page: 'Design da página',
    image: 'Imagem',
  },
  toolsMenu: {
    title: 'Ferramentas',
    account: 'Conta',
    instantPages: 'Páginas Instantâneas',
    instantPagesText: 'Páginas independentes de carregamento rápido',
    agents: 'Agentes',
    agentsText: 'Assistentes de IA que gerenciam seu perfil',
    socialPlanner: 'Planejador Social',
    socialPlannerText: 'Agendamento de conteúdo e inspiração',
    emailMarketing: 'Email Marketing',
    emailMarketingText: 'Aumente sua lista de contatos',
    smartReply: 'Instagram Reply',
    smartReplyText: 'Envie comentários e mensagens automáticas',
    linkShortener: 'Encurtador de Links',
    linkShortenerText: 'Encurte URLs longas',
    posts: 'Publicações',
    postsText: 'Crie e gerencie publicações',
    blog: 'Blog',
    blogText: 'Crie e gerencie artigos do blog',
  },
  insideMenu: {
    planner: 'Planejador',
    aiContent: 'Conteúdo IA',
    aiPosts: 'Posts com IA',
    postIdeas: 'Ideias de Posts',
    contentPlanner: 'Planejador de Conteúdo',
    aiImages: 'Imagens com IA',
    brandProjects: 'Brand Identity',
    aiVideo: 'Vídeo IA',
    integrations: 'Integrações',
    products: 'Produtos',
    orders: 'Pedidos',
    payments: 'Pagamentos',
    links: 'Links',
    qrCodes: 'Códigos QR',
    adBuilder: 'Criador de anúncios',
  },
  orders: {
    title: 'Pedidos',
    empty: 'Você ainda não tem nenhum pedido',
    all: 'Todos os pedidos',
    shop: 'Loja',
    digital: 'Produtos digitais',
    appointments: 'Agendamentos',
    services: 'Serviços',
    donations: 'Doações',
  },
  discounts: {
    title: 'Descontos',
    newDiscount: '+ Novo desconto',
    code: 'Código',
    titleCol: 'Título',
    type: 'Tipo',
    value: 'Valor',
    status: 'Status',
    used: 'Usado',
    actions: 'Ações',
    statusAll: 'Todos os status',
    statusActive: 'Ativo',
    statusExpired: 'Expirado',
    statusScheduled: 'Agendado',
    statusInactive: 'Inativo',
    searchPlaceholder: 'Pesquisar por código ou título...',
    clearFilters: 'Limpar filtros',
    emptyTitle: 'Ainda não há descontos',
    emptySubtitle: 'Crie seu primeiro código promocional para oferecer descontos nos seus produtos',
    createDiscount: 'Criar desconto',
    createTitle: 'Criar desconto',
    editTitle: 'Editar desconto',
    fieldTitle: 'Título',
    fieldTitlePlaceholder: 'ex. Promoção de primavera',
    fieldCode: 'Código',
    fieldCodePlaceholder: 'ex. SAVE20',
    generate: 'Gerar',
    sectionDiscount: 'Desconto',
    fieldType: 'Tipo',
    typePercentage: 'Percentagem',
    typeFixed: 'Valor fixo',
    typeFreeShipping: 'Envio grátis',
    fieldValue: 'Valor',
    sectionConditions: 'Condições (opcional)',
    appliesTo: 'Aplica-se a',
    appliesToAll: 'Todos os produtos',
    appliesToShop: 'Loja',
    appliesToDigital: 'Digital',
    appliesToCourses: 'Cursos',
    appliesToServices: 'Serviços',
    appliesToEvents: 'Eventos',
    minOrderAmount: 'Valor mínimo do pedido ($)',
    maxDiscountAmount: 'Valor máximo de desconto ($) — 0 = sem limite',
    minItemCount: 'Mín. de itens no pedido — 0 = sem requisito',
    specificProducts: 'Produtos específicos — vazio = todos',
    specificProductsPlaceholder: 'Pesquisar produtos...',
    noProductsFound: 'Nenhum produto encontrado',
    sectionLimits: 'Limites',
    usageLimit: 'Limite total de uso — 0 = sem limite',
    usageLimitPerUser: 'Limite por cliente — 0 = sem limite',
    sectionSchedule: 'Agendamento',
    startDate: 'Data de início — vazio = começa agora',
    endDate: 'Data de fim — vazio = sem expiração',
    active: 'Ativo',
    cancel: 'Cancelar',
    save: 'Salvar desconto',
    createdSuccess: 'Desconto criado',
    updatedSuccess: 'Desconto atualizado',
    deletedSuccess: 'Desconto excluído',
    loadError: 'Falha ao carregar descontos',
    saveError: 'Falha ao salvar o desconto',
    deleteError: 'Falha ao excluir o desconto',
    fieldTrigger: 'Como se aplica',
    triggerCode: 'Código de desconto',
    triggerAutomatic: 'Automático (sem código)',
    triggerAutomaticHint:
      'Aplicado automaticamente no checkout quando as condições são cumpridas — sem código. Defina abaixo um valor mínimo de encomenda para um desconto por valor da encomenda.',
    automaticBadge: 'Automático',
  },
  donation: {
    chooseSmiles: 'Escolher emojis',
    item: 'Item',
    itemTitle: 'Título do item de doação',
    price: 'Preço',
    thanksMessagePlaceholder: 'Muito obrigado',
    thanksMessage: 'Mensagem de agradecimento',
    thanksMessageCaption: 'A mensagem de agradecimento será exibida para seus fãs após a doação',
    addDonation: 'Adicionar doação',
    addAmount: '+ Adicionar valor',
    buttonTitle: 'Título do botão',
    buttonTitleCaption: 'Título do botão de doação',
    acceptDonations: 'Aceitar doações',
    donationsType: 'Doações',
    tips: 'Gorjetas',
    type: 'Tipo',
    addAnotherAmount: '+ Adicionar outro valor',
  },
  blog: {
    empty: 'Você ainda não tem um blog',
  },
  apps: {
    empty: 'Você ainda não tem aplicativos',
  },
  payments: {
    title: 'Pagamentos',
    text: 'Você ainda não tem nenhuma transação',
    single: 'Pagamentos únicos',
    subscriptions: 'Assinaturas',
    wallet: 'Carteira',
    connectPromo: 'Conecte sua conta Stripe ou PayPal à sua página UniLink e receba todos os pagamentos na sua carteira.',
    connectSystem: 'Conectar sistema de pagamento',
    manageCards: 'Gerenciar seus cartões',
    addNewCard: 'Adicionar novo cartão',
    editCard: 'Editar informações do cartão',
    addCard: 'Adicionar informações do cartão',
    cardHolder: 'Nome do Titular do Cartão',
    cardHolderNecessary: 'É necessário',
    withdrawalSuccess: 'Seu saque foi enviado com sucesso!',
    withdrawalError: 'Algo deu errado, tente novamente mais tarde.',
    change: 'Alterar',
  },
  store: {
    emptyTitle: 'Você ainda não tem nenhum produto',
    emptyText: 'Comece adicionando seu primeiro produto',
    emptyButton: 'Adicionar produto',
    createFirstProduct: 'Crie seu primeiro produto',
    startAdding: 'Comece adicionando seus produtos favoritos, bens digitais ou serviços. Um espaço onde você pode vender e promover tudo o que oferece.',
    activate: 'Ativar Loja',
    empty: 'Você ainda não tem produtos',
    products: 'Produtos',
    addProducts: 'Adicionar produtos',
    whatDoYouWant: 'O que você quer vender?',
    externalProduct: 'URL de produto externo',
    createOwnProduct: 'Criar seu próprio produto',
    shop: 'Loja',
    shopText: 'Venda produtos físicos e digitais',
    digital: 'Produtos digitais',
    digitalText: 'Venda um Download Digital',
    course: 'Curso ou Tutorial',
    courseText: 'Adicione curso ou tutorial ao site',
    service: 'Serviços',
    serviceText: 'Adicione serviços para seus clientes',
    appointment: 'Agendamentos',
    appointmentText: 'Permita que visitantes agendem horários no seu calendário',
    event: 'Eventos ou Ingressos',
    eventText: 'Crie eventos e convide seu público',
    tips: 'Gorjetas',
    tipsText: 'Deixe uma gorjeta para seus criadores favoritos',
    donation: 'Doações',
    donationText: 'Faça uma doação',
    membership: 'Assinatura',
    membershipText: 'Adicione assinatura ao site',
    links: 'Link externo',
    linksText: 'Adicione link externo para qualquer site',
    coupon: 'Cupom',
    couponText: 'Adicione cupom para seu site',
    singleProduct: 'Produto Único',
    singleProductText: 'Venda um único produto com checkout simples',
    booking: 'Reservas',
    bookingText: 'Permita que visitantes reservem seus espaços ou propriedades',
    rental: 'Aluguel',
    rentalText: 'Liste itens para alugar com disponibilidade e preços',
    add: 'Adicionar',
    manageStore: 'Gerenciar Loja',
    displayLast: 'Exibir último produto',
  },
  products: {
    info: 'Informações',
    uploadCover: 'Envie uma foto de capa, depois forneça um título e descrição',
    thumbnail: 'Miniatura',
    thumbnailTab: {
      intro:
        'O cartão que as pessoas veem na sua loja, antes de abrirem o produto. Não tem preço nem stock próprios — esses estão em Details, e aqui só escolhe quais deles o cartão mostra.',
      cardImage: 'Imagem do cartão',
      crop: 'Recorte',
      cropSquare: 'Quadrado',
      cropPortrait: 'Retrato',
      cropWide: 'Largo',
      imageHint: 'Deixe vazio e o cartão usa a primeira imagem de Details. 1200×1200 ou maior fica melhor.',
      cardCopy: 'Texto do cartão',
      cardTitle: 'Título do cartão',
      sameAsTitle: 'Igual ao título do produto',
      shortDescription: 'Descrição curta',
      shortDescriptionHint: 'Uma linha que faça alguém tocar. A descrição longa está em Details.',
      buttonLabel: 'Texto do botão',
      showOnCard: 'Mostrar no cartão',
      showOnCardNote: 'os valores vêm de Details — aqui só decide o que fica visível',
      editInDetails: 'Editar em Details ↗',
      rowPrice: 'Preço',
      rowOldPrice: 'Preço anterior e desconto',
      rowAvailability: 'Disponibilidade',
      rowLabel: 'Etiqueta',
      inStock: 'Em stock',
      notShown: 'Não mostrado',
    },
    thumbnailError: 'Por favor, adicione uma miniatura',
    title: 'Título',
    titleTooltip: 'Insira o nome do seu produto',
    shortDescription: 'Descrição curta',
    shortDescriptionTooltip: 'Insira uma descrição curta do seu produto',
    description: 'Descrição',
    descriptionTooltip: 'Insira a descrição do seu produto',
    descriptionTooltipExtra: 'Descrição opcional de características, tipos, cor, tamanhos do produto, etc.',
    price: 'Preço',
    priceTooltip: 'Insira o preço do seu produto',
    oldPrice: 'Preço antigo',
    oldPriceTooltip: 'O preço antigo será riscado',
    category: 'Categoria',
    categoryTooltip: 'Escolha a categoria do seu produto',
    image: 'Imagem',
    imageTooltip: 'Envie uma imagem para seu produto',
    groups: 'Grupos',
    rate: 'Avaliação',
    rateTooltip: 'Insira a avaliação do seu produto',
    buttonTitle: 'Título do botão',
    buttonTitleTooltip: 'Insira o título do botão do seu produto',
    limitQuantity: 'Limitar Quantidade',
    itemsLeft: 'Itens restantes',
    itemsLeftTooltip: 'Itens do seu produto',
    trackStock: 'Controlar estoque',
    stockQuantity: 'Quantidade em estoque',
    stockQuantityTooltip: 'Unidades atualmente em estoque. Diminui automaticamente a cada pedido pago; ao chegar a 0, o produto não pode mais ser comprado.',
    lowStockThreshold: 'Alerta de estoque baixo',
    lowStockThresholdTooltip: 'Seja notificado quando o estoque cair para este número ou menos.',
    maxOrderQuantity: 'Quantidade máxima por pedido',
    maxOrderQuantityTooltip: 'Número máximo de unidades que um cliente pode comprar em um único pedido. Deixe vazio para sem limite.',
    minOrderQuantity: 'Quantidade mínima por pedido',
    minOrderQuantityTooltip: 'Número mínimo de unidades que um cliente deve comprar em um único pedido. Deixe vazio para sem limite.',
    attachments: 'Anexos',
    addAttachments: 'Adicione anexos aos seus produtos',
    addNewAttachment: 'Adicionar novo item',
    file: 'Arquivo',
    uploadFile: 'Enviar arquivo',
    uploadCoverTitle: 'Enviar capa',
    optionalDescription: 'Descrição opcional de características, tipos, cor, tamanhos do produto, etc.',
    customReviews: 'Avaliações personalizadas',
    addCustomReviews: 'Adicione avaliações aos seus produtos',
    name: 'Nome',
    nameTooltip: 'Insira o nome do seu cliente',
    comment: 'Comentário',
    commentTooltip: 'Insira o comentário do seu cliente',
    rateTooltipCustomer: 'Avaliação do cliente',
    imageTooltipCustomer: 'Envie a imagem do seu cliente',
    displayPriceOnPreview: 'Exibir preço na pré-visualização',
    displayDetailsOnPreview: 'Exibir detalhes na pré-visualização',
    postOnSocials: 'Publicar nas Redes Sociais',
    sendAnEmail: 'Enviar um E-mail',
    highlights: 'Destaques',
    listProductSetup: 'Liste o produto e configure seu bloco de loja',
    whereToSell: 'Onde você gostaria de vender este produto?',
    youHaveProducts: 'Você tem {count} produtos',
    shareThisProduct: 'Compartilhar este produto',
    shareAProduct: 'Compartilhar um produto',
    monetizeWays: 'Diferentes formas de monetizar no Unilink',
    addProductToProfile: 'Adicionar um {title} ao seu perfil',
    productPage: 'Página do produto',
    setUpPayments: 'Configure seus pagamentos',
    connectPaymentMethods: 'Conecte seus métodos de pagamento para começar a ganhar dinheiro no Unilink',
    addPaymentMethod: 'Adicione um método de pagamento {type} para receber pagamentos dos seguidores',
    withdrawAttempt: 'Esta é uma tentativa de cobrança de dívida e qualquer informação será usada para esse fim.',
    withdrawSuccess: 'Seu saque foi enviado com sucesso!',
    yourVisitorsPay: 'Seus visitantes pagarão primeiro e depois serão direcionados para seu {method}',
    emailAddress: 'endereço de e-mail',
    calendlyLink: 'link do Calendly',
    features: 'Vantagens',
    featuresTooltip: 'Lista de vantagens mostrada no layout de cartão Montra',
    featurePlaceholder: 'Vantagem',
    addFeature: 'Adicionar vantagem',
    pendingReviews: {
      title: 'Avaliações pendentes',
      subtitle: 'Aprove ou oculte as avaliações dos compradores antes de ficarem públicas',
      empty: 'Nenhuma avaliação à espera de moderação.',
      approve: 'Aprovar',
      hide: 'Ocultar',
    },
  },
  posts: {
    posts: 'Publicações',
    title: 'Crie sua primeira publicação',
    description: 'Publicações são onde você cria automações de chat em um formato fácil e visual. Experimente algumas automações que recomendamos com base nos seus objetivos',
    activate: 'Ativar Publicações',
    managePosts: 'Gerenciar Publicações',
    postsTab: 'Aba de Publicações',
    displayLast: 'Exibir últimas publicações',
    tabNavigation: 'Configurações de navegação por abas',
    createFirstPost: 'Crie sua primeira publicação social!',
    autoPostsText: 'Planeje e publique conteúdo em todas as redes sociais de uma vez!',
    createPost: 'Criar publicação',
  },
  messages: {
    title: 'Mensagens',
    empty: 'Sem Mensagens',
    addText: 'Adicione um botão de mensagem ao bloco Cabeçalho, permitindo que os usuários enviem facilmente uma mensagem para você.',
    addButton: 'Adicionar botão de Mensagem',
  },
  smartReply: {
    title: 'Instagram Reply',
    clicks: 'cliques',
    createTitle: 'Crie sua primeira Instagram Reply!',
    text: 'Use DMs automáticas do Instagram para compartilhar links automaticamente com seu público!',
    createButton: 'Criar Auto DM',
    subtitleComment: 'DM automático com um link em resposta a um comentário',
    subtitleDm: 'DM automático em resposta a uma mensagem ou Story',
    ready: 'pronto',
    edit: 'Editar',
    stepContentTitle: 'Conteúdo IG',
    stepContentSub: 'Escolha uma publicação ou Reel',
    storiesAndDmsSub: 'DM automático quando alguém responde a uma Story ou lhe escreve',
    stepTriggerTitle: 'Acionador',
    stepTriggerSub: 'Palavras-chave nos comentários',
    stepTriggerSubDm: 'Palavras-chave nas mensagens',
    stepDmTitle: 'DM',
    stepDmSub: 'A mensagem enviada automaticamente',
    dmSummary: 'Mensagem definida',
    activatesNow: 'A resposta automática ativa-se de imediato',
    saveAutomation: 'Guardar resposta automática',
    savedToast: 'Resposta automática criada',
    linkLabel: 'Escolha o destino do link',
    selectDestination: 'Escolha um link, produto ou artigo',
    change: 'Alterar',
    choose: 'Escolher',
    remove: 'Remover',
    optional: 'opcional',
    buttonText: 'Texto do botão',
    addLink: 'Adicionar link',
    attachLink: 'Anexar link',
    noLinks: 'Ainda não há links — adicione primeiro um link no seu Link in Bio.',
    tabLinks: 'Links',
    tabProducts: 'Produtos',
    noProducts: 'Ainda não há produtos — crie primeiro um produto na sua loja.',
    tabArticles: 'Artigos',
    noArticles: 'Ainda não há artigos — crie primeiro um artigo.',
    choosePost: 'Escolha uma publicação ou Reel',
    searchPosts: 'Pesquisar nas suas publicações',
    loadingPosts: 'A carregar as suas publicações…',
    done: 'Concluído',
    oneSelected: '1 publicação selecionada',
    postSelected: 'Publicação selecionada',
    noPosts: 'Ainda não há publicações — publique uma publicação ou Reel no Instagram.',
    postsError: 'Não foi possível carregar as publicações. Tente novamente.',
    reauthTitle: 'Alguns DM podem não ser entregues.',
    reauthText: 'O Instagram exige que volte a autorizar a conta.',
    reconnect: 'Voltar a ligar',
    statActive: 'Automações ativas',
    statDmSent: 'DM enviados · 30 d',
    statClicks: 'Cliques no link',
    activeReplies: 'Respostas automáticas ativas',
    filterAll: 'Todas',
    filterActive: 'Ativas',
    filterOff: 'Desativadas',
  },
  businessCards: {
    title: 'Cartões de visita',
    emptyTitle: 'Crie seu cartão de visita digital',
    emptySubtitle: 'Adicione seus dados de contato para que qualquer pessoa possa salvá-los no celular com um toque — depois compartilhe com um código QR ou um arquivo .vcf.',
    createButton: 'Criar cartão de visita',
    sectionButton: 'Botão Salvar contato',
    sectionButtonSubtitle: 'Como o botão "Salvar contato" aparece e onde ele fica no seu perfil.',
    showButton: 'Mostrar no meu perfil',
    showButtonSubtitle: 'Exibir o botão "Salvar contato" na sua página pública.',
    placement: 'Posição do botão',
    placementSubtitle: 'Escolha onde o botão aparece.',
    showInHeader: 'Mostrar no cabeçalho',
    placementHeader: 'Cabeçalho do perfil',
    placementHeaderHint: 'Aparece logo abaixo do seu nome e avatar.',
    placementContact: 'Seção de contatos',
    placementContactHint: 'Aparece dentro da janela de Contatos.',
    placementBottom: 'Botão flutuante',
    placementBottomHint: 'Fica na parte inferior da página ao rolar.',
    none: 'Nenhum',
    buttonLabel: 'Texto do botão',
    buttonLabelSubtitle: 'Texto exibido no botão.',
    saveContact: 'Salvar contato',
    sectionDetails: 'Dados de contato',
    sectionDetailsSubtitle: 'Esses dados são salvos no cartão de contato.',
    delete: 'Excluir cartão de visita',
    previewHint: 'É assim que seu cartão aparece para os visitantes.',
    share: 'Compartilhar e QR',
    shareSubtitle: 'Escaneie o código ou compartilhe o link para abrir seu perfil.',
    download: 'Baixar .vcf',
    copyLink: 'Copiar link',
    copied: 'Link copiado!',
    digitalCard: 'Cartão digital',
    physicalCard: 'Cartão físico',
    cardStyle: 'Estilo do cartão',
    cardStyleSubtitle: 'Defina seu nome de exibição, escolha uma cor de fundo e adicione seu cartão a uma carteira.',
    displayName: 'Nome de exibição',
    backgroundColour: 'Cor de fundo',
    addAppleWallet: 'Adicionar à Apple Wallet',
    addGoogleWallet: 'Adicionar à Google Wallet',
    nameLabel: 'Nome',
    urlLabel: 'URL',
    walletScanTitle: 'Escaneie o código QR para salvar na sua carteira',
    walletScanSubtitle: 'Ele será salvo na carteira digital do seu celular.',
    walletUseLink: 'Ou use este link em vez disso',
    walletComingSoonTitle: 'Quase lá',
    walletComingSoon: 'Os passes de carteira chegarão em breve.',
    done: 'Concluído',
    physicalTitle: 'Solicitar um cartão físico',
    physicalSubtitle: 'Os cartões de visita NFC chegarão em breve.',
    leadCapture: 'Recolher contactos',
    leadCaptureSubtitle: 'Permita que quem recebe o seu cartão partilhe os seus dados de volta — diretamente para a sua Audiência.',
    leadCaptureToggle: 'Ativar «Partilhe os seus dados»',
    leadCaptureToggleHint: 'Mostra um formulário de contacto no seu cartão público.',
    leadTag: 'Etiquetar novos leads',
    leadTagSubtitle: 'Cada contacto recolhido é etiquetado com isto (ex.: nome de um evento ou campanha).',
    leadTagPlaceholder: 'ex.: Conferência 2026',
    renewLink: 'Renovar link',
    renewing: 'A renovar…',
    renewConfirm: 'Renovar o link do cartão? O seu código QR atual e os links partilhados deixarão de funcionar.',
    linkRenewed: 'Link do cartão renovado',
    scans: '{count} leituras',
  },
  shortLinks: {
    title: 'Encurtador de Links',
    addLink: 'Adicionar link',
    name: 'Nome',
    slug: 'Slug',
    slugTooltip: 'Você pode alterar o Slug clicando no botão de edição',
    destinationUrl: 'URL de Destino',
    metadata: 'Metadados',
    utmTags: 'Tags UTM',
    customizeMetadata: 'Personalize os metadados do link',
    metaTitle: 'Título',
    metaDescription: 'Descrição',
    favicon: 'Favicon',
    imagePreview: 'Pré-visualização da imagem',
    addUtm: 'Adicionar tags UTM ao link (opcional)',
    utmCampaign: 'UTM Campaign',
    utmMedium: 'UTM Medium',
    utmSource: 'UTM Source',
    utmTerm: 'UTM Term',
    utmContent: 'UTM Content',
    utmId: 'UTM Id',
    utmPlacement: 'UTM Placement',
    utmCreative: 'UTM Creative',
    pasteLink: 'Cole seu link longo aqui',
    shorten: 'Encurtar link',
    shortenGreeting: 'What are we shortening',
    shortenGreetingPlain: 'What are we shortening?',
    pasteLinkMulti: 'Paste a long link — or several, one per line',
    customSlug: 'Custom slug',
    customSlugPlaceholder: 'my-link',
    qrCode: 'QR code',
    qrDesign: {
      title: 'QR code for',
      close: 'Close',
      subtitle: 'Customize the look and download it — the link stays the same',
      codeColor: 'Code color',
      background: 'Background',
      transparent: 'Transparent',
      logo: 'Logo in the middle',
      logoSize: 'Logo size',
      none: 'None',
      avatar: 'Avatar',
      upload: 'Upload',
      quietZone: 'Quiet zone',
      quietZoneHint: 'the frame a scanner looks for',
      small: 'Small',
      normal: 'Normal',
      format: 'Format',
      size: 'Size',
      reset: 'Reset',
      copyImage: 'Copy image',
      copied: 'Copied',
      download: 'Download',
      preparing: 'Preparing…',
      contrastOk: 'Contrast is good enough to scan',
      contrastLow: 'Contrast is too low — phones may fail to scan',
      avatarFailed: 'Could not load your profile picture — upload an image instead',
      fileFailed: 'Could not read that image',
      downloadFailed: 'Could not prepare the file',
      copyFailed: 'Your browser did not allow copying the image',
    },
    edit: 'Editar detalhes do item',
    status: 'Estado',
    expires: 'Validade',
    noExpiry: 'sem limite',
    tags: 'Tags',
    noSocialPreview: 'Sem pré-visualização social definida',
    addImage: 'Adicionar imagem',
    regenerate: 'Gerar outro',
    all: 'Todos',
    addTag: 'tag',
    newTagPlaceholder: 'Nova tag e Enter',
    frequent: 'Frequentes',
    duplicateTitle: 'Já tens um link curto para este URL',
    duplicateCreate: 'Criar outro',
  },
  audience: {
    title: 'Público',
    total: 'Total',
    totalMembers: 'Total de Membros do Público',
    totalContacts: 'Total de Contatos',
    forms: 'Formulários',
    subscribers: 'Assinantes',
    customers: 'Clientes',
    noAudienceMembers: 'Sem Contatos',
    emptyAudienceMembers: 'Adicione novos contatos clicando no botão',
    addAudienceMember: 'Adicionar Contato',
    noSubscribers: 'Sem Assinantes',
    emptySubscribers: 'Adicione novos assinantes adicionando blocos ao seu Link na Bio',
    addDataCollect: 'Adicionar bloco de Coleta de Dados',
    noResponses: 'Sem Respostas',
    emptyResponses: 'Adicione novas respostas adicionando blocos ao seu Link na Bio',
    addFormBlock: 'Adicionar bloco de Formulário',
    noCustomers: 'Sem Clientes',
    emptyCustomers: 'Adicione novos clientes adicionando produtos ao seu Link na Bio',
    addProduct: 'Adicionar Produto',
    addContactModal: {
      title: 'Adicionar novo contato',
      name: 'Nome',
      nameTooltip: 'Insira o nome do seu contato',
      email: 'E-mail',
      emailTooltip: 'Insira o endereço de e-mail do seu contato',
      phone: 'Telefone',
      phoneTooltip: 'Insira o número de telefone do seu contato',
      telegram: 'Telegram',
      telegramTooltip: 'Insira o nome de usuário ou URL do Telegram do seu contato',
      whatsapp: 'WhatsApp',
      whatsappTooltip: 'Insira o número de WhatsApp do seu contato',
      instagram: 'Instagram',
      instagramTooltip: 'Insira o nome de usuário ou URL do Instagram do seu contato',
      messenger: 'Messenger',
      messengerTooltip: 'Insira o nome de usuário ou URL do Messenger do seu contato',
      viber: 'Viber',
      viberTooltip: 'Insira o número de Viber do seu contato',
      address: 'Endereço',
      addressTooltip: 'Insira o endereço do seu contato',
      add: 'Adicionar',
    },
    search: {
      search: 'Buscar',
      error: 'Caractere inválido inserido no campo de busca',
      notFound: 'Nenhum resultado encontrado',
    },
  },
  auth: {
    logIn: 'Entrar',
    logInWith: 'Entrar com',
    signIn: 'Fazer login',
    signInWith: 'Cadastrar com',
    email: 'E-mail',
    password: 'Senha',
    notHaveAccount: 'Não tem uma conta?',
    createAccount: 'Criar uma nova Conta',
    createYourAccount: 'Crie sua Conta',
    signUp: 'Cadastrar',
    haveAccount: 'Se você já tem uma conta',
    or: 'ou',
    reset: 'Redefinir',
    resetPassword: 'Redefinir senha',
    resetTitle: 'O link de recuperação foi enviado para seu e-mail',
    goToHome: 'Ir para a Página Inicial',
    byClicking: 'Ao clicar em',
    youAreAgree: 'você concorda com os',
    terms: 'Termos de Serviço',
    andConfirm: 'e nossa',
    usagePolicy: 'Política de Uso',
    signInGoogle: 'Entrar com Google',
    forgotPassword: 'Esqueceu a senha?',
  },
  menu: {
    moreApps: 'Mais aplicativos',
    account: 'Conta',
    more: 'Mais',
    storyWidget: 'Embed Stories',
    integrations: 'Integrações',
    socialAccounts: 'Contas sociais',
    aiContent: 'Conteúdo IA',
    aiPosts: 'Posts com IA',
    postIdeas: 'Ideias de Posts',
    contentPlanner: 'Planejador de Conteúdo',
    aiImages: 'Imagens com IA',
    aiVideo: 'Vídeo com IA',
    planner: 'Planejador',
    customers: 'Clientes',
    subscribers: 'Assinantes',
    forms: 'Formulários',
    allAudience: 'Todo o público',
    payments: 'Pagamentos',
    orders: 'Pedidos',
    products: 'Produtos',
    events: 'Eventos',
    appointments: 'Agendamentos',
    discounts: 'Descontos',
    affiliates: 'Afiliados',
    instantPages: 'Páginas Instantâneas',
    openInNewTab: 'Abrir em nova aba',
    linkInBio: 'Link na Bio',
    linkInBioApps: 'Link na Bio',
    website: 'Site',
    store: 'Loja',
    audience: 'Público',
    emailMarketing: 'Email Marketing',
    postPlaner: 'Planejador de Posts',
    posts: 'Publicações',
    agents: 'Agentes',
    community: 'Comunidade',
    profileHealth: 'Saúde do Perfil',
    socialPlanner: 'Planejador Social',
    shortLinks: 'Encurtador de Links',
    businessCards: 'Cartões de visita',
    views: 'Visualizações',
    clicks: 'Cliques',
    allWebsites: 'Todos os Sites',
    createNewAccount: 'Criar nova conta',
    createNewWebsite: 'Criar um novo perfil',
    tools: 'Ferramentas',
    borderGenerator: 'Gerador de Bordas',
    yourPlan: 'Seu plano:',
    upgrade: 'Atualizar',
    accountSettings: 'Configurações da conta',
    manageWebsites: 'Gerenciar perfis',
    updates: 'Atualizações',
    autoUpdate: 'Atualização automática',
    logOut: 'Sair',
    myPages: 'Minhas Páginas',
    design: 'Design',
    heading: 'Título',
    analytics: 'Análises',
    settings: 'Configurações',
    open: 'Abrir',
    language: 'Idioma',
    siteLanguage: 'Idioma do site público',
    dashboardLanguage: 'Idioma do painel',
    movePage: 'Mover Página',
    editBlock: 'Editar Bloco',
    renameBlock: 'Renomear Bloco',
    rename: 'Renomear',
    deleteBlock: 'Excluir Bloco',
    archiveBlock: 'Arquivar Bloco',
    archive: 'Arquivar',
    scheduleBlock: 'Agendar Bloco',
    copyBlock: 'Copiar Bloco',
    dublicateBlock: 'Duplicar Bloco',
    content: 'Conteúdo',
    preview: 'Pré-visualizar',
    copy: 'Copiar',
    moveBlock: 'Mover Bloco',
    move: 'Mover',
    edit: 'Editar',
    delete: 'Excluir',
    schedule: 'Agendar',
    dublicate: 'Duplicar',
    smartReply: 'Instagram Reply',
    marketing: 'Marketing',
    selectBlocks: 'Selecionar blocos',
    selectAll: 'Selecionar tudo',
    cancelSelection: 'Cancelar',
    blocksSelected: 'selecionados',
    moveToPage: 'Mover para página',
    newPage: 'Nova página',
    openPage: 'Abrir página',
    pageSettings: 'Configurações da página',
    deletePage: 'Excluir página',
    appInBio: 'App na Bio',
    blog: 'Blog',
    publish: 'Publicar',
    creatorHub: 'Hub do Criador',
    qrCodes: 'Códigos QR',
    apps: 'Apps',
    automations: 'Automações',
    messages: 'Caixa de Entrada',
    form: 'Formulários',
    embedTools: 'Embed Tools',
    adBuilder: 'Criador de anúncios',
    emailSignatures: 'Assinaturas de e-mail',
    virtualBackgrounds: 'Fundos virtuais',
    adsCampaigns: 'Gerenciador de anúncios',
    thumbnail: 'Miniatura',
    buildFromReference: 'Criar a partir de uma referência',
  },
  modal: {
    addInstagram: 'Adicionar Instagram',
    addYourInstagram: 'Adicione sua conta do Instagram',
    cropYourAvatar: 'Recortar seu avatar',
    removeSite: 'Tem certeza de que deseja remover o site?',
    areYouSure: 'Tem certeza de que deseja',
    areYouSureDelete: 'Tem certeza de que deseja excluir esta seção?',
    areYouSureArchive: 'Tem certeza de que deseja arquivar este bloco?',
    areYouSurePermanentDelete: 'Tem certeza de que deseja excluir permanentemente este bloco? Esta ação não pode ser desfeita.',
    remove: 'remover',
    site: 'site',
    removeAccountText: 'remover sua conta',
    moveBlock: 'Mover bloco para outra página',
    moveBlockText: 'Isso moverá o bloco para o final de outra página. Você pode então reorganizar o bloco na nova página',
    profileTitle: 'Alterar foto do perfil',
    profileText: 'Escolha uma imagem ou GIF do seu dispositivo.',
    profileAvatar: 'Avatar do Perfil',
    addProfilePicture: 'Adicionar Foto do Perfil',
    storiesTitle: 'Stories',
    storiesText: 'Compartilhe seus momentos do dia a dia.',
    thoughtsTitle: 'Pensamentos',
    thoughtsText: 'Compartilhe seus pensamentos.',
    accountPageDescription: 'Esta é a página da sua conta, onde você pode personalizar a aparência da sua página, adicionar diferentes blocos de recursos e muito mais.',
  },
  modalSubscribe: {
    plan: 'Plano',
    usdMonth: 'USD/mês',
    sites: 'Sites',
    sitesMuch: 'Sites',
    notification: 'Notificações',
    noNotification: 'Sem notificações ainda',
    inCategory: 'Não há itens na categoria',
    categoryYet: 'ainda.',
    externalPixels: 'Pixels Externos',
    parameters: 'parâmetros',
    analyticsReports: 'Análises e Relatórios',
    noUniLinkLogo: 'Sem Logo UniLink',
    inProfile: 'no perfil',
    verifiedBadge: 'Selo verificado',
    your: 'Seu',
    customDomain: 'domínio personalizado',
    emailMarketing: 'Email Marketing',
    liveSupport: 'Suporte ao Vivo',
    dataSecured: 'Os dados são protegidos em conformidade com o padrão PCI DSS',
    thankYou: 'Obrigado pelo seu interesse. Entraremos em contato em breve.',
    socialMediaScheduler: 'Agendador de Redes Sociais',
    featureRequest: 'Solicitação de recurso',
    markAllRead: 'Marcar tudo como lido',
    currentPlan: 'Plano Atual',
    features: 'Recursos',
  },
  buttons: {
    upgrade: 'Atualizar Plano',
    buyProPlan: 'Comprar Plano Pro',
    continue: 'Continuar',
    skip: 'Pular',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    back: 'Voltar',
    save: 'Salvar',
    add: 'Adicionar',
    added: 'Adicionado',
    done: 'Concluído',
    ok: 'OK',
    edit: 'Editar',
    delete: 'Excluir',
    remove: 'Remover',
    setAsDefault: 'Definir como padrão',
    subscribeNow: 'Assinar Agora',
    yes: 'Sim',
    preview: 'Pré-visualizar',
    generate: 'Gerar',
    changePassword: 'Alterar senha',
    deleteAccount: 'Excluir conta',
    removeAccount: 'Remover conta',
    deleteProfile: 'Excluir perfil',
    addBlock: 'Adicionar bloco',
    copyLink: 'Copiar link',
    active: 'Ativo',
    update: 'Atualizar',
    updatePro: 'Atualizar Plano',
    prev: 'Anterior',
    next: 'Próximo',
    uploadImage: 'Enviar imagem',
    uploadVideo: 'Enviar vídeo',
    loadMore: 'Carregar mais',
    uploadProductImage: 'Enviar imagem do produto',
    claim: 'Reivindicar',
    removeSite: 'Remover site',
    move: 'Mover',
    addButton: 'Adicionar botão',
    actionButton: 'Botão de ação',
    directMessage: 'Mensagem direta',
    subscribe: 'Assinar',
    button: 'Botão',
    generateWithAI: 'Gerar com IA',
    cta: 'CTA',
    cart: 'Carrinho',
    direct: 'Direto',
    follow: 'Seguir',
    addNewItem: 'Adicionar novo item',
  },
  support: {
    liveSupport: 'Suporte ao Vivo',
    response: 'Geralmente respondemos em 1 minuto durante o horário de trabalho (8h - 22h) GMT+3',
    founder: 'Denys Bilozor',
    ceo: 'Fundador e CEO da UniLink',
  },
  wizard: {
    createNewProfile: 'Criar um novo perfil',
    createProfile: 'Criar Perfil',
    continue: 'Continuar',
    tellUs: 'Conte-nos sobre você',
    addSocialLinks: 'Adicione todas as redes sociais e as mostraremos no seu banco de dados',
    addMoreLinks: 'Adicionar Mais Links',
    addLink: 'Adicionar Link',
    selectCategory: 'Selecione a categoria que melhor descreve você:',
    chooseTemplate: 'Escolha um modelo',
    skip: 'Pular',
    step: 'Passo',
    of: 'de',
    yourName: 'Seu Nome',
    search: 'Buscar',
    blog: 'Blog',
    creator: 'Criador',
    music: 'Música',
    events: 'Eventos',
    esoteric: 'Esotérico',
    fashion: 'Moda',
    influencer: 'Influenciador',
    food: 'Alimentação',
    smallBusiness: 'Pequeno Negócio',
    marketing: 'Marketing',
    education: 'Educação',
    socialMedia: 'Redes Sociais',
    coaching: 'Coaching',
    ecommerce: 'E-commerce',
    healthAndFitness: 'Saúde e Fitness',
    beautyWellness: 'Beleza e Bem-estar',
  },
  billing: {
    back: 'Voltar',
    findPlan: 'Encontre o plano ideal para você',
    changeAnytime: 'Você pode alterar a qualquer momento.',
    subtitle: 'Faça upgrade, downgrade ou cancele quando quiser.',
    currentPlan: 'Plano atual',
    mostPopular: 'Mais popular',
    upgradeTo: 'Fazer upgrade para {plan}',
    includes: 'Inclui:',
    everythingIn: 'Tudo o que está em {plan}, mais:',
    secure: 'Os pagamentos são protegidos em conformidade com a norma PCI DSS.',
  },
  field: {
    fullName: 'Nome Completo',
    username: 'nome de usuário',
    addValue: 'Adicionar valor',
    newValue: 'Novo valor',
    placeholderDefault: 'Texto, números, símbolos etc.',
    addInstagramUsername: 'Adicionar nome de usuário do Instagram',
    nameDefault: 'João',
    enterYourLink: 'Insira seu link',
    searchImage: 'Buscar imagem',
    pasteLink: 'Colar link',
    pasteLinkTip: 'Adicione um link para qualquer página da web',
    searchGIFs: 'Buscar GIFs',
    searchIcons: 'Buscar ícones',
    searchVideo: 'Buscar vídeo',
    search: 'Buscar',
    insertURL: 'Inserir URL',
    writeYourDescription: 'Escreva sua descrição',
    headerCTAbutton: 'Cabeçalho, botão CTA',
    enterTitle: 'Inserir título',
    enterDescription: 'Inserir descrição',
    enterURL: 'Inserir URL canônica',
  },
  tooltip: {
    addImage: 'Adicionar imagem',
    labelModalTitle: 'Configurações do rótulo',
    addLabel: '+ Adicionar rótulo',
    label: 'Rótulo',
    labelCaption: 'Inserir rótulo',
    labelText: 'Texto do rótulo',
    labelTextCaption: 'Inserir texto do rótulo',
    labelTextPlaceholder: 'Rótulo',
    labelUrl: 'URL do rótulo',
    labelUrlCaption: 'Inserir URL do rótulo',
    labelUrlPlaceholder: 'https://exemplo.com',
    noLabel: 'Sem rótulo',
    colorFrom: 'Cor de',
    colorTo: 'Cor para',
    highlight: 'Destaque',
    firstName: 'Nome',
    firstNameCaption: 'Insira seu nome',
    lastName: 'Sobrenome',
    lastNameCaption: 'Insira seu sobrenome',
    jobTitle: 'Cargo',
    jobTitleCaption: 'Insira seu cargo',
    organization: 'Organização',
    organizationCaption: 'Insira sua organização',
    email: 'E-mail',
    emailCaption: 'Insira seu e-mail',
    workPhone: 'Telefone comercial',
    workPhoneCaption: 'Insira seu telefone comercial',
    mobilePhone: 'Celular',
    mobilePhoneCaption: 'Insira seu celular',
    website: 'Site',
    websiteCaption: 'Insira seu site',
    information: 'Informação',
    informationCaption: 'Insira suas informações',
    streetAddress: 'Endereço',
    streetAddressCaption: 'Insira seu endereço',
    city: 'Cidade',
    cityCaption: 'Insira sua cidade',
    state: 'Estado',
    stateCaption: 'Insira seu estado',
    postalCode: 'CEP',
    postalCodeCaption: 'Insira seu CEP',
    country: 'País',
    countryCaption: 'Insira seu país',
    titleColor: 'Cor do título',
    titleColorCaption: 'Você pode alterar a cor do título',
    fontFamily: 'Família da fonte',
    fontFamilyCaption: 'Você pode alterar a família da fonte',
    fontSize: 'Tamanho da fonte',
    fontSizeLabel: 'Tamanho da fonte do rótulo',
    fontSizeCaption: 'Você pode alterar o tamanho da fonte',
    fontSelect: 'Fonte',
    fontSelectCaption: 'Escolha uma fonte',
    imageMargin: 'Margem da imagem',
    profilePicture: 'Foto do perfil',
    profilePictureCaption: 'Altere sua foto do perfil',
    pictureSize: 'Tamanho da foto',
    pictureSizeCaption: 'Você pode alterar o tamanho da foto',
    title: 'Título',
    titleCaption: 'Insira um título',
    blockCaption: 'Insira um título para seu bloco',
    titlePageCaption: 'Insira um título para sua página',
    templates: 'Modelos',
    templatesCaption: 'Escolha um modelo para sua página',
    background: 'Fundo',
    backgroundColor: 'Cor de fundo',
    textBackground: 'Fundo do Texto',
    textBackgroundCaption: 'Escolha a cor de fundo do texto',
    textColor: 'Cor do Texto',
    textColorCaption: 'Escolha a cor do texto',
    gradientBackground: 'Fundo Gradiente',
    gradientColor: 'Cor do Gradiente',
    BackgroundType: 'Tipo',
    backgroundSource: 'Origem do fundo',
    backgroundSourceCaption: 'Escolha a origem do fundo',
    backgroundStyle: 'Estilo do fundo',
    backgroundStyleCaption: 'Escolha o estilo do fundo',
    backgroundStylesNormal: 'Normal',
    backgroundStylesGlass: 'Vidro',
    backgroundStylesOutline: 'Contorno',
    backgroundTypeCaption: 'Escolha o tipo de fundo',
    color: 'Cor',
    colorTooltip: 'Você pode alterar a cor',
    backgroundOpacityTooltip: 'Arraste o controle para definir a opacidade do fundo',
    backgroundBlur: 'Desfoque do fundo',
    backgroundBlurCaption: 'Arraste o controle para desfocar o fundo',
    backgroundBrightness: 'Brilho do fundo',
    backgroundBrightnessCaption: 'Arraste o controle para alterar o brilho do fundo',
    backgroundContrast: 'Contraste do fundo',
    backgroundContrastCaption: 'Arraste o controle para alterar o contraste do fundo',
    color1: 'Cor 1',
    color2: 'Cor 2',
    colorCaption: 'Insira a cor da sua página',
    gradient: 'Gradiente',
    image: 'Imagem',
    photo: 'Foto',
    gif: 'GIF',
    animation: 'Animação',
    video: 'Vídeo',
    hexColor: 'Cor hexadecimal',
    direction: 'Direção',
    gradientDirection: 'Direção do gradiente',
    directionCaption: 'Arraste o controle para definir a direção do gradiente',
    offset: 'Deslocamento',
    gradientOffset: 'Deslocamento do gradiente',
    offsetCaption: 'Arraste o controle para definir o deslocamento do gradiente',
    backgroundDarkness: 'Escurecimento do fundo',
    backgroundDarknessCaption: 'Arraste o controle para escurecer a imagem de fundo',
    uploadVideo: 'Enviar vídeo',
    uploadFile: 'Enviar arquivo',
    uploadVideoCaption: 'Vídeo do fundo da sua página',
    linkToVideo: 'Link para vídeo',
    linkToVideoCaption: 'Adicionar link para vídeo',
    videoWithSound: 'Vídeo com som',
    videoWithSoundCaption: 'Reproduzir vídeo com som',
    fonts: 'Fontes',
    fontWeight: 'Peso da fonte',
    fontWeightCaption: 'Clique para escolher seu destino',
    preloader: 'Pré-carregamento',
    preview: 'Pré-visualizar',
    hideLogo: 'Ocultar logo UniLink',
    cover: 'Capa',
    coverCaption: 'Alterar capa',
    coverCaptionHeader: 'Adicionar imagem ou vídeo à capa do cabeçalho',
    pageNavigation: 'Navegação da página',
    websiteNavigation: 'Navegação por abas',
    backgroundOpacity: 'Opacidade do fundo',
    backgroundOpacityCaption: 'Arraste o controle para definir a opacidade do fundo do botão',
    borderRadius: 'Raio da borda',
    borderRadiusCaption: 'Arraste o controle para definir o raio da borda',
    heightTabs: 'Altura das abas',
    heightTabsCaption: 'Arraste o controle para definir a altura das abas',
    backgroundShadow: 'Sombra do fundo',
    backgroundShape: 'Forma do fundo',
    backgroundBorder: 'Borda do fundo',
    opacity: 'Opacidade',
    opacityCaption: 'Arraste o controle para definir a opacidade',
    shape: 'Forma',
    shapeCaption: 'Definir forma',
    text: 'Texto',
    textCaption: 'Inserir texto',
    textSize: 'Tamanho do texto',
    textSizeCaption: 'Arraste o controle para definir o tamanho do texto',
    additionalText: 'Texto adicional',
    username: 'Nome de usuário',
    currency: 'Moeda',
    language: 'Idioma',
    timeZone: 'Fuso horário',
    websiteNiche: 'Nicho do site',
    websiteNicheCaption: 'Insira o nicho do seu site',
    renameCaption: 'Renomear título do bloco',
    description: 'Descrição',
    descriptionCaption: 'Insira uma descrição',
    actionButton: 'Botão de ação',
    actionButtonCaption: 'O botão de chamada para ação motiva os visitantes a agir',
    animationDirection: 'Direção da animação',
    animationDirectionCaption: 'Escolha a direção da animação',
    buttonTitle: 'Título do botão',
    buttonTitleCaption: 'Insira o título do botão',
    buttonUrl: 'URL do botão',
    buttonUrlCaption: 'A URL abrirá em uma nova janela',
    imageSize: 'Tamanho da imagem',
    imageSizeCaption: 'Arraste o controle para definir o tamanho da imagem',
    view: 'Visualização',
    viewCaption: 'Escolha uma visualização',
    margin: 'Margem',
    marginCaption: 'Arraste o controle para adicionar margem no topo e na parte inferior do item',
    separateTopBottom: 'Topo / Inferior',
    padding: 'Espaçamento',
    paddingCaption: 'Arraste o controle para adicionar espaçamento no topo e na parte inferior do item',
    fullWidth: 'Largura total',
    lineHeight: 'Altura da linha',
    lineHeightCaption: 'Você pode alterar a altura da linha',
    button: 'Botão',
    titleSize: 'Tamanho do título',
    titleSizeCaption: 'Você pode alterar o tamanho do título',
    titleLineHeight: 'Altura da linha do título',
    titleLineHeightCaption: 'Personalize a altura da linha do título para trazer mais soluções de design ao texto',
    layout: 'Layout',
    layoutCaption: 'Crie o layout de cabeçalho que desejar',
    layoutAlign: 'Alinhamento do layout',
    alignText: 'Alinhar texto',
    align: 'Alinhar',
    alignCaption: 'Escolha o alinhamento',
    position: 'Posição',
    positionCaption: 'Escolha a posição',
    width: 'Largura',
    widthCaption: 'Escolha a largura do seu banner',
    nameHeader: 'Nome',
    nameCaption: 'Insira o nome da sua conta',
    shortBio: 'Bio curta',
    shortBioCaption: 'Insira a bio curta da sua conta',
    externalLink: 'Link externo',
    externalLinkCaption: 'Insira o link externo da sua conta',
    location: 'Localização',
    locationCaption: 'Insira sua localização',
    locationMap: 'Mapa de localização',
    locationMapCaption: 'Insira a URL da sua localização',
    rightIcon: 'Ícone direito',
    rightIconCaption: 'Este ícone aparecerá no lado direito do botão',
    buttons: 'Botões',
    buttonsCaption: 'Adicionar botões de ação',
    nameLogo: 'Logo com nome',
    nameLogoCaption: 'Envie um logo para seu nome',
    buttonText: 'Texto do botão',
    buttonTextCaption: 'Insira o nome do seu botão',
    buttonColor: 'Cor do botão',
    buttonColorCaption: 'Escolha as cores para o botão',
    buttonColorCTACaption: 'Escolha a cor de fundo para o botão CTA',
    cartColor: 'Cor do carrinho',
    cartColorCaption: 'Escolha a cor de fundo para o carrinho',
    ctaButton: 'Botão CTA',
    ctaButtonCaption: 'Este ícone aparecerá no lado direito do botão',
    style: 'Estilo',
    socialIconsStyleCaption: 'Você pode escolher o estilo dos seus ícones sociais',
    socialIconsShape: 'Forma dos ícones sociais',
    socialIconsShapeCaption: 'Você pode escolher a forma dos ícones sociais',
    headerTextColorCaption: 'Você pode escolher a cor do texto do cabeçalho',
    pictureShape: 'Forma da foto',
    pictureShapeCaption: 'Você pode escolher a forma da foto do perfil',
    socialLinks: 'Links sociais',
    socialLinksCaption: 'Adicione botões de links sociais para conexão rápida entre você e seus clientes em um clique',
    URL: 'URL',
    URLCaption: 'Insira o endereço URL',
    heading: 'Título',
    headingTitle: 'Título do cabeçalho',
    headingTitleCaption: 'Insira o título do cabeçalho',
    headingDescription: 'Descrição do cabeçalho',
    headingDescriptionCaption: 'Insira a descrição do cabeçalho',
    headingImage: 'Imagem do cabeçalho',
    headingImageCaption: 'Envie uma imagem para o cabeçalho',
    headingPosition: 'Posição do cabeçalho',
    headingInsideBlock: 'Dentro do bloco',
    headingOutsideBlock: 'Fora do bloco',
    headingDivider: 'Divisor do cabeçalho',
    canonicalURL: 'URL Canônica',
    seo: 'SEO',
    seoCaption: 'Personalize seu produto com tags meta SEO',
    themes: 'Temas',
    brandColors: 'Brand Kit',
    applyBrandColors: 'Aplicar ao perfil',
    syncBlocks: 'Sincronizar todos os blocos',
    brandColorsApplied: 'Cores da marca aplicadas',
    generatedPalette: 'Paleta gerada',
    applying: 'Aplicando...',
    syncing: 'Sincronizando...',
    backgroundType: 'Tipo de fundo',
    palettes: 'Paletas',
    previewTitle: 'Título',
    previewTitleCaption: 'Digite o título da pré-visualização',
    previewDescription: 'Descrição',
    previewDescriptionCaption: 'Digite a descrição da pré-visualização',
    previewButton: 'Texto do botão',
    previewButtonCaption: 'Digite o texto do botão da pré-visualização',
    previewLabel: 'Texto do rótulo',
    previewLabelCaption: 'Digite o texto do rótulo da pré-visualização',
    previewThumbnail: 'Miniatura',
    previewThumbnailCaption: 'Envie a miniatura da pré-visualização',
    myTemplates: 'Os meus modelos',
    myTemplatesEmpty: 'Ainda não há modelos. Guarda o design da página atual para o reutilizares mais tarde.',
    saveAsTemplate: 'Guardar como modelo',
    saveCurrentAsTemplate: 'Guardar o atual como modelo',
    templateSaved: 'Modelo guardado',
    templateApplied: 'Modelo aplicado',
    buildFromReference: 'Criar a partir de referência',
    templateAppliedCount: 'Modelo aplicado — {n} blocos adicionados',
    searchTemplates: 'Procurar modelos…',
    favorites: 'Favoritos',
    previewLive: 'Pré-visualizar ao vivo',
    previewingTemplate: 'A pré-visualizar',
    exitPreview: 'Sair',
    templateKind: 'O que incluir',
    publish: 'Publicar',
    unpublish: 'Anular publicação',
    templatePublished: 'Modelo publicado',
    templateUnpublished: 'Publicação do modelo anulada',
    discoverTemplates: 'Descobrir a comunidade',
    discoverSubtitle: 'Modelos gratuitos publicados por outros criadores na UniLink.',
    discoverEmpty: 'Ainda não há modelos públicos — sê o primeiro a publicar um.',
    pricing: 'Preços',
    fontRoles: {
      heading: 'Título',
      subtitle: 'Subtítulo',
      body: 'Global',
    },
  },
  table: {
    clicks: 'Cliques',
    signups: 'Cadastros',
    views: 'Impressões',
    orderNumber: 'Número do pedido',
    amount: 'Valor',
    credits: 'Créditos',
    invoice: 'Fatura',
    email: 'E-mail',
    card: 'Cartão',
    currency: 'Moeda',
    name: 'Nome',
    contact: 'Contato',
    optIn: 'Opt-in',
    notes: 'Notas',
    address: 'Endereço',
    date: 'Data',
    action: 'Ação',
    custom: 'Personalizado',
    status: 'Status',
    tags: 'Tags',
    view: 'Visualizar',
    remove: 'Remover',
    sendEmail: 'Enviar E-mail',
    details: 'Detalhes',
    purchases: 'Compras',
    order: 'Pedido',
    money: 'Dinheiro',
    type: 'Tipo',
    orderCode: 'Código do pedido',
  },
  settings: {
    title: 'Configurações',
    settings: 'configurações',
    accountSettings: 'Configurações da conta',
    email: 'E-mail',
    subscription: 'Assinatura',
    billingHistory: 'Histórico de cobrança',
    dueTo: 'Vencimento em',
    subscriptionDueTo: 'Assinatura vence em',
    cancelSubscription: 'Cancelar assinatura',
    cancelSubscriptionConfirm: 'Tem certeza de que deseja cancelar sua assinatura?',
    subscriptionCancelled: 'Sua assinatura foi cancelada. Seu plano permanece ativo até o final do período de cobrança.',
    subscriptionCancelError: 'Falha ao cancelar assinatura. Entre em contato com o suporte.',
    deleteFirst: 'Excluir permanentemente sua',
    deleteSecond: 'e todos os seus dados. Esta ação não pode ser desfeita.',
    account: {
      title: 'Conta',
      usernameNotAvailable: 'Nome de usuário não disponível',
      setupCustomDomain: 'Configurar domínio personalizado',
      subtitle: 'E-mail da conta, cobrança, senha e chave de API',
    },
    profile: {
      title: 'Perfil',
      usernameNotAvailable: 'Nome de usuário não disponível',
      setupCustomDomain: 'Configurar domínio personalizado',
      subtitle: 'Gerenciar nome de usuário, idioma, moeda, fuso horário',
      category: 'Categoria',
      categoryCaption: 'Insira a categoria do seu perfil',
      usernameDesc: 'O teu identificador público',
      currencyDesc: 'Usada para ganhos e pagamentos',
      languageDesc: 'Idioma mostrado aos teus visitantes',
      timeZoneDesc: 'Para agendamento e análises',
      categoryDesc: 'O que melhor descreve o teu perfil',
      privateProfile: 'Perfil privado',
      privateProfileDesc: 'Apenas seguidores aprovados podem ver o teu perfil',
    },
    aiassistant: {
      title: 'Assistente IA',
      subtitle: 'Personalize seu assistente IA para respostas melhores e mais personalizadas',
      titleText: 'Ajude a IA a entender quem você é para respostas mais relevantes',
      customAiTitle: 'Instruções personalizadas',
      customAiPlaceholder: 'Adicione instruções específicas para a IA...',
      customAiDescription: 'Estas instruções serão aplicadas a todas as conversas com a IA',
      nicknameTitle: 'Como a IA deve chamar você?',
      nicknamePlaceholder: 'Apelido',
      titleBio: 'Bio/ Descrição',
      bioPlaceholder: 'Conte um pouco sobre você...',
      occupation: 'O que você faz?',
      occupationPlaceholder: 'ex. Estudante de Engenharia na Universidade de São Paulo',
      aboutYouTitle: 'Sobre Você',
      aboutYouTooltip: 'Conte ao seu assistente IA um pouco sobre você',
      locationTitle: 'Localização',
      locationPlaceholder: 'ex. São Paulo, Brasil',
      categoryTitle: 'Categoria',
    },
    notifications: {
      title: 'Notificações',
      subtitle: 'Configure notificações sobre novos e-mails de visitantes e pedidos',
      text: 'Conecte mensageiros para receber notificações sobre novos e-mails e pedidos de clientes',
      setUpWebhooks: 'Configure webhooks na seção Webhooks',
      save: 'Salvar',
      connect: 'CONECTAR',
      disconnect: 'DESCONECTAR',
      webhook: 'Webhook',
      emailSubmit: 'Envio de coleta de dados',
      formSubmit: 'Envio de formulário',
      showSubmit: 'Envio da loja',
      digitalSubmit: 'Envio digital',
      appointmentSubmit: 'Envio de agendamento',
      requestSubmit: 'Envio de serviço',
      donationSubmit: 'Envio de doação',
      email: 'E-mail',
      settings: 'configurações',
      cartSubmit: 'Envio do carrinho',
      linkClick: 'Clique no link',
      contactClick: 'Clique no contato',
      all: 'Todos',
      updates: 'Atualizações',
      messages: 'Mensagens',
      opportunities: 'Oportunidades',
      insights: 'Insights',
      activity: 'Atividade',
      system: 'Sistema',
      news: 'Notícias',
      more: 'Mostrar mais',
      less: 'Mostrar menos',
      connectedAccounts: 'Contas conectadas',
      addEmailAccount: 'Adicionar conta de e-mail',
    },
    paymentSystem: {
      title: 'Sistema de pagamento',
      subtitle: 'Configure pagamentos via Stripe ou PayPal',
      text: 'Ver taxas de processamento',
      connected: 'Conectado',
      active: 'Aceitar pagamentos no site',
      pending: 'Pendente',
      disconnect: 'Desconectar',
      connect: 'Conectar',
      add: 'Adicionar',
      ofYourAccount: 'da sua conta',
      save: 'Salvar',
    },
    shop: {
      title: 'Loja',
      subtitle: 'Configuração de categorias e propriedades',
      label: {
        title: 'Rótulos',
        subtitle: 'Adicionar rótulos aos cartões de produtos',
        addValue: 'Adicionar valor',
        save: 'Salvar',
        value: 'Valor',
        enterTitle: 'Inserir título',
        maximum: 'O número máximo de valores pode ser 5',
        add: 'Adicionar',
        edit: 'Editar',
        labels: 'Rótulos',
      },
      category: {
        title: 'Categorias',
        subtitle: 'Adicionar categoria aos seus produtos',
        addCategory: 'Adicionar categoria',
        save: 'Salvar',
        maximum: 'O número máximo pode ser',
        editTitle: 'Categoria',
        name: 'Nome',
        namePlaceholder: 'Introduz a categoria',
        visibility: 'Visibilidade',
        visible: 'Visível',
        hidden: 'Oculta',
        description: 'Descrição',
        descriptionHint: 'A descrição deve ter menos de 100 caracteres',
        descriptionPlaceholder: 'Adiciona uma breve descrição',
        cover: 'Capa',
        view: 'Ver',
        share: 'Partilhar',
        linkCopied: 'Link copiado',
        saveFirst: 'Guarda a categoria primeiro',
        moveOut: 'Mover para fora',
      },
      property: {
        title: 'Propriedade',
        subtitle: 'Adicionar propriedade aos seus produtos',
        addProperties: 'Adicionar propriedades',
        properties: 'Propriedades',
        type: 'Tipo',
        typeTooltip: 'Tipo das suas propriedades',
        titleModal: 'Título',
        titleModalTooltip: 'Nome das suas propriedades',
        enterTitle: 'Inserir o título',
        value: 'Valor',
        addValue: 'Adicionar valor',
        maximum: 'O número máximo de valores pode ser',
        save: 'Salvar',
        cancel: 'Cancelar',
        remove: 'Remover',
        addPropertyToItem: 'Adicionar propriedade ao item',
        add: 'Adicionar',
        edit: 'Editar',
        propertiesSmall: 'propriedades',
        required: 'Obrigatório',
        requiredTooltip: 'Definir propriedades obrigatórias para compra',
        selectAll: 'Selecionar tudo',
      },
      actionButtons: {
        contentTab: 'Conteúdo',
        designTab: 'Design',
        buttonTitle: 'Título do botão',
        buttonColor: 'Cor do botão',
        cancel: 'Cancelar',
        save: 'Guardar',
        maxChars: 'Máximo {count} caracteres',
        minChars: 'Mínimo {count} caracteres',
        enterTitle: 'Introduza um título para o botão',
        contactTooltip: 'Uma forma de os clientes o contactarem: e-mail, mensagem ou formulário',
        contactNotConfigured: 'Defina como os clientes o contactam',
        methodEmail: 'Carta por email',
        methodMessenger: 'Mensageiro',
        methodForm: 'Formulário de pedido',
        enterAddress: 'Introduza um endereço',
        invalidAddress: 'Endereço inválido',
        enterContact: 'Introduza um número ou nome de utilizador',
        summaryFields: '{count} campos',
        dragToReorder: 'Arraste para reordenar',
        fieldName: 'Nome do campo',
        fieldRequired: 'Obrigatório',
        deleteField: 'Eliminar campo',
        enterFieldName: 'Introduza o nome do campo',
        addAtLeastOneField: 'Adicione pelo menos um campo',
        maxFields: 'Máximo {count} campos',
        typeText: 'Texto',
        typeEmail: 'E-mail',
        typePhone: 'Telefone',
        preorderTooltip: 'Formulário de pré-encomenda para este produto',
        preorderRowHint: 'Campos que o comprador preenche — abra para editar',
        saveFailed: 'Não foi possível guardar. Tente novamente.',
        preorderNotConfigured: 'Configure o formulário de pré-encomenda',
        enableAtLeastOneField: 'Ative pelo menos um campo',
        enterSubmitTitle: 'Introduza o título do botão de envio',
        invalidUrl: 'Ligação inválida',
        redirectHelper: 'Se ficar vazio, o cliente permanece na página e vê o texto abaixo.',
        discardTitle: 'Fechar sem guardar?',
        discardText: 'As alterações às definições do botão serão perdidas.',
        discardContinue: 'Continuar a editar',
        discardClose: 'Fechar',
        contactModalTitle: 'Botão Contact',
        preorderModalTitle: 'Botão de pré-venda',
        contactModalSubtitle: 'Uma ação por botão. Para onde vai o resultado define-se a seguir',
        actionTab: 'Ação',
        methodFormDesc: 'O cliente preenche campos',
        methodChat: 'Chat ao vivo',
        methodChatDesc: 'Conversa em tempo real aqui mesmo',
        methodMessengerDesc: 'WhatsApp, Telegram, Viber…',
        methodEmailDesc: 'Abre o email do cliente',
        inboxDefaultNote: 'Por defeito tudo fica guardado no seu Unilink Inbox — pode alterar isto mais tarde.',
        readyToSave: 'Pronto a guardar',
        apply: 'Aplicar',
        back: 'Voltar',
        pickAction: 'Escolha o que o botão faz',
        buttonText: 'Texto do botão',
        buttonBackground: 'Fundo do botão',
        buttonTextColor: 'Cor do texto',
        lowContrastWarning: 'O texto mistura-se com o fundo — o cliente não vai conseguir ler o rótulo.',
        colorsSharedNote: 'As cores aplicam-se ao botão na página do produto.',
        chatNoSetup: 'Não há nada a configurar: o chat abre na página e a conversa vai para o seu Inbox.',
        yourEmail: 'O seu email',
        yourEmailHelper: 'No cliente abre o email com uma carta para este endereço.',
        channelAndContact: 'Canal e contacto',
        singleChannelNote: 'O botão abre a conversa na aplicação escolhida de imediato.',
        addContact: 'Adicionar contacto',
        deleteContact: 'Eliminar contacto',
        contactsCount: '{count} contactos',
        maxContacts: 'Máximo {count} contactos',
        duplicateContact: 'Esta aplicação já está na lista',
        multiChannelNote: 'O botão abre uma lista e o cliente escolhe a aplicação.',
        recapMessengers: 'O cliente escolhe: {apps}',
        whatToAsk: 'O que perguntar',
        fieldsOfMax: '{count} de {max} campos',
        fieldOptional: 'Opcional',
        typeLongText: 'Texto longo',
        duplicateField: 'Já existe um campo com este nome acima',
        addReplyableField: 'Adicione um email ou telefone — caso contrário não haverá como responder',
        presetName: 'Nome',
        presetEmail: 'Email',
        presetPhone: 'Telefone',
        presetComment: 'Comentário',
        presetOwnField: 'campo próprio',
        thanksText: 'Texto após o envio',
        thanksPlaceholder: 'Obrigado! Respondemos durante o dia.',
        recapForm: 'O pedido chega {targets}',
        recapChat: 'A conversa vai para o seu Unilink Inbox',
        recapMessenger: 'O cliente passa para {app}',
        recapEmail: 'No cliente abre o email com uma carta para {address}',
        recapEmailFallback: 'o seu endereço',
        recapTargetInbox: 'no seu Unilink Inbox',
        actionsLabel: 'Formas de contacto',
        actionsOfMax: '{count} de {max}',
        actionsCount: '{count} ações',
        addAction: 'Adicionar ação',
        addFirstAction: 'Adicione a primeira forma de contacto para os clientes',
        deleteAction: 'Eliminar ação',
        actionNeedsAttention: 'Falta completar',
        severalActionsNote: 'Cada ação é um botão próprio na página do produto, nesta ordem.',
        methodAlreadyAdded: 'Já está na lista',
        duplicateChannel: 'Este canal com este contacto já está na lista',
        duplicateTitle: 'Outro botão já usa este texto',
        defaultTitleForm: 'Contacte-nos',
        defaultTitleChat: 'Falar no chat',
        defaultTitleEmail: 'Enviar email',
        buyModalTitle: 'Botão Buy',
        buyModalSubtitle: 'Leva o comprador diretamente ao pagamento',
        buyTooltip: 'O botão leva o comprador diretamente ao pagamento',
        buyNoPrice: 'Apenas texto, sem preço',
        priceOnButton: 'Preço no botão',
        priceOnButtonHelper: 'Deixe vazio e o botão mostra apenas o texto',
        invalidPrice: 'O preço é apenas um número, p. ex. 990',
        redirectModalTitle: 'Botão Redirect',
        redirectModalSubtitle: 'Leva a qualquer página através de um link',
        redirectTooltip: 'O botão abre qualquer página através de um link',
        linkLabel: 'Ligação',
        linkPlaceholder: 'https://example.com/pagina',
        opensHost: 'Vai abrir: {host}',
        openInNewTab: 'Abrir num novo separador',
        enterLink: 'Indique a ligação que este botão abre',
        noLinkSet: 'Sem ligação',
        preorderModalSubtitle: 'Recolhe pré-encomendas antes do início das vendas — sem pagamento',
        shipEta: 'Quando envia',
        shipEtaPlaceholder: 'p. ex. até 15 de setembro',
        shipEtaHelper: 'Mostramos no formulário — o comprador vê o prazo e pergunta menos vezes',
        fieldsInForm: 'Campos no formulário: {count}',
        enableFieldFirst: 'Ative primeiro o campo',
        submitInForm: 'Texto do botão no formulário',
        afterSubmit: 'Depois de enviar',
        afterSubmitText: 'Mostrar um texto',
        afterSubmitUrl: 'Levar para uma página',
        afterSubmitTextHelper: 'O comprador fica na página e lê este texto',
        preorderThanksPlaceholder: 'Obrigado! Escrevemos quando o produto estiver pronto.',
        enterRedirectUrl: 'Indique o URL da página ou volte a mostrar um texto',
      },
      preorderForm: {
        title: 'Formulário de pré-venda',
        subtitle: 'Configurar campos do formulário de pré-venda',
        fields: 'Campos',
        fieldsTooltip: 'Adicionar campos ao formulário',
        required: 'Obrigatório',
        submitButton: 'Título do botão de envio',
        redirectUrl: 'URL de redirecionamento (opcional)',
        resultText: 'Texto do resultado',
        save: 'Salvar',
        name: 'Nome',
        emailAddress: 'Endereço de e-mail',
        phone: 'Telefone',
        address: 'Endereço',
        comment: 'Comentário',
      },
      shipping: {
        title: 'Formulário de finalização',
        subtitle: 'Campos que o comprador preenche ao fazer o pedido',
        fields: 'Campos',
        fieldsTooltip: 'Adicionar campos ao formulário de entrega',
        required: 'Obrigatório',
        save: 'Salvar',
        name: 'Nome',
        emailAddress: 'Endereço de e-mail',
        phone: 'Telefone',
        address: 'Endereço',
        comment: 'Comentário',
        askDetails: 'Pedir os dados do comprador',
        askDetailsHint: 'Desligado — a finalização aceita o pedido sem formulário',
        askDetailsPaymentWarning:
          'A finalização cobra online. Sem e-mail não há para onde enviar o recibo: deixe pelo menos E-mail ligado ou mude para «Receber o pedido, sem pagamento».',
        askDetailsRedirectNote: 'A finalização acontece noutro site — estes campos nunca são mostrados aos compradores.',
        askDetailsNoContactNote: 'O pedido chegará sem contactos. Deixe o Telefone ligado se pretende ligar ao comprador.',
        promoCode: 'Código promocional',
        addCustomField: 'Adicionar campo personalizado',
        addFormInfo: 'Adicionar informações do formulário',
        editFormInfo: 'Editar informações do formulário',
        type: 'Tipo',
        typeTooltip: 'Tipo de campo personalizado',
        fieldName: 'Nome do campo',
        fieldNameTooltip: 'Nome para campo personalizado',
        placeholder: 'Placeholder',
        placeholderTooltip: 'Placeholder para campo personalizado',
        delete: 'Excluir',
        update: 'Atualizar',
        add: 'Adicionar',
      },
      delivery: {
        title: 'Métodos de entrega',
        subtitle: 'Envio, entrega e retirada',
        loading: 'A carregar…',
        inactive: 'inativo',
        confirmDelete: 'Eliminar este método de entrega?',
        category: {
          shipping: 'Envio',
          localDelivery: 'Entrega local',
          selfPickup: 'Recolha própria',
        },
        rateType: {
          free: 'Grátis',
          conditionalFree: 'Grátis condicional',
          flatRate: 'Tarifa fixa',
          customRates: 'Tarifas personalizadas',
          carrierApi: 'API da transportadora',
        },
        carrier: {
          custom: 'Transportadora personalizada',
        },
        add: {
          shipping: 'Adicionar envio',
          localDelivery: 'Adicionar entrega local',
          selfPickup: 'Adicionar recolha própria',
        },
        actions: {
          edit: 'Editar',
          delete: 'Eliminar',
          save: 'Guardar',
          cancel: 'Cancelar',
        },
        fields: {
          name: 'Nome',
          namePh: 'ex.: Envio standard',
          description: 'Descrição',
          isActive: 'Ativo',
          estimatedDays: 'Dias estimados',
          currency: 'Moeda',
          countryCodes: 'Códigos de país (CSV)',
          carrier: 'Transportadora',
          rateType: 'Tipo de tarifa',
          flatPrice: 'Preço fixo',
          freeThreshold: 'Grátis acima de (subtotal)',
          fallbackPrice: 'Preço de recurso',
          customRates: 'Linhas de tarifa personalizada',
          senderCity: 'Nome da cidade do remetente',
          senderCityRef: 'Ref. da cidade do remetente',
          pickupInstructions: 'Instruções de recolha',
          pickupCharge: 'Custo de recolha',
          askPickupDateTime: 'Pedir data/hora de recolha na finalização',
        },
        rateRow: {
          subtotal: 'Por subtotal',
          weight: 'Por peso (g)',
          min: 'Mín.',
          max: 'Máx.',
          price: 'Preço',
          add: 'Adicionar linha',
        },
      },
      legal: {
        title: 'Documentos legais',
        subtitle: 'Termos, privacidade, devoluções',
        loading: 'A carregar…',
        empty: 'Ainda não há documentos legais.',
        inactive: 'inativo',
        required: 'obrigatório',
        confirmDelete: 'Eliminar este documento?',
        addNew: '+ Adicionar documento',
        types: {
          terms: 'Termos de serviço',
          privacy: 'Política de privacidade',
          returns: 'Política de devolução / reembolso',
          shipping: 'Política de envio',
          cookies: 'Política de cookies',
          custom: 'Personalizado',
        },
        fields: {
          title: 'Título',
          titlePh: 'ex.: Termos de serviço',
          type: 'Tipo de documento',
          content: 'Conteúdo',
          contentPh: 'Escreve aqui o teu texto legal…',
          isActive: 'Ativo',
          requireAcceptance: 'Exigir aceitação na finalização',
        },
        actions: {
          edit: 'Editar',
          delete: 'Eliminar',
          save: 'Guardar',
          cancel: 'Cancelar',
        },
      },
      checkoutGroup: 'Finalização',
      serviceCharge: {
        title: 'Taxa de serviço',
        subtitle: 'Adiciona uma taxa de serviço ou gorjeta a cada encomenda.',
        label: 'Descrição',
        labelPh: 'ex.: Taxa de serviço 5% e gorjeta de entrega 3€',
        rate: 'Taxa',
        rateHint: 'Percentagem do subtotal da encomenda.',
        amount: 'Montante',
        amountHint: 'Montante fixo adicionado por cima.',
      },
      tip: {
        title: 'Gorjetas',
        subtitle: 'Permite aos clientes adicionar uma gorjeta à encomenda na finalização.',
        enable: 'Ativar gorjetas',
        presets: 'Predefinições de gorjeta (%)',
        noPresets: 'Ainda não há predefinições — adiciona uma abaixo.',
        presetPh: 'ex.: 10',
        addPreset: '+ Adicionar predefinição',
        presetsHint: 'Mostradas como botões de escolha rápida na finalização. Até 6.',
        remove: 'Remover',
        allowCustom: 'Permitir montante personalizado',
        label: 'Texto do pedido',
        labelPh: 'ex.: Adiciona uma gorjeta pelo ótimo serviço',
        save: 'Guardar',
        saving: 'A guardar…',
      },
      orderNumber: {
        title: 'Número da encomenda',
        subtitle: 'Personaliza o aspeto dos números de encomenda.',
        next: 'Próximo número de encomenda',
        prefix: 'Prefixo',
        suffix: 'Sufixo',
        showInMessage: 'Mostrar na fatura e na mensagem da encomenda',
        reset: 'Repor número de encomenda',
      },
      orderMessage: {
        title: 'Mensagem da encomenda',
        subtitle: 'Personaliza a confirmação de encomenda enviada aos clientes.',
        footer: 'Rodapé da mensagem',
        footerPh: 'ex.: Obrigado pela tua encomenda! Segue-nos @amarca',
        footerHint: 'Anexado a todas as mensagens de confirmação de encomenda.',
        plain: 'Mensagem simples',
        plainHint: 'Remove toda a formatação da mensagem da encomenda.',
      },
      invoice: {
        title: 'Fatura',
        subtitle: 'Fatura personalizada anexada às encomendas pagas.',
        upgrade: 'Upgrade',
        showLogo: 'Mostrar logótipo',
        header: 'Cabeçalho',
        footer: 'Rodapé',
        companyName: 'Nome da empresa',
        companyEmail: 'Email da empresa',
        companyPhone: 'Telefone da empresa',
        companyAddress: 'Morada da empresa',
        companyAddressPh: 'Introduz a morada',
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'Personalize sua página com tags meta SEO',
      titleText: 'Título',
      titlePlaceholder: 'Insira o título da página',
      description: 'Descrição',
      descriptionPlaceholder: 'Insira a descrição da página',
      favicon: 'Favicon',
      uploadFavicon: 'Enviar favicon',
      imagePreview: 'Pré-visualização da imagem',
      useCustom: 'Usar imagem personalizada',
      save: 'Salvar',
      visualise: 'Visualize como a pré-visualização do seu site ficará no Google',
      inMessengers: 'Em mensageiros',
      inSocial: 'Em redes sociais',
      searchEngine: 'Motor de busca',
      googleIndexable: 'Indexável pelo Google',
      sitemap: {
        title: 'Mapa do site',
        entryHint: 'Gere que páginas e produtos os motores de busca podem indexar.',
        setupLink: 'personalizar',
        mainEntry: 'Indexar website',
        subtitle: 'Escolhe que páginas os motores de busca devem indexar. As páginas desativadas recebem uma tag noindex e são removidas do teu mapa do site.',
        mainPage: 'Página de perfil principal',
        pagesSection: 'Páginas',
        pagesHint: 'Ativa/desativa a indexação de cada página adicional do teu site.',
        noPages: 'Ainda não há páginas adicionais.',
        productsSection: 'Produtos',
        productsHint: 'Ativa/desativa a indexação de páginas de produto individuais.',
        noProducts: 'Ainda não há produtos.',
        postsSection: 'Publicações',
        postsHint: 'Ativa/desativa a indexação de publicações individuais.',
        noPosts: 'Ainda não há publicações.',
        blogSection: 'Artigos do blogue',
        blogHint: 'Ativa/desativa a indexação de artigos do blogue individuais.',
        noArticles: 'Ainda não há artigos do blogue.',
        loadMore: 'Carregar mais',
        loading: 'A carregar…',
      },
    },
    analytics: {
      title: 'Análises',
      subtitle: 'Integre Facebook Pixel, Google Analytics e parâmetros UTM',
      facebookTooltip: 'Conecte o Facebook para exibir análises',
      googleAnalyticsTooltip: 'O Google Analytics permite medir o ROI da sua publicidade e rastrear todos os seus links.',
      googleTagManagerTooltip: 'O Google Tag Manager permite configurar e implantar tags instantaneamente no seu site',
      tikTokPixelTooltip: 'O TikTok Pixel é uma ferramenta poderosa de medição que rastreia o impacto dos seus anúncios TikTok no seu site',
      pinterestTag: 'Tag do Pinterest',
      pinterestTagTooltip:
        'A tag do Pinterest é um código que você adiciona ao seu site que permite ao Pinterest rastrear visitantes no seu site, bem como as ações que eles tomam após verem seu anúncio no Pinterest.',
      tag: 'tag',
      headerTagTooltip: 'Cole a tag que aparece no cabeçalho do seu site',
      bodyTagTooltip: 'Cole a tag que aparece no corpo do seu site',
      utmParameters: 'Parâmetros UTM',
      utmParametersTooltip: 'Colete dados de campanha com URLs personalizadas. Adicione parâmetros às URLs para identificar as campanhas que referem tráfego.',
      makeAnalytics: 'Faça o Google Analytics mostrar o tráfego do UniLink como Social',
      the: 'O',
      campaign: 'campanha',
      parameter: 'parâmetro é definido dinamicamente a partir do título de cada publicação ou link',
      save: 'Salvar',
    },
    customDomain: {
      title: 'Domínio personalizado',
      subtitle: 'Personalize sua página com domínio personalizado',
      titleTooltip: 'Adicionar domínio personalizado',
      save: 'Salvar',
      connect: 'Conectar',
      connecting: 'Conectando',
      instructions: 'Instruções',
      submit: 'Enviar',
      submitting: 'Enviando...',
      enterDomain: 'Insira seu domínio',
      domainPlaceholder: 'seu-dominio.com',
      steps: {
        submitting: 'Enviando solicitação',
        validation: 'Validação do domínio',
        certificate: 'Provisionamento do certificado',
        complete: 'Concluído',
      },
      txtRecord: {
        title: 'Registro TXT',
        description: 'Adicione o seguinte registro TXT às suas configurações DNS:',
        verifyButton: 'Verificar Registro TXT',
        verifying: 'Verificando...',
        verified: 'Registro TXT verificado',
      },
      cnameRecord: {
        title: 'Registro CNAME',
        description: 'Adicione o seguinte registro CNAME às suas configurações DNS:',
        verifyButton: 'Verificar Registro CNAME',
        verifying: 'Verificando...',
        verified: 'Registro CNAME verificado',
      },
      dnsTable: {
        type: 'Tipo',
        host: 'Host',
        value: 'Valor',
        ttl: 'TTL',
        copy: 'Copiar',
        copied: 'Copiado!',
      },
      provisioning: {
        title: 'O certificado SSL está sendo provisionado...',
        description: 'Isso pode levar alguns minutos. Por favor, aguarde.',
        timeout: 'O provisionamento do certificado está demorando mais que o esperado. Por favor, verifique mais tarde.',
      },
      complete: {
        title: 'O HTTPS foi ativado com sucesso no seu domínio.',
        connected: 'Conectado',
      },
      failed: {
        title: 'Falha na conexão do domínio',
        tryAgain: 'Tentar Novamente',
      },
      rootDomainWarning: 'Domínios raiz requerem que seu provedor DNS suporte CNAME flattening (ex.: Cloudflare, Route53).',
      deleteConfirm: {
        title: 'Desconectar domínio',
        message: 'Tem certeza de que deseja desconectar este domínio? Seu site não estará mais acessível por este domínio.',
        confirm: 'Desconectar',
        cancel: 'Cancelar',
      },
    },
    webhooks: {
      title: 'Webhooks',
      subtitle: 'Envie notificações de eventos em tempo real para serviços externos',
      webhook: 'Webhook',
      webhookTooltip: 'Adicionar webhook',
      send: 'Enviar eventos para site de terceiros',
      webhookUrl: 'URL do Webhook (requisição POST)',
      error: 'Insira um link correto',
      save: 'Salvar alterações',
      enableWebhooks: 'Ativar Webhooks',
      enableDescription: 'Requisições POST em eventos selecionados',
      endpointUrl: 'URL do Endpoint',
      endpointTooltip: 'A URL que receberá requisições POST quando os eventos selecionados ocorrerem',
      endpointPlaceholder: 'https://exemplo.com/api/webhook',
      events: 'Eventos',
      selectAll: 'Selecionar todos',
      deselectAll: 'Desmarcar todos',
      filterPlaceholder: 'Filtrar eventos...',
      all: 'Todos',
      none: 'Nenhum',
      active: 'Ativo',
      inactive: 'Inativo',
      categories: {
        submissions: 'Envios',
        engagement: 'Engajamento',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'Assinatura do Cabeçalho',
        SubmitHeaderMessage: 'Mensagem do Cabeçalho',
        SubmitDataCollect: 'Coleta de Dados',
        SubmitForm: 'Envio de Formulário',
        SubmitShop: 'Pedido da Loja',
        SubmitShopPreorder: 'Pré-venda da Loja',
        SubmitDigital: 'Produto Digital',
        SubmitAppointment: 'Agendamento',
        SubmitService: 'Pedido de Serviço',
        SubmitEvent: 'Inscrição em Evento',
        SubmitCourse: 'Inscrição em Curso',
        SubmitDonation: 'Doação',
        SubmitMembership: 'Assinatura',
        SubmitBlog: 'Compra do Blog',
        SubmitCoupon: 'Cupom Usado',
        SubmitTip: 'Gorjeta',
        SubmitLink: 'Compra de Link',
        SubmitProductMessage: 'Pergunta sobre Produto',
        SubmitPodcast: 'Compra de Podcast',
        SubmitBooking: 'Reserva',
        SubmitRental: 'Aluguel',
        SubmitSingleProduct: 'Produto Avulso',
        SubmitDiscount: 'Pedido com Desconto',
        SubmitListing: 'Solicitação de Listagem',
        SubmitUnlock: 'Desbloqueio de Conteúdo',
        SubmitChatAi: 'Mensagem do Chat IA',
        ClickLink: 'Clique no Link',
        ClickContact: 'Clique no Contato',
        AddToCart: 'Adicionar ao Carrinho',
        AddToCartSingleProduct: 'Produto Avulso ao Carrinho',
        AddToWishlist: 'Adicionar à Lista de Desejos',
        InitiateCheckout: 'Iniciar Checkout',
        DownloadFile: 'Download de Arquivo',
        DownloadMusic: 'Download de Música',
        CopyCoupon: 'Copiar Cupom',
        CopyDiscount: 'Copiar Desconto',
        QR_ScanQrCode: 'Escaneamento de QR Code',
        VisitPage: 'Visita à Página',
      },
    },
    sensitive: {
      title: 'Material sensível',
      subtitle: 'Mostrar aviso de conteúdo sensível antes de exibir seu site',
    },
    socialIntegration: {
      title: 'Integração social',
      subtitle: 'Gerencie suas integrações do Instagram, TikTok',
      connectInstagram: 'Conectar Instagram',
    },
    emailIntegration: {
      title: 'Integrações de público',
      subtitle: 'Passe os endereços de e-mail dos seus visitantes para MailChimp, Reply',
      emailCaption: 'Adicione uma integração para passar os endereços de e-mail dos seus seguidores para o MailChimp',
      mailChimp: 'Integrações MailChimp',
      selzy: 'Integrações Selzy',
      selzyCaption: 'Adicione uma chave de API para passar os endereços de e-mail dos seus seguidores para o Selzy',
      sendPulse: 'Integrações SendPulse',
      sendPulseCaption: 'Adicione uma chave de API para passar os endereços de e-mail dos seus seguidores para o SendPulse',
      reply: 'Integrações Reply',
      replyCaption: 'Adicione uma chave de API para passar os endereços de e-mail dos seus seguidores para',
      integrations: 'integrações',
    },
    calendarIntegration: {
      title: 'Calendar integrations',
      subtitle: 'Connect your calendar services',
      calendly: 'Calendly',
      calendlyDescription: 'Connect Calendly to sync your event types and availability',
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: 'Connect Google Calendar to sync events and create Google Meet links',
      zoom: 'Zoom',
      zoomDescription: 'Connect Zoom to create meeting links automatically',
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Create Google Meet links automatically (requires Google Calendar)',
    },
    storage: {
      title: 'Armazenamento',
      subtitle: 'Salve os pedidos dos visitantes no Google Spreadsheet',
      storageCaption: 'Adicione uma integração para salvar todos os pedidos dos clientes no Google Spreadsheet',
      emailSignup: 'Cadastro por e-mail',
      emailSignupsCaption: 'Escolha a tabela para salvar cadastros por e-mail',
      formSignups: 'Cadastro por formulário',
      forSignupsCaption: 'Escolha a tabela para salvar cadastros por formulário',
      shopOrders: 'Pedidos da loja',
      shopOrderCaption: 'Escolha a tabela para salvar pedidos da loja',
      disconnect: 'Desconectar planilha',
      storageUsage: 'Uso do armazenamento',
      of: 'de',
      uses: 'Este aplicativo usa',
      space: 'do seu espaço livre em disco',
      view: 'ver detalhes',
      noItems: 'Não há itens',
      files: 'Arquivos',
      images: 'Imagens',
      videos: 'Vídeos',
      audio: 'Áudio',
      settings: 'configurações',
      free: 'livre',
      needMoreSpace: 'Precisas de mais espaço?',
      unlockStorage: 'Desbloqueia armazenamento ilimitado, vídeo 4K',
      upgradePlan: 'Fazer upgrade do plano',
      addFile: 'Adicionar ficheiro',
      uploading: 'A carregar...',
      dragDrop: 'ou arrasta e larga aqui',
      noFilesYet: 'Ainda não há ficheiros',
      noImagesYet: 'Ainda não há imagens',
      noVideosYet: 'Ainda não há vídeos',
      noAudioYet: 'Ainda não há áudio',
      filesHint: 'Carrega PDFs, documentos e outros downloads para os anexares aos links da tua página de bio.',
      imagesHint: 'Carrega imagens para usar em toda a tua página de bio.',
      videosHint: 'Carrega vídeos para incorporar na tua página de bio.',
      audioHint: 'Carrega faixas de áudio para partilhar na tua página de bio.',
    },
    accountLabel: 'Conta',
    profileLabel: 'Perfil',
    switchProfile: 'Mudar de perfil',
    createNewProfile: 'Criar novo perfil',
    active: 'Ativo',
    currentPlan: 'Plano atual',
    freePlanHint: 'Faz upgrade para desbloquear funcionalidades Pro e remover limites.',
    to: 'para',
    renews: 'Renova',
    passwordChangeDesc: 'Altera a palavra-passe da tua conta',
    apiKeyDesc: 'Usa esta chave para autenticar pedidos API',
    apiDocumentation: 'Documentação da API',
    dashboardLanguageDesc: 'Idioma da interface da tua conta',
    manualPayments: {
      title: 'Pagamentos manuais / offline',
      hint: 'Os clientes pagam offline (transferência bancária, dinheiro, QR). Confirmas a encomenda manualmente.',
      save: 'Guardar',
      iban: 'IBAN',
      accountHolder: 'Nome do titular da conta',
      bankName: 'Nome do banco',
      phone: 'Telefone',
      payeeName: 'Nome do beneficiário',
      instruction: 'Instrução',
      instructionHint: 'Decora com **negrito** ~rasurado~ _itálico_',
      requireProof: 'Exigir comprovativo de pagamento',
      requireProofHint:
        'Para finalizar a compra, os clientes têm de carregar uma captura de ecrã (recibo, confirmação de transferência bancária ou qualquer comprovativo de pagamento).',
      markPaidOnConfirm: 'Marcar como pago após confirmação do cliente',
      markPaidOnConfirmHint: `Atualiza automaticamente o estado do pagamento para 'Pago' assim que o cliente confirmar o pagamento.`,
      contactBeforePay: 'Ativar contacto com o vendedor antes do pagamento',
      contactBeforePayHint:
        'Permite aos clientes ignorar o pagamento para contactar o vendedor, aumentando os pedidos de informação mas gerando confiança e reduzindo cancelamentos.',
    },
    developerApi: {
      title: 'API para programadores',
      subtitle: 'Cria chaves API para aceder às tuas encomendas, produtos e clientes através dos endpoints /api/v2.',
      keyName: 'Nome da chave',
      keyNamePh: 'ex.: Sincronização do armazém',
      scopes: 'Permissões',
      scopeLabels: {
        'orders:read': 'Ler encomendas',
        'products:read': 'Ler produtos',
        'products:write': 'Atualizar stock de produtos',
        'customers:read': 'Ler clientes',
      },
      create: 'Criar chave',
      creating: 'A criar…',
      created: 'Chave API criada',
      copyWarning: 'Copia esta chave agora — não será mostrada novamente.',
      done: 'Concluído',
      revoke: 'Revogar',
      revoked: 'Revogada',
      confirmRevoke: 'Revogar esta chave API? As apps que a usam deixarão de funcionar.',
      empty: 'Ainda não há chaves API.',
    },
    whatsapp: {
      title: 'WhatsApp Business',
      subtitle: 'Liga o teu número do WhatsApp Business para receber e responder a mensagens de clientes.',
      phoneNumberId: 'ID do número de telefone',
      accessToken: 'Token de acesso',
      displayPhone: 'Telefone a apresentar (opcional)',
      connect: 'Ligar',
      connecting: 'A ligar…',
      connected: 'Ligado',
      disconnect: 'Desligar',
      confirmDisconnect: 'Desligar o WhatsApp?',
      webhookHelp: 'Define este Callback URL e Verify token na tua Meta App → WhatsApp → Configuração:',
      webhookUrl: 'Callback URL',
      verifyToken: 'Verify token',
      inbox: 'Caixa de entrada',
      noMessages: 'Ainda não há mensagens.',
      selectThread: 'Seleciona uma conversa.',
      replyPlaceholder: 'Escreve uma mensagem…',
      send: 'Enviar',
      broadcast: {
        title: 'Difusão',
        audienceInbox: 'Contactos da caixa de entrada',
        audienceCrm: 'Audiência do CRM (modelo)',
        message: 'Mensagem',
        inboxHint: 'Texto livre — apenas entregue a contactos dentro da janela de apoio ao cliente de 24h.',
        templateName: 'Nome do modelo',
        templateLang: 'Idioma do modelo',
        crmHint: 'Usa um modelo do WhatsApp aprovado — necessário para alcançar contactos fora da janela de 24h.',
        send: 'Enviar difusão',
        sending: 'A enviar…',
        empty: 'Ainda não há difusões.',
        sent: 'enviada',
        failed: 'falhada',
      },
      autoReply: {
        title: 'Respostas automáticas',
        type: 'Tipo',
        typeKeyword: 'Palavra-chave',
        typeGreeting: 'Saudação (primeira mensagem)',
        typeAway: 'Ausente (fora de horas)',
        keyword: 'Palavra-chave',
        from: 'Das',
        to: 'Às',
        reply: 'Texto da resposta',
        add: 'Adicionar regra',
        empty: 'Ainda não há regras de resposta automática.',
        delete: 'Eliminar',
      },
    },
  },
  productStore: {
    title: 'Mostrar aba da Loja no seu link-in-bio',
    subtitle: 'Sua Loja está atualmente oculta.',
  },
  sections: {
    elements: {
      editTitle: 'Edit section',
      sectionTitle: 'Section title',
      sectionTitleCaption: 'Shown above the section. Leave empty, or hide it with the toggle below.',
      sectionTitlePlaceholder: 'For example, Delivery terms',
      hideHeader: 'Hide header',
      textBody: 'Text',
      textBodyCaption: 'A paragraph that supports the block: terms, a disclaimer, an explanation.',
      textBodyPlaceholder: 'Write the text of this section',
      itemsLayout: 'Layout',
      itemsLayoutCaption: 'How the rows are arranged inside this section.',
      layoutList: 'List',
      layoutGrid: 'Grid',
      layoutRow: 'Row',
      image: 'Image',
      imageCaption: 'Uploaded or picked from your media library.',
      imageAlt: 'Alt text',
      imageAltCaption: 'Read by screen readers and shown if the image fails to load.',
      imageAltPlaceholder: 'What is in the picture',
      ratio: 'Proportions',
      ratioCaption: 'Auto keeps the original shape. The others crop to fit.',
      ratioAuto: 'Auto',
      caption: 'Caption',
      captionCaption: 'A short line under the media. Optional.',
      captionPlaceholder: 'Caption',
      linkUrl: 'Link',
      linkUrlCaption: 'Where a click leads. Leave empty for no link.',
      videoUrl: 'Video link',
      videoUrlCaption: 'YouTube, Vimeo, or a direct mp4 link.',
      videoDetected: 'Detected',
      videoNotDetected: 'This link cannot be played here. Use YouTube, Vimeo or a direct mp4 link.',
      videoPoster: 'Cover image',
      videoPosterCaption: 'Shown before playback. YouTube covers are picked up automatically.',
      embedHtml: 'HTML',
      embedHtmlCaption: 'Scripts are removed. Iframes work for YouTube, Vimeo and Spotify only.',
      embedStripped: 'Will be removed on save',
      countdownEnds: 'Ends on',
      countdownEndsCaption: 'The date and time the countdown runs to.',
      countdownNoDate: 'Pick a date and time, otherwise nothing is shown.',
      timezone: 'Time zone',
      timezoneCaption: 'The zone the time above is in. Visitors see the countdown in their own.',
      countdownStyle: 'Style',
      countdownStyleCaption: 'Strip shows days, hours and minutes. Compact is one line.',
      countdownStyleStrip: 'Strip',
      countdownStyleCompact: 'Compact',
      countdownHideWhenEnded: 'Hide timer when countdown ends',
      couponCode: 'Promo code',
      couponCodeCaption: 'Visitors copy it with one tap.',
      couponDescription: 'Description',
      couponDescriptionCaption: 'What the code gives. Optional.',
      couponDescriptionPlaceholder: '20% off your first order',
      couponExpires: 'Valid until',
      couponExpiresCaption: 'After this date the coupon is hidden.',
      couponButtonText: 'Link text',
      couponButtonTextCaption: 'Shown instead of the bare address.',
      couponButtonTextPlaceholder: 'Shop now',
      address: 'Address',
      addressCaption: 'Start typing and pick a suggestion so the pin is exact.',
      addressPlaceholder: 'Street, city',
      addressNotPicked: 'Pick one of the suggestions — without a pin the map is not shown.',
      showDirections: 'Show "Get directions" link',
      galleryItems: 'Images',
      galleryItemsCaption: 'Up to 12. Each can carry a caption.',
      addImage: 'Add image',
      itemTitlePlaceholder: 'Name',
      reviewsItems: 'Reviews',
      reviewsItemsCaption: 'Up to 10 quotes you write yourself.',
      reviewsShowRating: 'Show star ratings',
      addReview: 'Add review',
      reviewName: 'Name',
      reviewRole: 'Role',
      reviewRating: 'Rating 1-5',
      reviewText: 'Review',
      contactItems: 'Contacts',
      contactItemsCaption: 'Up to 6 channels.',
      addContact: 'Add contact',
      contactValuePlaceholder: 'Number, address or username',
      contactLabelPlaceholder: 'Label (optional)',
      channels: {
        phone: 'Phone',
        email: 'Email',
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        instagram: 'Instagram',
        website: 'Website',
        address: 'Address',
      },
      summary: {
        oneImage: '1 image',
        manyImages: '{n} images',
        oneReview: '1 review',
        manyReviews: '{n} reviews',
        oneContact: '1 contact',
        manyContacts: '{n} contacts',
      },
    },
    splashScreen: {
      title: 'Tela de Abertura',
      subtitle: 'Aparece enquanto a página está carregando',
    },
    promo: {
      title: 'Barra promocional',
      subtitle: 'Destaque que permite exibir promoções',
      masterPromoMessage:
        'A Barra Promocional Principal está ativada no momento. Se você deseja criar uma barra promocional personalizada para esta página, precisará desativar a Barra Promocional Principal primeiro.',
      titlePlaceholder: 'Bem-vindo ao meu site!',
      switcherIsMasterPromobar: 'Mostrar em todas as páginas',
    },
    contact: {
      title: 'Contatos',
      subtitle: 'Forneça formas de se comunicar com você',
      caption: 'Adicione botões de mensageiros para conexão rápida entre você e seus clientes em um clique',
      tooltip: 'Contatos permite que os usuários se comuniquem diretamente com você. Adicione seu telefone, e-mail, mensageiro ou localização',
      addNewContact: 'Adicionar novo contato',
      addContact: 'Adicionar contato',
      chooseContact: 'Escolher contato',
      enterLink: 'Insira seu link de contato',
      showDetails: 'Mostrar detalhes',
      enterAnyContact: 'Por favor, insira qualquer contato',
      enterAnyContactCaption: '(WhatsApp, Telegram, Viber, Messenger)',
    },
    membership: {
      title: 'Assinatura',
      subtitle: 'Crie uma assinatura gratuita ou paga para seu conteúdo',
      addNewTier: 'Adicionar novo nível',
      editTier: 'Editar nível',
      name: 'Nome',
      nameCaption: 'Insira o nome do seu nível',
      price: 'Preço por mês',
      priceCaption: 'Insira o preço do seu nível',
      month: 'mês',
      image: 'Imagem',
      imageCaption: 'Envie uma imagem para seu nível',
    },
    pricing: {
      title: 'Preços',
      subtitle: 'Crie um cardápio com preços',
      add: 'Adicionar novo item',
      edit: 'Editar item',
      name: 'Nome',
      nameCaption: 'Insira o nome do seu item',
      duration: 'Atributo',
      durationCaption: 'Insira o tempo, quantidade ou duração do seu item',
      category: 'Categoria',
      categoryCaption: 'Insira a categoria do seu item',
      price: 'Preço',
      priceCaption: 'Insira o preço do seu item',
      month: 'mês',
      image: 'Imagem',
      imageCaption: 'Envie uma imagem para seu item',
    },
    subscribe: {
      dataCollectTitle: 'Coleta de Dados',
      title: 'Assinar',
      subtitle: 'Colete e-mails ou números de telefone dos seus visitantes',
      instructionsMessage: 'Adicione um campo de cadastro por e-mail à sua página para que seus visitantes possam se cadastrar facilmente!',
      instructionsLink: 'Passe e-mails para o MailChimp para executar campanhas de marketing.',
      sectionHeaderCaption: 'Assine nossa newsletter',
      collecting: 'Coletando',
      collectingCaption: 'Escolha seu tipo de entrada',
      addDataToCollect: 'Adicionar dados para coleta',
      email: 'E-mail',
      enterEmail: 'Inserir e-mail',
      thanksForEmail: 'Obrigado pelo seu e-mail',
      phone: 'Telefone',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'Youtube',
      whatsapp: 'Whatsapp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: 'Adicionar links atualizados',
      placeholder: 'Placeholder',
      placeholderCaption: 'Inserir texto do placeholder',
      button: 'Botão',
      buttonCaption: 'Texto que motivará o visitante a inserir o e-mail (10% de desconto, assine agora, baixar arquivo etc.)',
      submitButton: 'Botão de envio',
      enterButton: 'Botão de entrada',
      thanksMessage: 'Mensagem de agradecimento',
      thanksMessageCaption: 'Mensagem de agradecimento dos seus assinantes',
      resultAction: 'Ação (após envio)',
      resultActionCaption: 'Ação após preenchimento do formulário',
      sendAnEmail: 'Enviar um e-mail',
      downloadFile: 'Baixar arquivo',
      redirect: 'Redirecionar',
      messageBody: 'Corpo da mensagem',
      messageBodyCaption: 'Estes dados serão enviados ao e-mail do usuário como presente pelo seu e-mail (cupom, link para download de arquivo, etc.)',
      integration: 'Integração',
      integrationCaption: 'Passe os endereços de e-mail dos seus visitantes para MailChimp, Reply',
      storage: 'Armazenamento',
      storageCaption: 'Salve os pedidos dos visitantes no Google Spreadsheet',
      maxSize: 'Você pode adicionar no máximo 3 canais',
    },
    text: {
      title: 'Texto',
      subtitle: 'Escreva qualquer coisa sobre você/empresa',
      trimBio: 'Botão Mostrar Mais',
    },
    header: {
      title: 'Cabeçalho',
      subtitle: 'Imagem ou vídeo em destaque ampliado na sua página',
      verifiedBadge: 'Selo verificado',
      showProfilePic: 'Exibir foto do perfil',
      profilePicRatio: 'Proporção',
      profilePicRatioSquare: 'Quadrado',
      profilePicRatioLandscape: 'Paisagem',
      profilePicRatioPortrait: 'Retrato',
      namePlaceholder: 'Seu nome',
      shortBioPlaceholder: 'Minhas informações resumidas',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: 'Cidade',
      addSocial: '+ Adicionar social',
      addCover: '+ Adicionar capa',
      addButton: '+ Adicionar botão',
      addText: '+ Adicionar texto',
      addLabel: '+ Adicionar rótulo',
      subtitleName: 'Personalize a aparência do seu nome',
      subtitleShortBio: 'Personalize a aparência da sua bio curta',
      shortBioSize: 'Tamanho da Bio curta',
      subtitleShortBioSize: 'Você pode alterar o tamanho da bio curta',
      subtitleLocation: 'Defina a cidade/país para navegar os visitantes para um local específico',
      headerCoverWarningMessage: 'Seu navegador não suporta a tag de vídeo.',
      headerCoverTitle: 'Definir capa acima do cabeçalho',
      coverHeight: 'Altura da capa',
      subtitleCoverHeight: 'Você pode alterar a altura da capa',
      coverDarkness: 'Escurecimento da capa',
      subtitleCoverDarkness: 'Arraste o controle para escurecer a imagem da capa',
      nameSize: 'Tamanho do nome',
      subtitleNameSize: 'Você pode alterar o tamanho do nome',
      positionText: 'Posição do nome',
      subtitlePositionName: 'Arraste o controle para definir a posição do nome',
      positionContent: 'Posição do conteúdo',
      subtitlePositionContent: 'Defina a posição para bio, link, localização',
      coverText: 'Texto na capa',
      subtitleCoverText: 'Adicione texto à sua capa',
      position: 'Posição',
      subtitlePosition: 'Arraste o controle para definir a posição do botão',
      buttonCover: 'Botão na capa',
      subtitleButtonCover: 'Adicione um botão à sua capa escolhendo uma ação',
      subtitleFollow: 'O botão Seguir permite que os usuários sigam suas novidades',
      buttonOpacity: 'Arraste o controle para alterar a opacidade do botão',
      subtitleCart: 'Ícone do carrinho para oferecer uma experiência de compra',
      subtitleDirect: 'Botão rápido para navegar o visitante aos mensageiros',
      subtitleCTAButton: '(chamada para ação) botão que motiva o usuário a clicar',
      subtitleSocialLinks: 'Dê uma aparência visual às suas redes sociais',
      chooseSocialLink: 'Escolher link social',
      alignSocialLink: 'Alinhamento dos links sociais',
      enterYourSocialLink: 'Insira seu link social',
      blockShadow: 'Sombra do bloco',
      activeButtonPosition: 'Posição do botão ativo',
      gradientColor: 'Cor do gradiente',
      bottomGradient: 'Gradiente inferior',
      autoGradient: 'Auto',
      customGradient: 'Personalizado',
      transparentGradient: 'Transparente',
      uploadLogo: 'Enviar Logo',
      customBackground: 'Fundo personalizado',
      headingLabel: 'Rótulo do Cabeçalho',
      customizeLabel: 'Personalize a aparência do rótulo do cabeçalho',
      labelText: 'Texto do Rótulo',
      enterLabelText: 'Insira o texto para o rótulo do cabeçalho',
      verticalCropStep: 'foto vertical',
      squareCropStep: 'avatar quadrado',
      topButtons: 'Botões superiores',
      bottomButtons: 'Botões inferiores',
      buttonSubtitleLanguage: 'Seletor de idioma',
      buttonSubtitleContact: 'Ligar / mensagem',
      buttonSubtitleCart: 'Carrinho de compras',
      buttonSubtitleCta: 'Apelo à ação',
      buttonSubtitleMessage: 'Mensagem',
      buttonSubtitleSubscribe: 'Subscrever',
      buttonSubtitleQrcode: 'Código QR',
      buttonSubtitleSearch: 'Busca de produtos',
      buttonDisabledHint: 'Oculto · desativado',
      gradientPositionLabel: 'Posição da sombra',
      gradientPositionPhoto: 'Sob a foto',
      gradientPositionHeader: 'Mais abaixo no cabeçalho',
      bottomBadge: 'Tonalidade inferior',
      addTint: 'Adicionar tonalidade',
      bottomBadgeText: 'Texto (opcional)',
      bottomBadgePreset: 'Predefinição',
      bottomBadgeShape: 'Forma',
      bottomBadgeSize: 'Altura',
      bottomBadgeAction: 'Ação',
      bottomBadgeBgColor: 'Cor de fundo',
      bottomBadgeTextColor: 'Cor do texto',
      bottomBadgeGradientFrom: 'Gradiente de',
      bottomBadgeGradientTo: 'Gradiente para',
      bottomBadgeGradientAngle: 'Ângulo do gradiente',
    },
  },
  billingHistory: {
    title: 'Histórico de cobrança',
    invoices: 'Faturas',
    messageText: 'Você ainda não tem histórico de pagamentos.',
  },
  migrate: {
    title: 'Você tem LinkTree ou Taplink?',
    text: 'Cole o link e migre para o UniLink em apenas um clique!',
    button: 'Migrar',
  },
  pages: {
    title: 'Páginas',
    addPage: 'Adicionar página',
    addNewPage: 'Adicionar nova página',
    deleteTitle: 'Tem certeza de que deseja excluir esta página?',
    managePage: 'Gerenciar Abas',
    empty: 'Esta página ainda não tem nenhum bloco.',
    dragAndDrop: 'Arraste e solte suas outras abas para reordená-las',
    pageNavigation: 'Configurações de navegação da página',
    goToDesign: 'Ir para Configurações de Design',
    viewArchive: 'Ver arquivo',
    archivedBlocks: 'Blocos arquivados',
    noArchivedBlocks: 'Mantenha sua página limpa e organizada arquivando blocos que não está usando no momento.',
    archiveAllUnpublished: 'Arquivar todos os blocos não publicados',
    restore: 'Restaurar',
    permanentDelete: 'Excluir permanentemente',
  },
  analytics: {
    lifeTimeAnalytics: 'Análises Completas',
    impressions: 'Impressões',
    impressionsText: 'Desempenho das estatísticas de impressões para o período escolhido',
    clicks: 'Cliques',
    clicksText: 'Desempenho dos eventos de "clique" para o período escolhido',
    signUps: 'Cadastros',
    signUpsText: 'Desempenho dos eventos de "fechamento" para o período escolhido',
    totalInteractions: 'Interações',
    totalInteractionsText: 'Cliques e cadastros por formulário no período escolhido',
    engagementRate: 'Taxa de engajamento',
    engagementRateText: 'Percentual de visualizações do perfil que geraram interação',
    visitor: 'Origem dos Visitantes',
    country: 'País',
    countries: 'Países',
    linkClicks: 'Cliques em links',
    content: 'Conteúdo',
    views: 'Visualizações',
    links: 'Links',
    products: 'Produtos',
    blocks: 'Blocos',
    pages: 'Páginas',
    clicksLower: 'cliques',
    of: 'de',
    noContentData: 'Ainda não há dados para o período escolhido',
  },
  aiInsights: {
    title: 'Insights de IA',
    generate: 'Analisar meu perfil',
    description: 'Receba recomendações com IA para melhorar o desempenho do seu perfil.',
    analyzing: 'Analisando seu perfil...',
    refresh: 'Atualizar',
    action: 'Ação',
  },
  post: {
    subscriptionTypePlaceholder: `Disponível para assinatura '{type}' e acima`,
    postButtonText: 'Publicar',
    newPostPlaceholder: 'No que você está pensando',
    free: 'Grátis',
    pro: 'Pro',
    premium: 'Premium',
    noPost: 'Você ainda não tem publicações',
    editPost: 'Editar publicação',
  },
  preview: {
    buy: 'Comprar',
    connect: 'Conectar',
  },
  activeButton: {
    initialText: 'Site',
    inputPlaceholder: 'Buscar ações...',
    existing: 'Existente',
    redirect: 'Redirecionar',
    scroll: 'Rolar',
    title: 'Botão Ativo',
    modalTitle: 'Ação do botão ativo',
    subtitle: 'Botão que motiva o usuário a tomar uma ação',
    next: 'Próximo',
    save: 'Salvar',
    opensALinkFromLinksBlock: 'Abre um link do bloco de Links',
    url: 'URL',
    opensAWebsite: 'Abre um site',
    openInApp: 'Abrir no App',
    addAction: 'Adicionar Ação',
    actionTitle: 'Ação',
    actionCaption: 'Editar tipo de ação',
    chooseOption: 'Escolha uma opção',
    tellPeople: 'Diga às pessoas como interagir com o botão de ação',
    urlRedirect: 'Redirecionamento de URL',
    customUrl: 'URL Personalizada',
    customUrlText: 'Abre um site',
    links: 'Links',
    linksText: 'Abre um link do bloco de Links',
    downloadDocument: 'Baixar Documento',
    sendEmail: 'Enviar E-mail',
    opensEmailClient: 'Abre o cliente de e-mail',
    phoneCall: 'Chamada Telefônica',
    initiatesPhoneCall: 'Inicia uma chamada telefônica',
    navigation: 'Navegação',
    openPage: 'Abrir Página',
    opensInternalPage: 'Abre uma página interna',
    openPageText: 'Abre página interna',
    openProduct: 'Abrir Produto',
    openProductText: 'Abre página de produto da Loja',
    openBlog: 'Abrir Blog',
    opensBlogPageFromStore: 'Abre a página do blog na Loja',
    openBlock: 'Abrir Bloco',
    opensContentBlock: 'Abre o bloco de conteúdo',
    openItem: 'Abrir Item',
    opensItemPageFromStore: 'Abre a página do item na Loja',
    showNewModal: 'Mostrar Novo Modal',
    displayContentInModalWindow: 'Exibir conteúdo em janela modal',
    showProduct: 'Mostrar Produto',
    displayProductInModalWindow: 'Exibir produto em janela modal',
    showBlog: 'Mostrar Blog',
    scrollToBlock: 'Rolar até o Bloco',
    scrollToBlockText: 'Rola até o bloco especificado na página',
    scrollToItem: 'Rolar até o Item',
    action: 'Ação',
    showBlock: 'Mostrar Bloco',
    showBlockText: 'Exibe o bloco em uma janela modal na página',
    showItem: 'Mostrar Item',
    showItemText: 'Exibe o bloco do item em uma janela modal na página',
    linksCaption: 'Links',
    linksTooltip: 'Escolha um link do bloco de links',
    pagesCaption: 'Páginas',
    pagesTooltip: 'Escolha uma página das páginas',
    productsCaption: 'Produtos',
    productsTooltip: 'Escolha um produto da lista',
    blocksCaption: 'Blocos',
    blocksTooltip: 'Escolha um bloco da lista',
    itemsCaption: 'Itens',
    itemsTooltip: 'Escolha um item da lista',
    showProductText: 'Exibe o produto em uma janela modal na página',
    more: 'Mostrar mais',
    less: 'Mostrar menos',
    showNewModalTitle: 'Dados do Novo Modal',
    uploadDocumentTitle: 'Clique para enviar ou arraste e solte',
    uploadProgressTitle: 'Enviando...',
    haveNoModal: 'Você não tem modal',
    haveModal: 'Você selecionou um modal',
    openNewModalHandler: 'Criar novo modal',
    linkGroupSubTitle: 'Selecione um bloco',
    linkItemSubTitle: 'Selecione um link',
    urlItemSubTitle: 'URL do site',
    openInAppItemSubTitle: 'URL do app',
    sendEmailItemSubTitle: 'Endereço de e-mail',
    phoneCallItemSubTitle: 'Número de telefone',
    openPageGroupSubTitle: 'Selecionar Página',
    openPageItemSubTitle: 'Selecionar Página',
    openProductGroupSubTitle: 'Selecionar Tipo de Produto',
    openProductItemSubTitle: 'Selecionar Produto',
    openBlogGroupSubTitle: 'Selecionar Canal do Blog',
    openBlogItemSubTitle: 'Selecionar Artigo do Blog',
    openBlockGroupSubTitle: 'Selecionar Página',
    openBlockItemSubTitle: 'Selecionar Bloco',
    openItemGroupSubTitle: 'Selecionar Bloco',
    openItemItemSubTitle: 'Selecionar Item',
    showProductGroupSubTitle: 'Selecionar Tipo de Produto',
    showProductItemSubTitle: 'Selecionar Produto',
    showBlogGroupSubTitle: 'Selecionar Canal do Blog',
    showBlogItemSubTitle: 'Selecionar Artigo do Blog',
    showBlockGroupSubTitle: 'Selecionar Página',
    showBlockItemSubTitle: 'Selecionar Bloco',
    showItemGroupSubTitle: 'Selecionar Bloco',
    showItemItemSubTitle: 'Selecionar Item',
    scrollToBlockGroupSubTitle: 'Selecionar Página',
    scrollToBlockItemSubTitle: 'Selecionar Bloco',
    scrollToItemGroupSubTitle: 'Selecionar Bloco',
    scrollToItemItemSubTitle: 'Selecionar Item',
    linkGroupPlaceholder: 'Escolha um bloco...',
    linkItemPlaceholder: 'Escolha um link...',
    openPageItemPlaceholder: 'Escolha uma página...',
    openProductGroupPlaceholder: 'Escolha um tipo de produto...',
    openProductItemPlaceholder: 'Escolha um produto...',
    showProductGroupPlaceholder: 'Escolha um grupo de produtos...',
    showProductItemPlaceholder: 'Escolha um produto...',
    openBlogGroupPlaceholder: 'Escolha um canal de blog...',
    openBlogItemPlaceholder: 'Escolha um artigo de blog...',
    openBlockGroupPlaceholder: 'Escolha uma página...',
    openBlockItemPlaceholder: 'Escolha um bloco...',
    openItemGroupPlaceholder: 'Escolha uma página e um bloco...',
    openItemItemPlaceholder: 'Escolha um item...',
    showBlogGroupPlaceholder: 'Escolha um grupo de blog...',
    showBlogItemPlaceholder: 'Escolha um post do blog...',
    showBlockGroupPlaceholder: 'Escolha uma página...',
    showBlockItemPlaceholder: 'Escolha um bloco...',
    showItemGroupPlaceholder: 'Escolha uma página e um bloco...',
    showItemItemPlaceholder: 'Escolha um item...',
    scrollToBlockGroupPlaceholder: 'Escolha uma página...',
    scrollToBlockItemPlaceholder: 'Escolha um bloco...',
    scrollToItemGroupPlaceholder: 'Escolha uma página e um bloco...',
    scrollToItemItemPlaceholder: 'Escolha um item...',
    linkReadable: 'Link',
    urlReadable: 'URL',
    openInAppReadable: 'Abrir no app',
    downloadDocumentReadable: 'Baixar documento',
    sendEmailReadable: 'Enviar e-mail',
    phoneCallReadable: 'Ligar',
    openPageReadable: 'Abrir página',
    openProductReadable: 'Abrir produto',
    showNewModalReadable: 'Mostrar novo modal',
    showProductReadable: 'Mostrar produto',
    openBlogReadable: 'Abrir blog',
    openBlockReadable: 'Abrir bloco',
    openItemReadable: 'Abrir item',
    showBlogReadable: 'Mostrar blog',
    showBlockReadable: 'Mostrar bloco',
    showItemReadable: 'Mostrar item',
    scrollToBlockReadable: 'Rolar até o bloco',
    scrollToItemReadable: 'Rolar até o item',
  },
  design: {
    textColorHint: 'A cor do conteúdo deste bloco. O cabeçalho tem a sua própria cor.',
    tabs: 'Abas',
    imageView: 'Visualização da imagem',
    preview: 'Pré-visualizar',
    buttonOpacity: 'Opacidade do botão',
    buttonBorder: 'Borda do botão',
    buttonShadow: 'Sombra do botão',
    itemView: 'Visualização do item',
    itemViewTooltip: 'Escolha a visualização do item',
    itemLayout: 'Layout do item',
    itemLayoutTooltip: 'Escolha o layout do item',
    top: 'Topo',
    center: 'Centro',
    bottom: 'Inferior',
    bottomLeft: 'Inferior Esquerdo',
    bottomHorizontal: 'Inferior Horizontal',
    under: 'Abaixo',
    title: 'Título',
    titleButton: 'Título e Botão',
    displayOptions: 'Opções de exibição',
    displayOptionsTooltip: 'Escolha as opções de exibição',
    landscape: 'Paisagem',
    square: 'Quadrado',
    portrait: 'Retrato',
    desktopMode: 'Modo desktop',
    mobile: 'Compacto',
    desktop: 'Largo',
    responsive: 'Responsivo',
    custom: 'Personalizado',
    templates: 'Modelos',
    chooseTemplates: 'Escolha seus modelos',
    viewAll: 'Ver todos',
    previousTheme: 'Observe que o tema anterior será apagado permanentemente.',
    useThisTemplate: 'Usar este modelo',
    notSupportedVideo: 'Seu navegador não suporta a tag de vídeo.',
    photosBy: 'Fotos por',
    animationBy: 'Animação por',
    searchTheSame: 'Pesquise o mesmo termo novamente para resultados diferentes.',
    addImage: 'Adicionar uma imagem',
    addVideo: 'Adicionar um vídeo',
    orSelectFrom: 'ou selecione de',
    noImagesYet: 'Sem imagens ainda',
    noVideosYet: 'Sem vídeos ainda',
    videoBy: 'Vídeo por',
    hamburgerMenu: 'Menu hambúrguer',
    menuContent: 'Conteúdo do menu',
    menuShowContacts: 'Mostrar contatos',
    menuShowAddress: 'Mostrar endereço',
    menuAddress: 'Endereço',
    menuAddressCaption: 'Se vazio, será usado o bloco Contatos',
    menuShowCta: 'Mostrar botão',
    menuCtaText: 'Texto do botão',
    menuCtaCaption: 'Se vazio, será usado o botão do cabeçalho',
    menuCtaUrl: 'Link do botão',
    menuShowSocials: 'Mostrar redes sociais',
    tabsOnTop: 'Abas no topo',
    tabsOnBottom: 'Abas na parte inferior',
    borderType: 'Tipo de borda',
    subTitle: 'Escolha forma, tipo de borda, sombra etc.',
    icon: 'Ícone',
    iconTooltip: 'Escolha o ícone certo para seu botão',
    background: 'Fundo',
    color: 'Cor',
    backgroundOpacity: 'Opacidade do fundo',
    backgroundOpacityTooltip: 'Arraste o controle para definir a opacidade do fundo',
    gradient: 'Gradiente',
    color1: 'Cor 1',
    color2: 'Cor 2',
    direction: 'Direção',
    directionTooltip: 'Arraste o controle para definir a direção do gradiente',
    offset: 'Deslocamento',
    offsetTooltip: 'Arraste o controle para definir o deslocamento do gradiente',
    minHeight: 'Altura mínima',
    minHeightTooltip: 'Arraste o controle para alterar a altura mínima do botão',
    align: 'Alinhar',
    alignTooltip: 'Alterar posição do botão',
    insert: 'Inserir URL',
    upload: 'Enviar vídeo',
    search: 'Buscar vídeo',
    layout: 'Layout',
    layoutTooltip: 'Escolha o layout que desejar',
    view: 'Visualização',
    viewTooltip: 'Escolha a visualização que desejar',
    media: 'Mídia',
    mediaTooltip: 'Escolha a mídia que desejar',
    none: 'Nenhum',
    small: 'Pequeno',
    medium: 'Médio',
    large: 'Grande',
    round: 'Redondo',
    feed: 'Feed',
    slider: 'Slider',
    text: 'Texto',
    colorTooltip: 'Escolha as cores',
    button: 'Botão',
    buttonTooltip: 'Escolha as cores do botão',
    chooseEmoji: 'Escolher emoji',
    changeEmoji: 'Altere seu emoji',
    quantum: 'Quantum',
    emoji: 'Emoji',
    warp: 'Warp',
  },
  components: {
    blockTemplates: {
      title: 'Modelos',
      empty: 'Nenhum modelo corresponde',
      preview: 'Pré-visualizar',
      apply: 'Usar este modelo',
      viewAll: 'Ver todos os {count} modelos',
      search: 'Pesquisar modelo',
      selected: 'Selecionado',
      cancel: 'Cancelar',
      applyTemplate: 'Aplicar modelo',
    },
    quickAdd: {
      addLink: 'Adicionar link',
      addVideo: 'Adicionar vídeo',
      addProduct: 'Adicionar produto',
      addPost: 'Adicionar publicação',
      addArticle: 'Adicionar artigo',
      addPhoto: 'Adicionar foto',
      addMusic: 'Adicionar música',
      addFiles: 'Adicionar arquivos',
      addStory: 'Adicionar story',
    },
    emoji: {
      search: 'Buscar',
      clear: 'Limpar',
      notfound: 'Nenhum Emoji Encontrado',
      skintext: 'Escolha seu tom de pele padrão',
      categories: {
        search: 'Resultados da Busca',
        recent: 'Usados Frequentemente',
        smileys: 'Sorrisos e Emoções',
        people: 'Pessoas e Corpo',
        nature: 'Animais e Natureza',
        foods: 'Comida e Bebida',
        activity: 'Atividade',
        places: 'Viagem e Lugares',
        objects: 'Objetos',
        symbols: 'Símbolos',
        flags: 'Bandeiras',
        custom: 'Personalizado',
      },
      categorieslabel: 'Categorias de Emoji',
      skintones: {
        1: 'Tom de Pele Padrão',
        2: 'Tom de Pele Claro',
        3: 'Tom de Pele Médio-Claro',
        4: 'Tom de Pele Médio',
        5: 'Tom de Pele Médio-Escuro',
        6: 'Tom de Pele Escuro',
      },
    },
    blogPreviewModal: {
      title: 'Pré-visualização do Blog',
      notify: 'Notificar assinantes',
    },
    standAloneModal: {
      title: 'Pré-visualização do Link',
      save: 'Salvar',
      chooseLayout: 'Escolha um layout para seu link',
      linkSettings: 'Configurações do Link',
      linkSettingsSubtitle: 'Redirecionamento, aparência',
      whenVisitorsClicks: 'Quando um visitante clicar neste link:',
      redirect: 'Redirecionar',
      redirectText: 'Enviar visitantes diretamente para a URL',
      highlight: 'Destaque',
      highlightText: 'Enviar visitantes para seu UniLink e destacar',
      standalone: 'Independente',
      standaloneText: 'Destaque seu link do YouTube e reproduza o conteúdo diretamente no seu',
      cover: 'Capa',
      imageTab: 'Imagem',
      videoTab: 'Vídeo',
      uploadImage: 'Enviar imagem',
      whenVisitors: 'Quando um visitante selecionar o link compartilhado:',
      compact: 'Visualização compacta',
      fullView: 'Visualização completa',
      videoSound: 'Reproduzir vídeo com som',
    },
    instagramModal: {
      title: 'Enviar DMs automáticas no Instagram',
      subtitle: 'Envie este link via mensagem direta quando alguém comentar no seu post ou Reel do IG',
      promo: 'Escolha de qual IG você gostaria de enviar',
      connect: 'Conectar conta do Instagram',
      added: 'Conta do Instagram adicionada',
      addNew: 'Adicionar nova automação',
      igContent: 'Conteúdo do IG',
      trigger: 'Gatilho',
      dmContent: 'DM',
      linkDestination: 'Destino do Link',
      buttonTitle: 'Título do botão',
      buttonTitleTooltip: 'Insira o título do botão',
      directMessage: 'Mensagem direta',
      directMessageTooltip: 'Insira a mensagem direta',
      selectPosts: 'Selecione o post ou Reel que acionará sua DM automática.',
      onePost: 'Um post ou Reel específico',
      allPosts: 'Todos os posts ou Reels',
      triggerText: 'Quando os comentários incluírem isso, sua DM será enviada.',
      addMessage: 'Adicione uma mensagem para enviar automaticamente com seu link.',
      clickLink: 'Quando alguém clicar no link da sua DM:',
      anyComment: 'Qualquer comentário',
      storiesAndDms: 'Stories & DMs',
      anyMessage: 'Qualquer mensagem',
      specificKeywords: 'Comentários com palavras-chave específicas',
      sendLink: 'Enviar para seu UniLink e destacar ',
      skipLink: 'Pular UniLink e enviar diretamente',
      keywordsTitle: 'Comentários com palavras-chave específicas',
      keywordsText: 'Suas DMs serão enviadas quando os comentários incluírem ou excluírem\npalavras-chave específicas (sem distinção de maiúsculas e minúsculas):',
      keywordsPlaceholder: 'Digite uma palavra-chave',
      keywordsExclude: 'Excluir palavras-chave',
      keywordsExcludeText: 'Deve excluir qualquer uma destas',
      replyComment: 'Responder comentário',
      replyCommentTooltip: 'Insira a resposta ao comentário',
    },
    blockEditProduct: {
      productPreview: 'Pré-visualização do Produto',
      productDetails: 'Detalhes do Produto',
      settings: 'Configurações',
      design: 'Design',
    },
    editMenuItems: {
      overview: 'Visão Geral',
      analytics: 'Análises',
    },
    botToken: {
      bot: 'Bot',
      botTooltip: 'Insira o token do seu bot',
      connect: 'Conectar',
      token: 'Token',
    },
    rewards: {
      title: 'Título',
      titleTooltip: 'Insira o título para a resposta',
      text: 'Texto',
      textTooltip: 'Insira o texto para a resposta',
      link: 'Link',
      linkTooltip: 'Insira o link para a resposta',
      code: 'Código',
      codeTooltip: 'Insira o código para a resposta',
      files: 'Arquivos',
      filesTooltip: 'Insira os arquivos para a resposta',
      removeReward: 'Tem certeza de que deseja remover esta resposta?',
    },
    addRewardModal: {
      addReward: 'Adicionar Resposta',
      textTitle: 'Texto',
      textText: 'Dê acesso a instruções ou qualquer texto com Editor Rico',
      fileTitle: 'Arquivos',
      fileText: 'Dê acesso a arquivos e colete dados de contato',
      linkTitle: 'Link',
      linkText: 'Dê acesso a conteúdo exclusivo e colete dados de contato',
      codeTitle: 'Código',
      codeText: 'Dê acesso a promoções exclusivas e colete dados de contato',
    },
    blockEmpty: {
      isNotAdded: 'não foi adicionado',
      itSeems: 'Parece que seus',
      itemsNot: 'itens ainda não foram adicionados. Adicione seus vídeos agora',
      add: 'Adicionar',
    },
    blockList: {
      add: 'Adicionar',
      item: 'item',
    },
    submitAction: {
      action: 'Ação (após envio)',
      actionTooltip: 'Escolha uma ação após o envio',
      upload: 'Enviar anexos',
      none: 'Nenhum',
      page: 'Mostrar Página de Confirmação',
      email: 'Enviar E-mail de Confirmação',
      redirect: 'Redirecionar para URL',
    },
    blockEditItem: {
      content: 'Conteúdo',
      preview: 'Pré-visualizar',
      settings: 'Configurações',
    },
    domainButton: {
      customizeDomain: 'Personalize seu domínio.',
      upgradeToLink: 'Atualize para Link na Bio Pro e use um domínio personalizado.',
    },
    coverText: {
      text: 'Texto',
      textTooltip: 'Insira texto para sua capa',
      description: 'Descrição',
      descriptionTooltip: 'Insira a descrição para sua capa',
      textColor: 'Cor do texto',
    },
    itemModal: {
      edit: 'Editar',
      addNew: 'Adicionar novo',
      item: 'item',
      update: 'Atualizar',
      add: 'Adicionar',
    },
    productSheet: {
      openFullEditor: 'Abrir o editor completo',
      copyLink: 'Copiar link',
      active: 'Ativo',
      notActive: 'Inativo',
      statistics: 'Estatísticas',
      clicks: 'Cliques',
      sales: 'Vendas',
      revenue: 'Receita',
      onlyName: 'Apenas o nome é obrigatório',
      name: 'Nome',
      required: 'Obrigatório',
      price: 'Preço',
      optional: 'Opcional',
      free: 'Grátis',
      appearance: 'Aparência',
      cover: 'Capa',
      coverNote: 'Quadrada, a partir de 600×600. Pode adicionar depois.',
      description: 'Descrição',
      descriptionPlaceholder: 'Uma linha sobre o que está incluído',
      remove: 'Remover',
      photo: 'Foto',
      enterName: 'Escreva um nome',
      adding: 'Adicionando…',
    },
    viewDesign: {
      compact: 'Compacto',
      card: 'Cartão',
      button: 'Botão',
      list: 'Lista',
      hero: 'Hero',
      featured: 'Em destaque',
    },
    moveItemModal: {
      title: 'Mover item para outra página',
      cancel: 'Cancelar',
      move: 'Mover',
      page: 'Página',
      pageTooltip: 'Escolha uma página para mover o item',
      blocks: 'Blocos',
      blocksTooltip: 'Escolha um bloco para mover o item',
      emptyBlocks: 'Não há blocos necessários nesta página.',
    },
    limitModal: {
      title: 'Limite atingido',
      text1: 'Você atingiu o limite do seu site.',
      text2: 'Entre em contato conosco para atualizar seu plano.',
      close: 'Fechar',
    },
    cropPicture: {
      title: 'Recortar sua imagem',
      cancel: 'Cancelar',
      save: 'Salvar',
    },
    uploadFile: {
      uploadProductImage: 'Enviar imagem do produto',
      coverImage: 'Imagem de capa',
      uploadImages: 'Você só pode enviar imagens aqui',
    },
    userMediaLibrary: {
      addImage: 'Adicionar uma imagem',
      uploadImage: 'Enviar imagem',
      orSelectFrom: 'ou enviar',
      orSelectLink: 'ou colar link',
      myMedia: 'Minha Mídia',
      stockImages: 'Imagens de Banco',
      gifs: 'GIFs',
      icons: 'Ícones',
      noImagesYet: 'Sem imagens ainda',
      loadMore: 'Carregar mais',
    },
    itemMenu: {
      active: 'Ativo',
      willBeAvailable: 'O item estará disponível em:',
      save: 'Salvar',
      copied: 'Copiado',
      copyLink: 'Copiar link',
      delete: 'Excluir',
    },
    itemDesign: {
      linkColor: 'Cor do link',
      gradient: 'Gradiente',
      background: 'Fundo',
      backgroundOpacity: 'Opacidade do fundo',
      backgroundOpacityTooltip: 'Arraste o controle para definir a opacidade do fundo',
      backgroundDarkness: 'Escurecimento do fundo',
      backgroundDarknessTooltip: 'Arraste o controle para definir o escurecimento do fundo',
      text: 'Texto',
      color1: 'Cor 1',
      color2: 'Cor 2',
      direction: 'Direção',
      directionTooltip: 'Arraste o controle para definir a direção do gradiente',
      offset: 'Deslocamento',
      offsetTooltip: 'Arraste o controle para definir o deslocamento do gradiente',
      linkHeight: 'Altura do link',
      linkHeightTooltip: 'Arraste o controle para alterar a altura do botão',
      icon: 'Ícone',
      iconTooltip: 'Escolha o ícone para seu botão',
      imageShape: 'Forma da Imagem',
      imageShapeTooltip: 'Escolha a forma da imagem para seu link',
    },
    menu: {
      linkInBio: 'Link na bio',
      linkInBioApps: 'Link na Bio',
      posts: 'Publicações',
      audience: 'Público',
      orders: 'Pedidos',
      marketing: 'Marketing',
      emailMarketing: 'Email Marketing',
      socialPlanner: 'Planejador Social',
      shortLinks: 'Encurtador de Links',
      businessCards: 'Cartões de visita',
      recentProfiles: 'Perfis Recentes',
      standalonePage: 'Página Independente',
      soloApps: 'App na Bio',
      bots: 'Bots',
      smartReply: 'Instagram Reply',
      analytics: 'Análises',
      settings: 'Configurações',
      shop: 'Ganhar',
      publish: 'Publicar',
      studio: 'Estúdio',
      blog: 'Blog',
      qrCodes: 'Códigos QR',
      singlePages: 'Apps',
      forms: 'Formulários',
      form: 'Formulários',
      automations: 'Automações',
      community: 'Comunidade',
      messages: 'Caixa de Entrada',
      agents: 'Agentes',
      apps: 'Apps',
      emailSignatures: 'Assinaturas de e-mail',
      virtualBackgrounds: 'Fundos virtuais',
    },
    notificationsBlockSetting: {
      title: 'Notificações',
      setUp: 'Configurar',
      notifications: 'notificações',
      connect: 'Conectar',
      telegramText: 'Receba notificação no Telegram quando alguém fizer',
      change: 'alteração',
      email: 'E-mail',
      emailText: 'Receba um e-mail quando alguém fizer',
      webhook: 'Webhook',
      webhookTooltip: 'Adicionar webhook',
      activate: 'Ativar',
      webhookText: 'Enviar evento para site de terceiros quando alguém fizer',
      webhookURL: 'URL do Webhook (requisição POST)',
      error: 'Insira um link correto',
      save: 'Salvar',
    },
    navigation: {
      content: 'Conteúdo',
      pages: 'Páginas',
      posts: 'Publicações',
      shop: 'Loja',
      blog: 'Blog',
      design: 'Design',
      analytics: 'Análises',
      settings: 'Configurações',
      apps: 'Apps',
      store: 'Loja',
    },
    headerSettings: {
      design: 'Design',
      analytics: 'Análises',
      settings: 'Configurações',
      editTabs: 'Editar Abas',
    },
    unlockModal: {
      title: 'Desbloqueie Recursos Pro',
      text: 'Aproveite mais do seu link-in-bio. Apenas $5/mês — desbloqueie tudo que o Pro oferece:',
      checkBoxTitle1: 'Mais Blocos:',
      checkBoxText1: 'Adicione formulários, lojas, contagens regressivas e players de mídia',
      checkBoxTitle2: 'Análises Avançadas:',
      checkBoxText2: 'Acompanhe cliques, visualizações e insights do público',
      checkBoxTitle3: 'Domínio Personalizado:',
      checkBoxText3: 'Use seu próprio domínio para um visual profissional',
      checkBoxTitle4: 'Loja Integrada:',
      checkBoxText4: 'Venda produtos e gerencie pedidos com facilidade',
      checkBoxTitle5: 'Ferramentas SEO:',
      checkBoxText5: 'Melhore seu ranking com tags meta, UTM e slugs personalizados',
      checkBoxTitle6: 'Integrações:',
      checkBoxText6: 'Sincronize com Mailchimp, Zapier e outras ferramentas',
      checkBoxTitle7: 'Email Marketing:',
      checkBoxText7: 'Colete leads e envie campanhas automatizadas',
      checkBoxTitle8: 'Suporte Prioritário:',
      checkBoxText8: 'Obtenha ajuda mais rápida sempre que precisar',
      upgradeToPro: 'Atualizar para Pro',
      viewAllPlans: 'Ver todos os planos',
    },
    profileSwitcher: {
      title: 'Todos os Perfis',
      button: 'Adicionar um novo perfil',
    },
    account: {
      signOut: 'Sair',
      createNew: 'Criar um novo Link na Bio',
      tryPro: 'Experimente o Pro agora!',
      tryProText: 'Obtenha personalização avançada e insights mais profundos do público para conseguir mais visitantes!',
    },
    accountSettings: {
      title: 'Configurações da conta',
    },
    billingHistory: {
      title: 'Histórico de cobrança',
    },
    pages: {
      home: 'Início',
      newPage: 'Nova Página',
      managePages: 'Gerenciar Páginas',
    },
    blockItem: {
      actionRequired: 'ação necessária',
      hidden: 'Oculto · ninguém vê',
    },
    blockContent: {
      untitled: 'Sem título',
      clickToRename: 'Clique para renomear o subtítulo',
      saving: 'salvando',
      saved: 'salvo',
      deleteTitle: 'Tem certeza de que deseja excluir este bloco?',
      cancel: 'Cancelar',
      yes: 'Sim',
    },
    addButtonModal: {
      title: 'Adicionar um botão de ação',
      close: 'Fechar',
      added: 'Adicionado',
      add: 'Adicionar',
      messageTitle: 'Mensagem',
      messageText: 'O botão de mensagem permite que os usuários entrem em contato com você via mensageiro',
      subscribeTitle: 'Assinar',
      subscribeText: 'O botão de assinar permite que os usuários se inscrevam na sua lista de e-mail ou mensageiro',
      ctaTitle: 'Botão CTA',
      ctaText: 'CTA é uma chamada em um site que diz ao usuário para tomar uma ação específica',
      cartTitle: 'Carrinho',
      cartText: 'Exiba um ícone de carrinho de compras para indicar que os visitantes podem fazer compras no seu site',
      contactTitle: 'Contato',
      contactText: 'Permita que os visitantes acessem rapidamente suas informações de contato',
      qrcodeTitle: 'QR Code',
      qrcodeText: 'Exiba um QR code para que os visitantes possam escanear e compartilhar sua página rapidamente',
      languageTitle: 'Idioma',
      languageText: 'Permite que os visitantes mudem o idioma da sua página',
      searchTitle: 'Buscar',
      searchText: 'Permita que os visitantes pesquisem os produtos da sua loja direto no cabeçalho',
    },
    inputMask: {
      copyLink: 'Copiar link',
    },
    videoLibrary: {
      addVideo: 'Adicionar vídeo',
      myVideos: 'Meus Vídeos',
      stockVideos: 'Vídeos de Banco',
      pasteUrl: 'Colar URL',
      uploadVideo: 'Enviar Vídeo',
    },
    createBlockModal: {
      searchTitle: 'Escolha um bloco para sua página',
      title: 'Adicionar ao UniLink',
      contentTitle: 'Conteúdo',
      contentText: 'Crie e gerencie sua página',
      growTitle: 'Leads',
      growText: 'Colete leads e aumente o engajamento',
      monetizeTitle: 'Monetizar',
      monetizeText: 'Venda produtos, conteúdo e serviços',
      monetizationTitle: 'Ganhe e colete dinheiro',
      monetizationText: 'Venda produtos, serviços e colete gorjetas',
      socialTitle: 'Conteúdo de redes sociais',
      socialText: 'Compartilhe conteúdo de redes sociais no seu UniLink',
      toolsTitle: 'Ferramentas de crescimento',
      toolsText: 'Cresça, gerencie e conecte-se com seu público',
      search: 'Buscar',
      all: 'Todos',
      allCategories: 'Todas as categorias',
      content: 'Conteúdo',
      monetization: 'Monetização',
      social: 'Social',
      tools: 'Ferramentas',
      header: 'Cabeçalho',
      headerText: 'Adicione uma foto de perfil e bio',
      link: 'Links',
      linkText: 'Selecione o layout do link',
      text: 'Texto',
      textText: 'Selecione o layout do texto',
      videos: 'Vídeos',
      videosText: 'Selecione o tipo de vídeo',
      image: 'Imagem',
      imageText: 'Adicione blocos de imagem',
      music: 'Música',
      musicText: 'Selecione o tipo de música',
      socialFeeds: 'Feeds Sociais',
      socialFeedsText: 'Selecione o tipo de feed social',
      moreContent: 'Mais',
      moreContentText: 'Adicione mais blocos de conteúdo',
      dataCollect: 'Coleta de Dados',
      dataCollectText: 'Selecione o tipo de coleta de dados',
      form: 'Formulário',
      formText: 'Selecione o tipo de formulário',
      conversionTools: 'Ferramentas de engajamento',
      conversionToolsText: 'Adicione blocos de conversão',
      products: 'Produtos',
      productsText: 'Adicione blocos de produtos',
      donation: 'Gorjetas e Doações',
      tipsAndDonations: 'Gorjetas e Doações',
      tipsDonationsText: 'Blocos de gorjetas e doações',
      event: 'Evento',
      eventText: 'Selecione o tipo de evento',
      quickAdd: 'Todos os blocos',
      quickAddText: 'Adicionar qualquer bloco',
    },
    addBlockModal: {
      title: 'Adicionar ao UniLink',
      dragToAdd: 'Arraste para adicionar',
      contentTitle: 'Compartilhar conteúdo básico',
      contentText: 'Compartilhe conteúdo diretamente no seu UniLink',
      monetizationTitle: 'Ganhe e colete dinheiro',
      monetizationText: 'Venda produtos, serviços e colete gorjetas',
      socialTitle: 'Conteúdo de redes sociais',
      socialText: 'Compartilhe conteúdo de redes sociais no seu UniLink',
      toolsTitle: 'Ferramentas de crescimento',
      toolsText: 'Cresça, gerencie e conecte-se com seu público',
      search: 'Buscar',
      searchPlaceholder: 'Buscar conteúdo...',
      all: 'Todos',
      allCategories: 'Todas as categorias',
      content: 'Conteúdo',
      monetization: 'Monetização',
      social: 'Social',
      tools: 'Ferramentas',
      suggestTitle: 'Sugira o seu bloco',
      suggestText: 'Falta um bloco? Diga-nos o que gostaria de ver',
      suggestModalTitle: 'Sugerir um bloco',
      suggestModalSubtitle: 'Descreva o bloco que gostaria que a UniLink tivesse. Lemos todas as ideias.',
      suggestPlaceholder: 'ex.: Um bloco de reservas com sincronização com o Google Calendar…',
      suggestSubmit: 'Enviar sugestão',
      suggestSending: 'A enviar…',
      suggestSuccessTitle: 'Sugestão enviada!',
      suggestSuccess: 'Obrigado! Lemos todas as ideias e usamo-las para definir o roteiro.',
      suggestError: 'Não foi possível enviar. Tente novamente.',
    },
    tabNavigation: {
      tabView: 'Visualização das abas',
      tabViewTooltip: 'Selecione a visualização das abas para navegação',
      colors: 'Cores',
      colorsTooltip: 'Escolha as cores das publicações e botões',
      tabs: 'Abas',
      tabsTooltip: 'Escolha as abas exibidas na navegação do site',
      content: 'Conteúdo',
      posts: 'Publicações',
      store: 'Loja',
      shop: 'Loja',
      tabsSettings: 'Configurações de navegação por abas',
    },
    hideLogo: {
      text: 'Mostrar logo UniLink no rodapé da sua página.',
      text2: 'Mostrar logo UniLink no rodapé da sua página.',
    },
    palettePreview: {
      custom: 'Cor de Fundo Personalizada',
      hexColor: 'Cor hexadecimal',
      hexColorTooltip: 'Insira a cor hexadecimal da sua pré-visualização',
    },
    backgroundVideo: {
      insert: 'Inserir URL',
      upload: 'Enviar vídeo',
      search: 'Buscar vídeo',
    },
    periodDropdown: {
      today: 'Hoje',
      yesterday: 'Ontem',
      last7days: 'Últimos 7 dias',
      last30days: 'Últimos 30 dias',
      allTime: 'Todo o período',
      custom: 'Personalizado',
    },
    subsections: {
      content: 'Conteúdo',
      design: 'Design',
      settings: 'Configurações',
    },
    wrapperSettings: {
      lock: 'Atualizar para Plano PRO',
    },
    shareModal: {
      addSocials: 'Adicionar às Redes Sociais',
      shareTo: 'Compartilhar em',
      qrCode: 'QR code',
      customizeUrl: 'Personalizar URL',
      goToMy: 'Ir para meu',
      print: 'Você pode imprimir seu QR code exclusivo em',
      cards: 'cartões de visita e folhetos',
      download: 'Baixar',
      copy: 'Copiar',
      previewMobile: 'Pré-visualizar no celular',
      scanMobilePreview: 'Escaneie o QR code no seu celular para pré-visualizar seu site',
      types: {
        socials: 'redes sociais',
        shareTo: 'compartilhar',
        qrCode: 'QR',
        title: 'Compartilhe seu UniLink',
        titleSocials: 'Adicione UniLink às suas redes sociais',
        titleShareTo: 'Compartilhar em...',
        titleQRCode: 'QR Code',
        titlePreviewMobile: 'Pré-visualizar no Celular',
      },
      socialList: {
        instagramText: 'Adicione seu UniLink ao seu perfil do Instagram. Simplesmente copie sua URL UniLink, vá em Editar Perfil e cole no campo Site.',
        facebookText:
          'Adicione seu UniLink ao seu perfil do Facebook. Simplesmente copie sua URL UniLink, vá à página Sobre no seu perfil, clique em Informações de contato e básicas, depois clique em + Adicionar um site, cole sua URL UniLink no campo Endereço do site e clique em Salvar.',
        tikTokText:
          'Adicione seu UniLink ao seu perfil do Facebook. Simplesmente copie sua URL UniLink, vá à página Sobre no seu perfil, clique em Informações de contato e básicas, depois clique em + Adicionar um site, cole sua URL UniLink no campo Endereço do site e clique em Salvar.',
        twitchText:
          'Adicione seu UniLink ao seu canal Twitch. Simplesmente copie sua URL UniLink, vá ao seu canal Twitch, clique em Sobre, depois clique em Editar sobre e configurações de links, role até Links Sociais, adicione UniLink no primeiro campo de texto e cole sua URL UniLink no segundo campo de texto, depois clique em Adicionar.',
        youTubeText:
          'Adicione seu UniLink ao seu canal do YouTube. Simplesmente copie sua URL UniLink, vá ao seu canal do YouTube, clique em Personalizar Canal, depois clique em Informações básicas e, em Links, adicione um título de link e cole sua URL UniLink no campo URL, depois clique em Publicar.',
        linkedInText:
          'Adicione seu UniLink ao seu perfil do LinkedIn. Simplesmente copie sua URL UniLink, vá ao seu perfil do LinkedIn, clique no ícone de lápis, role até Informações de contato, cole sua URL UniLink no campo URL do site e clique em Aplicar.',
        pinterestText:
          'Adicione seu UniLink ao seu perfil do Pinterest. Simplesmente copie sua URL UniLink, vá às suas configurações do Pinterest, cole sua URL UniLink no campo URL do site e clique em Salvar.',
        twitterText:
          'Adicione seu UniLink ao seu perfil do Twitter. Simplesmente copie sua URL UniLink, vá ao seu perfil, clique em Editar Perfil e cole sua URL UniLink no campo Site.',
      },
      share: {
        shareFacebook: 'Compartilhar no Facebook',
        shareLinkedIn: 'Compartilhar no LinkedIn',
        shareTwitter: 'Compartilhar no Twitter',
        shareWhatsApp: 'Compartilhar via WhatsApp',
        shareMessenger: 'Compartilhar via Messenger',
        shareEmail: 'Compartilhar via E-mail',
      },
    },
  },
  popupMenu: {
    edit: 'Editar página',
    openInNewTab: 'Abrir em nova aba',
    copyLink: 'Copiar URL',
    delete: 'Excluir',
    showThumbnail: 'Mostrar miniaturas das páginas no painel',
    manageTabs: 'Gerenciar Abas',
  },
  tabsDashboard: {
    labelAddNewTab: 'Nova Aba',
  },
  blocks: {
    header: {
      blockTitle: 'Cabeçalho',
      blockText: 'Personalize sua foto de perfil, adicione uma bio curta e atualize seus ícones sociais',
      blockShortText: 'Personalize seu perfil',
      layout: 'Layout',
      layoutTooltip: 'Crie o layout de cabeçalho que desejar',
      layoutAlign: 'Alinhamento do layout',
      layoutAlignTooltip: 'Alinhar texto',
      profilePicture: 'Foto do perfil',
      profilePictureTooltip: 'Altere sua foto do perfil',
      pictureSize: 'Tamanho da foto',
      pictureSizeTooltip: 'Você pode alterar o tamanho da foto',
      pictureHeight: 'Altura da foto',
      pictureHeightCaption: 'Você pode alterar a altura da foto',
      preview: 'Pré-visualizar',
      badge: 'Selo',
      badgeTooltip: 'Adicionar um selo verificado ao cabeçalho',
      tags: 'Tags',
      tagsTooltip: 'Mostrar tags de categoria abaixo do seu nome (até 5)',
      tagsAdd: 'Adicionar tags',
      addTags: '+ Adicionar tags',
      tagsEdit: 'Editar tags',
      tagsCustomPlaceholder: 'Adicionar tag personalizada',
      tagsCustomAdd: 'Adicionar',
      tagsSuggested: 'Categorias sugeridas',
      tagsSelected: 'Selecionadas',
      tagsEmpty: 'Ainda sem tags — escolha das sugestões ou adicione as suas',
      tagsLimit: 'Máx. 5 tags',
      visibility: 'Visibilidade',
      visibilityTooltip: 'Mostrar ou ocultar a foto do perfil',
      cover: 'Capa',
      coverTooltip: 'Adicionar imagem ou vídeo à capa do cabeçalho',
      addCover: 'Adicionar capa',
      image: 'Imagem',
      video: 'Vídeo',
      positionCover: 'Posição do texto e botão',
      positionCoverTooltip: 'Arraste o controle para alterar a posição',
      buttons: 'Botões',
      block: 'Bloco',
      videoProcessing: 'Processamento de vídeo',
      vibe: 'Vibe',
      vibeTooltip: 'Adicione sua vibe',
      stories: 'Stories',
      storiesTooltip: 'Adicione seus stories',
      addStory: 'Adicionar story',
      storiesSubtitle: 'Adicione imagem ou vídeo aos seus stories',
      subscribeMethod: 'Método de assinatura',
      subscribeMethodTooltip: 'Escolha seu método de assinatura',
      subscribeLink: 'Link de assinatura',
      subscribeLinkTooltip: 'Copie seu link de assinatura',
      minWidth: 'Largura mínima',
      addVCard: 'Adicionar vCard',
      vCard: 'vCard',
      vCardTooltip: 'Você pode adicionar informações sobre você',
      buttonInline: 'Botão inline no cabeçalho',
      buttonInsideContact: 'Botão dentro do botão Contato',
      showSaveContact: 'Exibir salvar contato',
      options: 'Opções',
      showBusinessCard: 'Mostrar cartão de visita',
      showBusinessCardCaption: 'Adiciona um botão «Salvar contato» aqui.',
      editBusinessCard: 'Editar cartão',
      editContactDetails: 'Editar dados de contato em Business cards',
      needAddContact: 'Você precisa adicionar o botão Contato',
      socialGap: 'Espaçamento',
      socialGapCaption: 'Você pode alterar o espaçamento',
      socialSize: 'Tamanho',
      socialSizeCaption: 'Você pode alterar o tamanho',
      icons: 'Ícones',
      iconsTooltip: 'Adicionar ícone ao botão',
      bottomButtonsSettings: 'Botões inferiores',
      bottomButtonsLayout: 'Disposição',
      bottomButtonsRow: 'Lado a lado',
      bottomButtonsColumn: 'Empilhados',
      cropMismatch: 'Esta foto está recortada para outra disposição.',
      adjustCrop: 'Ajustar recorte',
      photoShapeLabel: 'Forma da foto',
      photoShapeTooltip: 'Escolhe se esta disposição mostra a foto quadrada ou um recorte vertical.',
      photoShapeSquare: 'Quadrada',
      photoShapeVertical: 'Vertical',
      coverShape: 'Forma da capa',
      coverShapeTooltip: 'Escolha a borda inferior da capa: reta, curvada para baixo ou para cima.',
      coverShapeStraight: 'Reta',
      coverShapeArcDown: 'Arco para baixo',
      coverShapeArcUp: 'Arco para cima',
      avatarOffsetLabel: 'Posição do avatar',
      avatarOffsetTooltip: 'Desloque o avatar para cima ou para baixo em relação à borda da capa.',
      photoStyleProTitle: 'Desbloqueia estilos de foto avançados',
      photoStyleProDesc: 'Sem fundo e Texto atrás são funcionalidades PRO.',
      photoShapeCustom: 'Personalizada',
      sliderStyleLabel: 'Estilo do slider',
      sliderStyleTooltip: 'Deslizar mostra uma foto de cada vez; Galeria mostra uma fila de miniaturas — toca numa miniatura para trocar a foto principal.',
      sliderStyleSwipe: 'Deslizar',
      sliderStyleGallery: 'Galeria',
      photoPositionLabel: 'Posição da foto',
      photoPositionHint: 'Enquadramento vertical',
      verticalCropHint: 'Esta disposição mostra a foto original. Escolhe a área vertical que queres apresentar.',
      verticalCropReady: 'Afina a área vertical mostrada nesta disposição.',
      pickVerticalArea: 'Escolher área vertical',
      photoStyle: 'Estilo da foto',
      photoStyleTooltip: 'Mostra a foto tal como está, com o fundo removido, ou coloca texto atrás do sujeito.',
      avatarModeOriginal: 'Original',
      avatarModeCutout: 'Sem fundo',
      avatarModeLayered: 'Texto atrás',
      overlayText: 'Texto',
      overlayTextPlaceholder: 'O teu nome (predefinição)',
      overlayColor: 'Cor do texto',
      overlaySize: 'Tamanho',
      overlayY: 'Posição vertical',
      overlayEffect: 'Animação',
      overlayEffectNone: 'Nenhuma',
      overlayEffectShimmer: 'Brilho',
      overlayEffectGlow: 'Luminosidade',
      overlayEffectGradient: 'Gradiente',
      overlayEffectSparkle: 'Cintilação',
      overlayUsesName: 'Nesta disposição o texto é o teu nome de perfil — aparece atrás de ti. Edita-o na secção “Nome”.',
      cutoutGenerate: 'Gerar recorte',
      cutoutRegenerate: 'Gerar novamente',
      cutoutUpload: 'Carregar',
      cutoutOr: 'ou',
      cutoutGenerating: 'A gerar...',
      cutoutUploading: 'A carregar...',
      cutoutVideoHint: 'A remoção de fundo funciona apenas com fotos de imagem, não com vídeo.',
      cutoutTimeout: 'A remoção de fundo está a demorar demasiado. Tenta novamente.',
      profileBadges: 'Distintivos',
      profileBadgesTooltip: 'Escolhe até 3 distintivos para mostrar junto ao teu nome',
      profileBadgesProLockHint: 'Faz upgrade para PRO para usar este distintivo',
      profileBadgesAdd: 'Adicionar distintivos',
      profileBadgesManage: 'Gerir distintivos',
      profileBadgesModalTitle: 'Adiciona distintivos ao teu perfil',
      profileBadgesModalSubtitle: 'Mostra as tuas conquistas e reconhecimentos.',
      profileBadgesCustomCta: 'Carrega o teu próprio distintivo',
      profileBadgesCustomDesc: 'O teu distintivo personalizado',
      profileBadgesCustomName: 'Nome do distintivo',
      profileBadgesCustomChoose: 'Escolher imagem',
      profileBadgesCustomChange: 'Alterar imagem',
      profileBadgesCustomUploading: 'A carregar…',
      profileBadgesCustomAdd: 'Adicionar distintivo',
      ribbonLabel: 'Faixa decorativa',
      ribbonLabelTooltip: 'Adiciona uma barra de cor abaixo do cabeçalho',
      addTint: 'Adicionar faixa',
      ribbonTitle: 'Faixa',
      ribbonText: 'Texto da faixa',
      ribbonTextPlaceholder: 'ex.: 20% de desconto até ao fim do mês',
      ribbonColor: 'Cor da faixa',
      ribbonTheme: 'Estilo',
      ribbonThemes: {
        none: 'Sem decoração',
        birthday: 'Aniversário',
        newyear: 'Ano Novo',
        valentine: 'Dia dos Namorados',
        halloween: 'Halloween',
        summer: 'Verão',
      },
      ribbonEffect: 'Efeito',
      ribbonEffects: {
        none: 'Nenhum',
        gradient: 'Gradiente animado',
        shimmer: 'Brilho',
        lights: 'Luzes de fio',
      },
      ribbonPosition: 'Posição',
      ribbonPositions: {
        bottom: 'Abaixo do cabeçalho',
        underPhoto: 'Sob a foto',
      },
      ribbonRemove: 'Remover faixa',
      statusBadges: 'Atividade',
      statusBadgesTooltip: 'Mostra atividade em tempo real na tua página',
      addStatus: 'Adicionar atividade',
      statusDisabledHint: 'Oculto · desativado',
      followersTitle: 'Seguidores',
      followersCounter: 'Contador de seguidores',
      followersTooltip: 'Mostra o número total de seguidores das tuas contas sociais ligadas',
    },
    text: {
      blockTitle: 'Texto',
      blockText: 'Bloco de texto geral para escrever o que quiser. Você pode formatar seu texto com o editor WYSIWYG',
      blockShortText: 'Bloco de texto geral',
      title: 'Título',
      titleText: 'Personalize o tamanho do seu título',
      orderOfElements: 'Ordem dos elementos',
      orderOfElementsTooltip: 'Arraste o controle para alterar a ordem dos elementos',
      changeOrder: 'Alterar ordem',
      text: 'Texto',
      content: 'Conteúdo',
      image: 'Imagem',
      button: 'Botão',
      addButtons: 'Adicionar mais botões',
      renameTabHint: 'Renomear aba',
      addElement: 'Adicionar elemento',
      showFullText: 'mostrar por completo',
      displayedContent: 'Conteúdo exibido',
      displayedContentTooltip: 'Mostrar ou ocultar conteúdo',
      buttonLayout: 'Layout do botão',
      buttonLayoutTooltip: 'Escolha disposição vertical ou horizontal dos botões',
    },
    timeline: {
      blockTitle: 'Linha do tempo',
      blockText: 'Exiba uma linha do tempo vertical com eventos. Cada evento pode ter data/hora, título, descrição e imagem opcional',
      blockShortText: 'Exibir linha do tempo de eventos',
      editItem: 'Editar evento',
      title: 'Título',
      titlePlaceholder: 'Título do evento',
      subtitle: 'Subtítulo',
      subtitlePlaceholder: 'Cargo ou afiliação (opcional)',
      description: 'Descrição',
      descriptionPlaceholder: 'Descrição do evento (opcional)',
      startTime: 'Hora de início',
      endTime: 'Hora de término',
      startDate: 'Data de início',
      endDate: 'Data de término',
      showEndDate: 'Mostrar data de término',
      showEndDateTooltip: 'Desative para eventos em andamento (ex.: "trabalhando aqui desde 2023")',
      includeTime: 'Incluir horário',
      includeTimeTooltip: 'Se desativado, apenas a data será exibida, sem o horário',
      image: 'Imagem',
      imagePlaceholder: 'Envie um avatar ou ícone',
      imageUploadFailed: 'Não foi possível enviar a imagem. Use Minha Mídia ou cole um link.',
      untitled: 'Sem título',
      listLayout: 'Layout em lista',
      lineColor: 'Cor da linha',
    },
    trust: {
      blockTitle: 'Confiança',
      blockShortText: 'Compartilhe suas parcerias',
      blockText: 'Coloque todas as suas conexões em um só lugar.',
      titleText: 'Personalize o tamanho do seu título',
      orderOfElements: 'Ordem dos elementos',
      orderOfElementsTooltip: 'Arraste o controle para alterar a ordem dos elementos',
      changeOrder: 'Alterar ordem',
      text: 'Texto',
      content: 'Conteúdo',
      image: 'Imagem',
      button: 'Botão',
      displayedContent: 'Conteúdo exibido',
      displayedContentTooltip: 'Mostrar ou ocultar conteúdo',
      enterTrustLink: 'Insira a URL do Parceiro',
      enterTrustLinkTooltip: 'Cole a URL do Parceiro',
      enterPartnerName: 'Insira o nome do parceiro',
      enterPartnerUrl: 'https://www.seuParceiro.com/',
      enterDescription: 'Insira a descrição (opcional)',
      partnerLogo: 'Logo do Parceiro',
      uploadPartnerLogo: 'Envie o logo do seu parceiro',
    },
    link: {
      blockTitle: 'Links',
      blockText: 'Direcione tráfego para seu site, blog, loja online ou qualquer outra página da web',
      blockShortText: 'Direcione tráfego para o site',
      addLink: 'Adicionar link',
      addNewLink: 'Adicionar novo link',
      restrictedTitle: 'Os links do {platform} são um recurso PRO',
      restrictedText: 'Adicionar links do {platform} está disponível no plano PRO. Faça upgrade do seu plano para adicionar este link à sua página.',
      upgradeToPro: 'Atualizar para PRO',
      showMore: 'Mostrar mais',
      showLess: 'Mostrar menos',
      viewArchive: 'Ver arquivo',
      archivedLinks: 'Links arquivados',
      noArchivedLinks: 'Mantenha seu painel de links limpo e organizado arquivando links que não está usando no momento.',
      archiveAllUnpublished: 'Arquivar todos os links não publicados',
      addFormExisting: 'Adicionar de links existentes',
      addYourLink: 'Adicione seu link ao grupo',
      add: 'Adicionar',
      otherTypes: 'Tipo de ação',
      link: 'Link',
      navigate: 'Navegar',
      navigateTo: 'Ir para',
      scrollBlock: 'Scroll to',
      copyText: 'Copy Text',
      navigatePage: 'Página',
      navigateProduct: 'Produto',
      navigateBlock: 'Bloco',
      modal: 'Modal',
      showModal: 'Mostrar Modal',
      modalBlock: 'Mostrar Bloco',
      modalItem: 'Mostrar Item',
      modalCustom: 'Personalizado',
      document: 'Documento',
      privat24: 'Privat24',
      phone: 'Ligação Telefônica',
      viber: 'Abrir Viber',
      skype: 'Abrir Skype',
      email: 'Enviar E-mail',
      discount: 'Desconto',
      smartLink: 'Link Inteligente',
      mobileApp: 'Deep Link',
      enterURL: 'Inserir URL',
      enterPrivat: 'Insira seu cartão do Privat Bank',
      enterPhone: 'Insira o número de telefone',
      enterViber: 'Insira o número do Viber',
      enterSkype: 'Insira o Skype',
      enterEmail: 'Insira o e-mail',
      enterTitle: 'Insira o título',
      enterCopyText: 'Insira o texto a copiar',
      enterPromoCode: 'Insira o código promocional',
      group: 'Criar Grupo',
      content: 'Conteúdo',
      links: 'Links',
      heading: 'Título',
      settings: 'Configurações',
      thumbnail: 'Miniatura',
      typeTooltip: '  O clique abrirá este link',
      title: 'Título',
      titleTooltip: 'Nome do seu link',
      description: 'Descrição',
      descriptionTooltip: 'Descrição opcional de características, tipos, cor, tamanhos do link, etc.',
      label: 'Rótulo',
      labelTooltip: 'Adicionar nome do rótulo',
      button: 'Botão',
      buttonTooltip: 'Adicionar nome do botão',
      buttonText: 'Texto do botão',
      buttonTextTooltip: 'Nome do seu botão',
      buttonUrl: 'URL do botão',
      buttonUrlTooltip: 'Insira a URL do botão',
      addLinkToGroup: 'Adicionar link ao grupo',
      removeFromGroup: 'Remover do grupo',
      deletePermanently: 'Excluir Permanentemente',
      image: 'Imagem',
      buttonBg: 'Fundo do botão',
      postPreview: 'Pré-visualização da Publicação',
      separatorType: 'Tipo de separador',
      separatorTypeTooltip: 'Adicionar tipo de separador ao seu botão',
      section: 'Seção',
      sectionTooltip: 'Seção do link',
      descriptionSeparator: 'Descrição',
      descriptionSeparatorTooltip: 'Descrição opcional da seção',
      sectionText: 'Texto da seção',
      linkInstant: 'Encaminhamento instantâneo do link',
      spotlight: 'Destacar o link',
      addEffect: 'Adicionar efeito especial',
      countdown: 'Contagem regressiva',
      countdownTimer: 'Temporizador de contagem regressiva',
      countdownText: 'Adicione uma contagem regressiva ao vivo para quando seu link se tornar clicável',
      chooseDate: 'Escolher data',
      chooseDateTooltip: 'Escolha a data para seu link',
      chooseAction: 'Escolher ação',
      chooseActionTooltip: 'Escolha a ação para seu link',
      addCountdown: 'Adicionar contagem regressiva para o link',
      scheduler: 'Agendador',
      schedule: 'Agendar',
      scheduleText: 'Escolha uma data e hora no futuro para seu link ser ativado',
      activateOn: 'Ativar em',
      activateOnTooltip: 'Escolher data',
      deactivateOn: 'Desativar em',
      deactivateOnTooltip: 'Escolher data',
      addSchedule: 'Adicionar agendamento para',
      scheduleError: 'A data final não pode ser anterior à data inicial e a data inicial não pode estar no passado.',
      scheduleErrorPast: 'A data de ativação não pode estar no passado.',
      scheduleErrorPastDeactivate: 'A data de desativação não pode estar no passado.',
      scheduleErrorOrder: 'A data de desativação deve ser posterior à data de ativação.',
      activatesIn: 'Ativa em',
      deactivatesIn: 'Desativa em',
      lock: 'Bloqueio',
      lockText: 'Os visitantes só podem acessar este link cumprindo um dos critérios.',
      lockCode: 'Código',
      lockCodeTitle: 'Código para desbloquear este link',
      lockCodeText: 'Os visitantes precisam inserir um código de 4 dígitos para desbloquear este link',
      lockSubscribe: 'Assinar',
      lockSubscribeTitle: 'Os visitantes devem assinar seu UniLink para desbloquear o link.',
      lockSubscribeText: 'O bloqueio foi configurado com sucesso.',
      lockPayment: 'Pagamento',
      lockPaymentText: 'O bloqueio foi configurado com sucesso.',
      price: 'Preço',
      priceTooltip: 'Adicione o preço do seu produto',
      lockAge: 'Data de nascimento (Idade)',
      lockAgeTitle: 'Definir idade mínima',
      lockAgeText: 'Os visitantes precisam ter mais de uma certa idade para desbloquear o link com sua data de nascimento',
      lockAgeAlert: 'O bloqueio foi configurado com sucesso.',
      lockSensitive: 'Conteúdo sensível',
      lockSensitiveText: 'Os visitantes devem reconhecer que este link pode conter conteúdo inadequado para todos os públicos.',
      makeLink: 'Tornar link pagável',
      addLock: 'Adicionar bloqueio para o link',
      save: 'Salvar',
      clear: 'Limpar',
      buttonColor: 'Cor do botão',
      labelColor: 'Cor do rótulo',
      background: 'Fundo',
      imageHeight: 'Altura da imagem',
      imageHeightTooltip: 'Arraste o controle para alterar a altura da imagem',
      buttonMinimum: 'Altura mínima',
      buttonMinimumTooltip: 'Arraste o controle para alterar a altura do botão',
      textPosition: 'Posição do texto',
      textPositionTooltip: 'Escolha a posição vertical do texto',
      preview: 'pré-visualizar',
      defaultDesign: 'Design padrão',
      defaultDesignTooltip: 'Configurar design padrão para links',
      defaultDesignTitle: 'Observe que este design será aplicado a todos os links.',
      defaultDesignText: 'Você pode alterar o design padrão do link',
      changeDefault: 'Alterar padrão',
      applyDefault: 'Aplicar padrão',
      scheduled: 'Agendado',
      scheduledVisible: 'O link agendado agora está visível',
      scheduledHidden: 'O link agendado agora está oculto',
      linkClickable: 'Link clicável em',
      linkDisable: 'Link desativado em',
      lockedBy: 'Bloqueado por',
      items: 'Itens',
      doNotAnyLinks: 'Você ainda não tem nenhum link',
      sublinks: 'Sublinks',
      layout: 'Layout',
      layoutTooltip: 'Escolha o layout de sublinks que desejar',
      hideGroupLink: 'Ocultar link do grupo',
      rules: 'Regras',
      rulesText: 'Altere a visibilidade deste link com base em quem visita a sua página.',
      rulesEmpty: 'Ainda não há condições. Adicione uma condição para controlar quem vê este link.',
      rulesAddCondition: 'Adicionar condição',
      rulesActive: 'Regras de visibilidade',
      rulesIf: 'Se',
      rulesThen: 'Então',
      ruleTypeLocation: 'Localização',
      ruleTypeDevice: 'Dispositivo',
      ruleTypeTime: 'Dia e hora',
      ruleOperatorIs: 'é',
      ruleOperatorIsNot: 'não é',
      ruleActionHide: 'Ocultar link',
      ruleActionShow: 'Mostrar link',
      ruleSelectLocations: 'Selecionar localizações',
      ruleSearchLocations: 'Pesquisar países…',
      ruleFrom: 'De',
      ruleTo: 'Até',
      ruleAnyTime: 'Qualquer',
    },
    'data-collect': {
      blockTitle: 'Coleta de dados',
      blockText: 'Colete e-mails ou números de telefone dos seus visitantes',
      blockShortText: 'Coletar e-mails',
      maxSize: 'Você pode adicionar no máximo 3 canais',
      customTerms: 'Termos personalizados',
      customTermsTooltip: 'Adicionar termos personalizados ao seu formulário',
      termsConditions: 'Termos e Condições',
      text: 'Texto',
      subscribe: 'Assinar',
      title: 'Título',
      titleTooltip: 'Insira o título para os termos e condições',
      titleResultTooltip: 'Insira o título para seu envio',
      url: 'URL',
      urlTooltip: 'Insira a URL',
      editItem: 'Editar item',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Insira o texto do placeholder',
      button: 'Botão',
      buttonTooltip: 'Texto que motivará o visitante a inserir o e-mail (10% de desconto, assine agora, baixar arquivo etc.)',
      successMessage: 'Mensagem de sucesso',
      successMessageTooltip: 'Mensagem de sucesso dos seus assinantes',
      botURL: 'URL do Bot (opcional)',
      botURLTooltip: 'Insira a URL do seu bot',
      botToken: 'Token do Bot',
      botTokenTooltip: 'Insira o token do seu bot',
      rewards: 'Respostas',
      rewardsTooltip: 'Adicionar respostas dos seus assinantes',
      addReward: 'Adicionar resposta',
      thankYou: 'Mensagem de agradecimento',
      email: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta para o E-mail',
        redirect: 'Redirecionar para URL',
      },
      phone: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta para o Telefone',
        redirect: 'Redirecionar para URL',
      },
      telegram: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta no bot do Telegram',
        redirect: 'Redirecionar para URL',
      },
      whatsapp: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta no bot do WhatsApp',
        redirect: 'Redirecionar para URL',
      },
      instagram: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta no bot do Instagram',
        redirect: 'Redirecionar para URL',
      },
      messenger: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta no bot do Messenger',
        redirect: 'Redirecionar para URL',
      },
      viber: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta no bot do Viber',
        redirect: 'Redirecionar para URL',
      },
      connect: 'Conectar',
      toChangeReward: 'Para alterar o tipo de resposta, você deve remover o atual',
      remove: 'Remover',
      viewTypes: 'Tipos de Visualização',
    },
    form: {
      blockTitle: 'Formulário',
      blockText: 'Permite capturar informações e dados do seu público',
      blockShortText: 'Capturar informações',
      fields: 'Campos',
      fieldsTooltip: 'Adicionar campos ao formulário',
      addCustomField: 'Adicionar campo personalizado',
      addItem: 'Adicionar item',
      editItem: 'Editar item',
      type: 'Tipo',
      typeTooltip: 'Escolha o tipo de campo',
      string: 'Resposta curta',
      textarea: 'Resposta longa',
      dropdown: 'Dropdown',
      radio: 'Radio',
      checkbox: 'Checkbox',
      date: 'Data',
      time: 'Hora',
      country: 'País',
      file: 'Envio de arquivo',
      rating: 'Avaliação',
      submissionsClosed: 'Parar de aceitar envios',
      submissionsClosedTooltip: 'O formulário dá lugar a um aviso curto. As respostas já recebidas permanecem.',
      closedTitle: 'Título de encerramento',
      closedText: 'Mensagem de encerramento',
      templates: {
        contact: 'Formulário de contato',
        contactCaption: 'Uma frase, os campos e um botão — o formulário que as pessoas esperam',
        steps: 'Em etapas',
        stepsCaption: 'Duas perguntas por tela com barra de progresso. Um formulário longo deixa de parecer longo',
        upload: 'Envio de arquivo',
        uploadCaption: 'A área de envio primeiro — para artes, briefings e documentos',
        schedule: 'Dia e horário',
        scheduleCaption: 'Escolha um dia e um horário e deixe o nome',
        rating: 'Avaliação e comentários',
        ratingCaption: 'Estrelas, alguns temas para tocar e um campo de comentário',
        card: 'Clássico',
        cardCaption: 'O formulário simples: campos empilhados na página, botão abaixo',
        button: 'Botão com pop-up',
        buttonCaption: 'Um botão na página; o formulário abre num pop-up',
      },
      fieldName: 'Nome do Campo',
      fieldNameTooltip: 'Insira o nome do campo',
      name: 'Nome',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Insira o texto do placeholder',
      required: 'Obrigatório',
      requiredTooltip: 'Marque se o campo é obrigatório',
      value: 'Valor',
      enterTitle: 'Insira o título',
      addValue: 'Adicionar valor',
      delete: 'Excluir',
      update: 'Atualizar',
      add: 'Adicionar',
      confirmationPage: 'Ação de confirmação',
      confirmationPageSubtitle: 'Escolha a ação resultado após envio do formulário',
      successMessage: 'Mensagem de sucesso',
      successMessageTooltip: 'Mensagem de sucesso após envio do formulário',
      thankYou: 'Mensagem de agradecimento',
      submit: 'Enviar',
    },
    contact: {
      blockTitle: 'Contatos',
      blockText: 'Contatos permite que os usuários se comuniquem diretamente com você. Adicione seu telefone, e-mail, mensageiro ou localização',
      blockShortText: 'Comunicar-se com usuários',
      addNewContact: 'Adicionar novo contato',
      newContact: 'Novo contato',
      friendlyName: 'Nome amigável',
    },
    faq: {
      blockTitle: 'FAQ',
      blockText: 'Perguntas Frequentes — usado para se referir a uma lista de respostas a perguntas típicas que os usuários podem fazer',
      blockShortText: 'Perguntas Frequentes',
      addNewItem: 'Adicionar novo item',
      editItem: 'Editar item',
      title: 'Título',
      titleTooltip: 'Insira o título',
      description: 'Descrição',
      descriptionTooltip: 'Insira a descrição',
      update: 'Atualizar',
      add: 'Adicionar',
      howToFind: 'Como nos encontrar',
      view: 'Ver',
      viewTooltip: 'Escolhe como os itens de FAQ são apresentados',
      feed: 'Feed',
      slider: 'Slider',
      emptyTitle: 'Ainda não tens itens',
      emptyText: 'Adiciona a tua primeira pergunta para preencher este bloco.',
    },
    ama: {
      blockTitle: 'Pergunte-me',
      blockShortText: 'Responde a perguntas dos fãs',
      blockText: 'Permite à tua audiência fazer perguntas e responde-lhes diretamente na tua página',
    },
    feature: {
      blockTitle: 'Recursos',
      blockText: 'Seção de texto com imagem para dizer aos seus usuários por que seu negócio é o melhor',
      blockShortText: 'Diga aos usuários por quê',
      title: 'Título',
      titleTooltip: 'Alterar título do item',
      description: 'Descrição',
      descriptionTooltip: 'Alterar descrição do item',
    },
    highlight: {
      blockTitle: 'Destaques',
      blockText: 'Destaque os links mais importantes com miniaturas (até 3)',
      blockShortText: 'Destaque os mais importantes',
      title: 'Título',
      titleTooltip: 'Alterar título do item',
      url: 'URL',
      urlTooltip: 'Alterar URL do item',
      modeLink: 'Link',
      modeStory: 'Story',
      coverPhoto: 'Foto',
      coverIcon: 'Ícone',
      templates: {
        scroll: 'Linha com rolagem',
        scrollCaption: 'O bloco original — capas redondas que se distribuem em linhas e rolam a partir de três',
        story: 'Stories',
        storyCaption: 'Capas maiores no anel gradiente, para serem lidas como stories que se tocam',
        square: 'Capas quadradas',
        squareCaption: 'Capas quadradas numa linha com rolagem — parece uma prateleira e não uma fila de stories',
        tall: 'Cartões altos',
        tallCaption: 'Cartões verticais com o nome sobre a imagem. Melhor quando a capa é o que importa',
        icon: 'Capas com ícone',
        iconCaption: 'Uma grade de ícones em vez de fotos — para quando ainda não há imagens',
        grid: 'Grade',
        gridCaption: 'Todos os destaques de uma vez numa grade de quatro colunas, para um conjunto longo demais',
      },
    },
    banner: {
      blockTitle: 'Banner',
      blockText: 'Destaque imagem, vídeo ou seu último produto. Você pode adicionar botão CTA para guiar os usuários em direção à sua meta de conversão',
      blockShortText: 'Destaque imagem, vídeo',
      height: 'Altura',
      heightTooltip: 'Alterar altura do banner',
      badge: 'Etiqueta',
      badgeTooltip: 'A linha pequena impressa acima do título neste modelo',
      badgePlaceholder: 'Acabou de sair',
      templates: {
        classic: 'Clássico',
        classicCaption: 'O banner original — o texto flutuando no meio da imagem, dimensionado pela proporção',
        coverTop: 'Capa com antetítulo',
        coverTopCaption: 'Uma linha pequena acima do título, tudo centralizado. Melhor quando o banner diz quem você é',
        coverTitle: 'Somente o título',
        coverTitleCaption: 'Uma palavra grande e espaçada, com uma linha embaixo. Sem botões, mais nada',
        coverLeft: 'Alinhado à esquerda',
        coverLeftCaption: 'O texto no canto inferior e dois botões lado a lado, como abre uma landing page',
        coverCenter: 'Botões centralizados',
        coverCenterCaption: 'Tudo centralizado, os botões empilhados em formato de pílula. O mais direto dos seis',
        coverVideo: 'Capa com vídeo',
        coverVideoCaption: 'Para um banner que reproduz vídeo — uma pílula de estado, controle de som e um botão',
        coverBadge: 'Etiqueta e CTA',
        coverBadgeCaption: 'Um quadro mais baixo: uma pílula branca com a novidade, um título e um botão',
      },
    },
    slider: {
      blockTitle: 'Slider',
      blockText: 'Carrossel de imagens que permite exibir seu conteúdo de imagens e adicionar diferentes recursos',
      blockShortText: 'Carrossel de imagens',
      image: 'Imagem',
      imageTooltip: 'Imagem da sua galeria',
      addText: 'Adicionar texto',
      title: 'Título',
      titleTooltip: 'Título do seu slide',
      titleSize: 'Tamanho do título',
      titleSizeTooltip: 'Escolha o tamanho para melhor leitura',
      description: 'Descrição',
      descriptionTooltip: 'Descrição do seu slide',
      textColor: 'Cor do texto',
      addButton: 'Adicionar botão',
      url: 'URL',
      urlTooltip: 'URL da sua imagem',
      button: 'Botão',
      buttonTooltip: 'Título do seu botão',
      buttonText: 'Texto do botão',
      buttonColor: 'Cor do botão',
      height: 'Altura',
      heightTooltip: 'Alterar altura dos slides',
      view: 'Visualização',
      viewTooltip: 'Escolha a visualização para o slider',
      auto: 'Auto',
      square: 'Quadrado',
      rectangle: 'Retângulo',
      single: 'Único',
      multi: 'Múltiplo',
      templates: {
        multi: 'Múltiplo',
        multiCaption: 'A tira original de cartões, com o próximo aparecendo na borda',
        single: 'Único',
        singleCaption: 'O slider original de um por vez, com os pontos abaixo',
        showcase: 'Vitrine',
        showcaseCaption: 'A vitrine original — um índice grande, um contador e uma tira de miniaturas',
        full: 'Sangrado com pontos',
        fullCaption: 'Uma imagem de ponta a ponta, os pontos como único enfeite. Para fotos que não precisam de legenda',
        peek: 'Espia o próximo slide',
        peekCaption: 'O próximo slide aparece na borda, então o gesto fica óbvio antes de alguém tentar',
        caption: 'Slide com legenda',
        captionCaption: 'A imagem em um cartão com o título e a descrição do próprio slide abaixo',
        thumbs: 'Com miniaturas',
        thumbsCaption: 'Uma tira sob a imagem, para pular um conjunto longo em vez de deslizar',
        counter: 'Contador e setas',
        counterCaption: 'A contagem escrita e duas setas — para um conjunto que vale percorrer com calma',
        auto: 'Barras automáticas',
        autoCaption: 'Barras de stories: o slider avança sozinho e diz quanto falta',
        compare: 'Antes e depois',
        compareCaption: 'Os dois primeiros slides sobrepostos com uma linha para arrastar. Os títulos são os rótulos',
        video: 'Slides de vídeo',
        videoCaption: 'Para slides que são arquivos de vídeo — o som que o visitante liga, e o tempo',
        shop: 'Slides com produto',
        shopCaption: 'O título, a descrição e o botão do slide são lidos como nome, preço e ação',
      },
    },
    gallery: {
      blockTitle: 'Galeria',
      blockText: 'Carrossel de imagens que permite exibir seu conteúdo de imagens',
      blockShortText: 'Carrossel de imagens',
      image: 'Imagem',
      imageTooltip: 'Imagem do item da sua galeria',
      layout: 'Layout',
      layoutTooltip: 'Escolha o layout para a galeria',
      feed: 'Feed',
      slider: 'Slider',
    },
    blog: {
      blockTitle: 'Blog',
      blockText: 'Crie um blog com suas publicações',
      blockShortText: 'Criar blog',
      writeYourStory: 'Escreva sua história',
      shortDescription: 'Descrição curta',
      shortDescriptionTooltip: 'Descrição opcional para seu blog',
      description: 'Descrição',
    },
    map: {
      blockTitle: 'Mapa',
      blockText: 'Adicione o Google Maps para ajudar os usuários a navegar até seu negócio local',
      blockShortText: 'Adicionar Google Maps',
      buttonText: 'Texto do botão',
      buttonTextTooltip: 'O botão aparece quando a segunda visualização é selecionada',
      text: 'Texto',
      addAddress: 'Adicionar outro endereço',
      address: 'Endereço',
      addressTooltip: 'Cole o endereço do Google Maps, por exemplo',
      googleMap: 'Google Maps (código embed)',
      googleMapTooltip: 'Cole o código embed do Google Maps',
      howToFind: 'Como encontrar o código embed',
      incorrectCode: 'Código embed incorreto.',
      moreInfo: 'Mais informações',
      code: 'Código',
      addressSettings: 'Configurações do endereço',
      addressContent: 'Adicione URL, título e texto ou ícone do botão',
      title: 'Título',
      titleTooltip: 'O nome do seu endereço',
      url: 'URL',
      urlTooltip: 'Cole a URL do endereço do Google Maps, por exemplo',
      directionText: 'Texto de direção',
      directionTextTooltip: 'Texto de chamada para ação para seus usuários',
    },
    footer: {
      templates: {
        minimal: 'Minimalista',
        minimalCaption: 'A marca, a fila social e a linha legal. Fecha a página sem um segundo menu',
        columns: 'Duas colunas de links',
        columnsCaption: 'Links agrupados sob rótulos, em duas colunas. Para poucas secções reais',
        accordion: 'Menu acordeão',
        accordionCaption: 'Grupos recolhíveis num painel escuro. Para mais secções do que cabem',
        subscribe: 'Rodapé com subscrição',
        subscribeCaption: 'Campo de email sobre os chips de navegação. Para recolher endereços',
        contacts: 'Rodapé de contacto',
        contactsCaption: 'Telefone, email e morada como linhas tocáveis, com os mensageiros abaixo',
        shop: 'Rodapé de loja grande',
        shopCaption: 'Promessa de envio, colunas de links, distintivos de app e pagamentos',
        cta: 'Chamada para ação',
        ctaCaption: 'Painel preenchido com título e duas ações. O fecho da página',
        sticky: 'Rodapé com barra de ações',
        stickyCaption: 'Um rodapé normal e abaixo chamada, chat e o botão principal',
        locale: 'Idioma e moeda',
        localeCaption: 'Idioma, moeda e país de envio sobre os links de ajuda da loja',
      },
      defaults: {
        groups: [
          { title: 'Serviços', links: ['Design', 'Desenvolvimento', 'Branding'] },
          { title: 'Empresa', links: ['Sobre', 'Casos', 'Carreiras'] },
        ],
        subscribeTitle: 'Uma carta por mês',
        subscribeText: 'Casos, processos e um pouco dos bastidores. Sem spam.',
        subscribeButton: 'Subscrever',
        ctaTitle: 'Conte-nos o seu projeto',
        ctaText: 'Respondemos dentro de uma hora em dias úteis.',
        ctaButton: 'Escreva-nos',
        languages: [
          { code: 'pt', label: 'Pt' },
          { code: 'en', label: 'Eng' },
          { code: 'pl', label: 'Pl' },
        ],
        currency: '€ Euro',
        country: 'Portugal',
        contacts: [
          { icon: 'phone', value: '+351 21 123 4567' },
          { icon: 'mail', value: 'hi@studio.pt' },
          { icon: 'pin', value: 'R. Khoryva 22, Kyiv' },
        ],
      },
      blockTitle: 'Rodapé',
      blockText: 'Seção de conteúdo na parte inferior da página. Você pode adicionar informações de contato, ícones de redes sociais e formulário de cadastro por e-mail',
      blockShortText: 'Seção de conteúdo inferior',
      addBlock: 'Adicionar bloco',
      blockType: 'Tipo de bloco',
      blockTypeTooltip: 'Escolha o tipo de bloco',
      addBlockTitle: 'Título do bloco',
      addBlockTitleTooltip: 'Escolha o título do bloco',
      faq: 'FAQ',
      'data-collect': 'Coleta de Dados',
      contact: 'Contato',
      pages: 'Páginas',
      payments: 'Pagamentos',
      social: 'Social',
      cancel: 'Cancelar',
      add: 'Adicionar',
      None: 'Nenhum',
      link: 'link',
      faqText: 'Você pode editar perguntas frequentes no bloco FAQ. Navegue até ele clicando neste',
      socialText: 'Você pode editar ícones sociais no bloco Cabeçalho. Navegue até ele clicando neste',
      dataCollectText: 'Você pode editar a coleta de dados no bloco Coleta de Dados. Navegue até ele clicando neste',
      contactText: 'Você pode editar o contato no bloco Contato. Navegue até ele clicando neste',
      pagesText: 'Você pode adicionar novas páginas no Site',
      paymentsText: 'Métodos de pagamento serão exibidos',
      showOnAllpages: 'Mostrar em todas as páginas',
      footerText: 'O Rodapé da página Inicial está ativado no momento.',
      editSocialIcons: 'Você pode editar ícones sociais na seção Cabeçalho. Navegue até ele clicando neste',
      editSubscribe: 'Você pode editar assinatura na seção Assinar. Navegue até ele clicando neste',
      editContacts: 'Você pode editar contatos na seção Contatos. Navegue até ele clicando neste',
      editFrequently: 'Você pode editar perguntas frequentes na seção FAQ. Navegue até ele clicando neste',
      text: 'Texto',
      image: 'Imagem',
      divider: 'Separador',
      linkViewLabel: 'Disposição',
      linkViewTooltip: 'Como os links estão organizados',
      linkViewSingle: 'Empilhados',
      linkViewRow: 'Em linha',
      linkItemsLabel: 'Links',
      linkItemsTooltip: 'Adiciona até 5 links (ex.: Política de privacidade, Termos)',
      linkLabelPlaceholder: 'Etiqueta',
      linkUrlPlaceholder: 'URL',
      linkAddMore: '+ Adicionar link',
      alignLabel: 'Alinhamento',
      alignTooltip: 'Alinhamento horizontal',
      alignLeft: 'Esquerda',
      alignCenter: 'Centro',
      alignRight: 'Direita',
      imageLabel: 'Imagem',
      imageTooltip: 'Carrega um logótipo ou imagem',
      imageLinkLabel: 'Link (opcional)',
      imageLinkTooltip: 'Torna a imagem clicável',
      dividerLabel: 'Tipo de separador',
      dividerTooltip: 'Uma linha ou um espaço vazio',
      dividerLine: 'Linha',
      dividerSpace: 'Espaço',
      picker: {
        subtitle: 'Escolhe um elemento para adicionar ao teu rodapé',
        configureSubtitle: 'Configura-o e adiciona-o ao teu rodapé',
        back: 'Voltar',
        saveButton: 'Guardar',
        availableTitle: 'Disponível para adicionar',
        addedTitle: 'Já adicionado',
        addedLabel: 'Adicionado',
        addButton: 'Adicionar bloco',
        linkTitle: 'Links',
        linkSub: 'Botões para qualquer URL',
        socialTitle: 'Redes sociais',
        socialSub: 'Ícones para os teus perfis sociais',
        textTitle: 'Texto',
        textSub: 'Um título ou parágrafo',
        pagesTitle: 'Páginas',
        pagesSub: 'Link para subpáginas aninhadas',
        paymentsTitle: 'Pagamentos',
        paymentsSub: 'Métodos de pagamento aceites',
        imageTitle: 'Imagem',
        imageSub: 'Um logótipo ou imagem',
        dividerTitle: 'Separador',
        dividerSub: 'Uma linha ou espaçamento',
        faqTitle: 'FAQ',
        faqSub: 'Perguntas frequentes',
        dataCollectTitle: 'Recolha de dados',
        dataCollectSub: 'Formulário de subscrição por email',
        contactTitle: 'Contacto',
        contactSub: 'Dados de contacto',
        importMode: 'Importar do bloco',
        manualMode: 'Adicionar manualmente',
        noContactsToImport: 'Não há contactos para importar — adiciona-os manualmente.',
        noSocialsToImport: 'Não há ícones sociais para importar — adiciona-os manualmente.',
        manualItemsLabel: 'Itens',
        manualItemsTooltip: 'Escolhe um tipo e introduz o seu valor.',
        contactValuePlaceholder: '@utilizador / email / telefone',
        socialUrlPlaceholder: 'https://...',
        addMore: '+ Adicionar mais',
      },
      contactDesign: {
        editSource: 'Edita os próprios contactos no bloco de Contacto —',
        variantLabel: 'Estilo',
        variantList: 'Lista',
        variantButton: 'Botão',
        shapeLabel: 'Forma',
        shape_square: 'Quadrada',
        shape_rounded: 'Arredondada',
        shape_pill: 'Cápsula',
        widthLabel: 'Largura',
        widthFull: 'Total',
        widthHalf: 'Metade',
        widthHalfStacked: 'Meia coluna',
        borderLabel: 'Bordadura',
        borderOn: 'Ligada',
        borderOff: 'Desligada',
        borderColorLabel: 'Cor da bordadura',
      },
      layout: 'Disposição',
      splitImage: 'Imagem lateral',
    },
    'chat-ai': {
      blockTitle: 'Chat ao vivo',
      blockShortText: 'Chat com IA',
      blockText: 'Chat com IA',
      suggestionsTitle: 'Sugestões',
      suggestionsSubtitle: 'Prompts rápidos',
    },
    custom: {
      blockTitle: 'Personalizado',
      blockShortText: 'Micro app com IA',
      blockText: 'Descreva um mini app interativo e a IA gerará para você',
    },
    shop: {
      blockTitle: 'Loja',
      blockText: 'Adicione sua lista de produtos',
      blockShortText: 'Adicione seus produtos',
      view: 'Visualização',
      products: 'Produtos',
      categories: 'Categorias',
      cardLayout: 'Disposição do cartão',
      cardLayoutTooltip: 'Montra apresenta cada produto como um cartão de venda detalhado, um por linha',
      standardCards: 'Standard',
      showcaseCards: 'Montra',
      featured: 'Em destaque',
      shoppingCart: 'Carrinho de compras',
      shoppingCartNote: 'O botão do carrinho aparece quando um visitante adiciona um produto',
      cartIconDisabledHint: 'Ative o carrinho de compras para usar isto',
    },
    digital: {
      blockTitle: 'Produtos digitais',
      blockText: 'Venda um Download Digital: PDFs, Planilhas, Modelos, Exclusivos',
      blockShortText: 'Venda um Digital',
    },
    podcast: {
      templates: {
        latest: 'Último episódio',
        latestCaption: 'O episódio mais novo e um botão para começar',
        player: 'Player',
        playerCaption: 'Barra, −15, +30 e controle de velocidade',
        list: 'Lista de episódios',
        listCaption: 'Play, número, título e duração — o feed simples',
        resume: 'Continuar ouvindo',
        resumeCaption: 'Onde o visitante parou, guardado no navegador dele',
        bestOf: 'Melhores',
        bestOfCaption: 'Três episódios para começar, na ordem que você definiu',
        cover: 'Capa do programa',
        coverCaption: 'Capa, sobre o que é e os apps onde está',
        subscribe: 'Linha de assinatura',
        subscribeCaption: 'Uma linha e os diretórios — sem capa nem episódios',
        trailer: 'Trailer',
        trailerCaption: 'A resposta de dois minutos para "esse programa é pra mim?"',
        guest: 'Episódio com convidado',
        guestCaption: 'Uma entrevista vendida por quem está nela',
        guests: 'Convidados',
        guestsCaption: 'Os rostos que passaram pelo programa, em grade',
        hosts: 'Apresentadores',
        hostsCaption: 'Quem faz o programa, lido do autor dos episódios',
        chapters: 'Capítulos e notas',
        chaptersCaption: 'Linhas com marcações; tocar salta o player',
        transcript: 'Transcrição',
        transcriptCaption: 'O episódio por escrito, cada linha salta o áudio',
        clip: 'Clipe para compartilhar',
        clipCaption: 'Uma frase em destaque e um botão de compartilhar',
        video: 'Videopodcast',
        videoCaption: 'O frame e a escolha entre assistir e ouvir',
        seasons: 'Temporadas',
        seasonsCaption: 'Seus programas como chips e os episódios abaixo',
        topics: 'Filtro por tema',
        topicsCaption: 'Episódios pela categoria do programa deles',
        showCards: 'Cartões de programa',
        showCardsCaption: 'Cada programa como cartão, rolando de lado',
        ask: 'Pergunta do ouvinte',
        askCaption: 'Uma chamada, um exemplo e para onde vão as respostas',
        ratings: 'Avaliações',
        ratingsCaption: 'Sua nota e uma avaliação que valha citar',
        support: 'Apoie o programa',
        supportCaption: 'O que os apoiadores recebem e onde assinam',
        classic: 'Listen Now',
        classicCaption: 'O bloco original — o feed com a aba de programas',
        showcase: 'Vitrine',
        showcaseCaption: 'A visão editorial: um cartão grande e um trilho de capas',
      },
      copy: {
        askTitle: 'Pergunta do ouvinte',
        askHint: 'A chamada, um exemplo de pergunta e para onde vão as respostas: um formulário, um e-mail, uma caixa de voz.',
        ratingTitle: 'Avaliações',
        ratingHint: 'Sua nota e uma avaliação para citar. O bloco imprime o que você escrever — não busca na Apple nem no Spotify.',
        supportTitle: 'Apoie o programa',
        supportHint: 'O que os apoiadores recebem e onde assinam. O botão leva para onde você já recebe.',
        title: 'Título',
        text: 'Texto',
        question: 'Exemplo de pergunta',
        url: 'Link do botão',
        buttonText: 'Texto do botão',
        voiceUrl: 'Link de voz',
        value: 'Nota',
        count: 'De onde',
        quote: 'Avaliação',
        author: 'Quem disse',
        tiers: 'Níveis',
        tierName: 'Nome',
        tierPerk: 'O que inclui',
        tierPrice: 'Preço',
        addTier: '+ Adicionar nível',
        removeTier: 'Remover nível',
      },
      blockTitle: 'Podcasts',
      blockText: 'Promova seus podcasts',
      blockShortText: 'Promova seus podcasts',
    },
    'page-list': {
      blockTitle: 'Lista de páginas',
      blockText: 'Crie sua lista de páginas',
      blockShortText: 'Crie sua lista de páginas',
      description: 'Descrição',
      addNewPageItem: 'Adicionar link de página',
    },
    appointment: {
      blockTitle: 'Agendamentos',
      blockText: 'Permita que visitantes agendem horários no seu calendário',
      blockShortText: 'Permita que visitantes agendem',
    },
    service: {
      modal: {
        title: 'Adicionar novo serviço',
        subtitle: 'Insira o essencial — adicione o resto na página do serviço',
        thumbnail: 'Miniatura (opcional)',
        thumbnailTooltip: 'Carregue uma foto de capa',
        label: 'Etiqueta (opcional)',
        labelTooltip: 'Destaque este serviço com um selo',
        titleField: 'Título',
        titleTooltip: 'Adicione um título para o seu serviço',
        titlePlaceholder: 'ex. Sessão de fotos em família — 1 hora',
        cancel: 'Cancelar',
        submit: 'Adicionar',
      },
      blockTitle: 'Serviços',
      blockText: 'Você receberá uma notificação por e-mail quando uma solicitação for enviada a você',
      blockShortText: 'Receber um e-mail',
    },
    requests: {
      blockTitle: 'Serviços',
      blockText: 'Você receberá uma notificação por e-mail quando uma solicitação for enviada a você',
      blockShortText: 'Receber um e-mail',
    },
    tips: {
      blockTitle: 'Gorjetas',
      blockText: 'UniLink torna o apoio divertido e fácil. Em apenas alguns toques, seus fãs podem fazer o pagamento e deixar uma mensagem',
      blockShortText: 'Torna o apoio divertido',
    },
    tip: {
      blockTitle: 'Gorjetas',
      blockText: 'UniLink torna o apoio divertido e fácil. Em apenas alguns toques, seus fãs podem fazer o pagamento e deixar uma mensagem',
      blockShortText: 'Torna o apoio divertido',
    },
    donation: {
      blockTitle: 'Doações',
      blockText: 'UniLink torna o apoio divertido e fácil. Em apenas alguns toques, seus fãs podem fazer o pagamento e deixar uma mensagem',
      blockShortText: 'Torna o apoio divertido',
    },
    course: {
      blockTitle: 'Curso ou Tutorial',
      blockText: 'Permita que visitantes agendem horários no seu calendário',
      blockShortText: 'Permita que visitantes agendem',
    },
    event: {
      blockTitle: 'Eventos ou Ingressos',
      blockText: 'Permita que o público participe dos seus eventos',
      blockShortText: 'Permita que o público participe',
    },
    menu: {
      blockTitle: 'Cardápio',
      blockText: 'Crie um cardápio exclusivo com preços',
      blockShortText: 'Criar cardápio exclusivo',
    },
    recipe: {
      blockTitle: 'Receita',
      blockText: 'Compartilhe uma receita com ingredientes, passos e fotos',
      blockShortText: 'Compartilhar uma receita',
    },
    booking: {
      blockTitle: 'Reservas',
      blockText: 'Permita que visitantes reservem seus espaços',
      blockShortText: 'Permita que visitantes reservem',
      name: 'Nome',
      nameCaption: 'Insira o nome do espaço',
      description: 'Descrição',
      descriptionCaption: 'Descrição curta deste espaço',
      rentalType: 'Tipo de aluguel',
      rentalTypeCaption: 'Por exemplo: apartamento, carro, escritório',
      duration: 'Duração',
      durationCaption: 'Por exemplo: por dia, por semana, por mês',
      price: 'Preço',
      priceCaption: 'Preço base deste espaço',
      oldPrice: 'Preço antigo',
      oldPriceCaption: 'Preço anterior opcional',
      rating: 'Avaliação',
      ratingCaption: 'Avaliação média (opcional)',
      label: 'Rótulo',
      labelCaption: 'Selo curto como NOVO ou DESTAQUE',
      image: 'Imagem',
      imageCaption: 'Envie uma imagem de capa para este espaço',
      location: 'Localização',
      locationCaption: 'Cidade, área ou endereço',
      capacity: 'Capacidade (hóspedes)',
      capacityCaption: 'Número máximo de hóspedes',
      rooms: 'Quartos e área',
      roomsCaption: 'Quartos, banheiros e área',
      bedrooms: 'Quartos',
      bathrooms: 'Banheiros',
      areaSqM: 'Área (m²)',
      minStay: 'Estadia mínima (dias)',
      minStayCaption: 'Número mínimo de dias para reserva',
      requiresDeposit: 'Requer depósito',
      depositAmount: 'Valor do depósito',
      depositAmountCaption: 'Depósito antecipado para confirmar reserva',
      noSmoking: 'Proibido fumar',
      noPets: 'Sem animais de estimação',
      amenitiesWifi: 'Wi-Fi',
      amenitiesParking: 'Estacionamento',
      amenitiesKitchen: 'Cozinha',
      amenitiesHeating: 'Aquecimento',
      amenitiesAC: 'Ar condicionado',
      amenitiesPool: 'Piscina',
      amenitiesSauna: 'Sauna',
      amenitiesRestrooms: 'Banheiros',
      validationNameRequired: 'Nome é obrigatório',
      validationPriceRequired: 'O preço deve ser um número não negativo',
      validationDepositRequired: 'O valor do depósito é obrigatório quando o depósito está ativado',
      validationCapacityNumber: 'A capacidade deve ser um número não negativo',
      validationOldPriceNumber: 'O preço antigo deve ser um número não negativo',
      brand: 'Marca',
      brandCaption: 'Marca do carro, ex. Tesla',
      model: 'Modelo',
      modelCaption: 'Modelo do carro, ex. Model 3',
      year: 'Ano',
      yearCaption: 'Ano de fabricação',
      color: 'Cor',
      colorCaption: 'Cor exterior, ex. preto',
      fuelType: 'Tipo de combustível',
      fuelTypeCaption: 'Gasolina, diesel, elétrico, híbrido etc.',
      transmission: 'Transmissão',
      transmissionCaption: 'Automática ou manual',
      seatCount: 'Número de assentos',
      seatCountCaption: 'Número de assentos no carro',
      edit: 'Editar item',
      add: 'Adicionar item',
    },
    membership: {
      blockTitle: 'Assinatura',
      blockText: 'Crie uma assinatura gratuita ou paga para seu conteúdo',
      blockShortText: 'Criar assinatura',
    },
    pricing: {
      blockTitle: 'Preços',
      blockText: 'Crie um cardápio exclusivo com preços',
      blockShortText: 'Criar cardápio exclusivo',
      name: 'Nome',
      nameTooltip: 'Insira o nome do seu produto',
      pricingPlanName: 'Nome do plano de preços',
      pricingPlanNameTooltip: 'Insira o nome do seu plano de preços',
      description: 'Descrição',
      descriptionTooltip: 'Insira a descrição do seu produto',
      pricingPlanDescriptionTooltip: 'Insira a descrição do seu plano de preços',
      priceValue: 'Valor do preço',
      priceUnit: 'Unidade de preço',
      label: 'Rótulo',
      labelTooltip: 'Insira o rótulo do seu plano de preços',
      orderButtonText: 'Texto do botão de pedido',
      orderButtonTextDescriptionTooltip: 'Insira o texto do botão de pedido do seu plano de preços',
      orderButtonLink: 'Link do botão de pedido',
      orderButtonLinkDescriptionTooltip: 'Insira o link do botão de pedido do seu plano de preços',
      subtitle: 'Subtítulo',
      subtitleTooltip: 'Insira o subtítulo do seu produto',
      price: 'Preço',
      priceTooltip: 'Insira o preço do seu produto',
      pricingTiers: 'Níveis de preço',
      pricingTiersTooltip: 'Insira os níveis de preço do seu produto',
      addPriceValue: 'Adicionar mais preço',
      group: 'Grupo',
      groupTooltip: 'Escolha o grupo do seu produto',
      image: 'Imagem',
      imageTooltip: 'Envie uma imagem para seu produto',
      unit: 'Unidade de preço',
      unitTooltip: 'Insira a unidade do seu preço',
      addUnitTitle: 'Unidades de preço',
      addPriceUnitValue: 'Adicionar mais unidade de preço',
      addUnitButtonText: 'Salvar',
      button: 'Botão',
      buttonTooltip: 'Adicionar botão para seu produto',
      buttonAddText: '+ Adicionar botão',
      buttonModalTextField: 'Texto do botão',
      buttonModalTextFieldTooltip: 'Insira o texto do botão',
      buttonModalURLField: 'URL do botão',
      buttonModalURLFieldTooltip: 'Insira a URL do botão',
      buttonModalTitle: 'Adicionar botão',
      groups: {
        title: 'Grupos',
        subtitle: 'Adicionar, editar e excluir grupos',
        groups: 'Grupos',
        groupsTooltip: 'Adicionar, editar e excluir grupos',
        addNewGroup: 'Adicionar novo grupo',
        newGroup: 'Novo grupo',
        titleGroup: 'Título',
        titleGroupTooltip: 'Insira o título do seu grupo',
        descriptionGroup: 'Descrição',
        descriptionGroupTooltip: 'Insira a descrição do seu grupo',
      },
    },
    menuBlock: {
      title: 'Cardápio',
      subtitle: 'Crie um cardápio com itens e preços',
      add: 'Adicionar novo item',
      edit: 'Editar item',
      name: 'Nome',
      nameCaption: 'Insira o nome do item',
      description: 'Descrição',
      descriptionCaption: 'Insira uma descrição curta',
      ingredients: 'Ingredientes',
      ingredientsCaption: 'Liste os ingredientes ou composição',
      price: 'Preço',
      priceCaption: 'Insira o preço',
      weight: 'Peso (g)',
      weightCaption: 'Insira o peso em gramas',
      calories: 'Calorias (kcal)',
      caloriesCaption: 'Insira as calorias em kcal',
      label: 'Rótulo',
      labelCaption: 'Insira o texto do rótulo',
      labelColor: 'Cor do rótulo',
      labelColorCaption: 'Escolha uma cor de fundo para o rótulo',
      image: 'Imagem',
      imageCaption: 'Envie uma imagem para seu item',
      available: 'Disponível para pedido',
      visible: 'Visível na página',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'Exiba um NFT da plataforma OpenSea',
      blockShortText: 'Exibir um NFT',
    },
    wallet: {
      wallet: 'Carteira',
      blockTitle: 'Carteira Bancária/Cripto',
      blockText: 'Exiba seu Cartão de Crédito ou carteira Bitcoin para facilitar a cópia pelos usuários para transferência de fundos',
      blockShortText: 'Exiba suas carteiras',
      title: 'Título',
      titleTooltip: 'Título da sua carteira',
      walletNumber: 'Número da carteira',
      walletNumberTooltip: 'Cole o número da sua carteira',
      icon: 'Ícone',
      iconTooltip: 'Definir ícone para sua carteira',
      card: 'Cartão',
      bank: 'Banco',
      crypto: 'Cripto',
      transfer: 'Transferência',
      paymentLink: 'Link de pagamento',
      cardNumber: 'Número do cartão',
      cardNumberTooltip: 'Cole o número do seu cartão',
      cardHolder: 'Titular do cartão',
      cardHolderTooltip: 'Insira o titular do seu cartão',
      bankAccountDetails: 'Dados da conta bancária',
      bankAccountDetailsTooltip: 'Insira os dados da sua conta bancária',
      walletAddress: 'Endereço da carteira',
      walletAddressTooltip: 'Insira o endereço da sua carteira',
      network: 'Rede',
      networkTooltip: 'Insira sua rede',
      publicKey: 'Chave pública',
      publicKeyTooltip: 'Insira sua chave pública',
      providerName: 'Nome do provedor',
      providerNameTooltip: 'Insira o nome do seu provedor',
      link: 'Link',
      linkTooltip: 'Insira seu link',
      serviceName: 'Nome do serviço',
      serviceNameTooltip: 'Insira o nome do seu serviço',
      email: 'E-mail',
      emailTooltip: 'Insira seu e-mail',
      phone: 'Telefone',
      phoneTooltip: 'Insira seu telefone',
      username: 'Nome de usuário',
      usernameTooltip: 'Insira seu nome de usuário',
      fullName: 'Nome completo',
      fullNameTooltip: 'Insira seu nome completo',
      referenceNumber: 'Número de referência',
      referenceNumberTooltip: 'Insira seu número de referência',
      country: 'País',
      countryTooltip: 'Insira seu país',
      transferProvider: 'Provedor de transferência',
      transferProviderTooltip: 'Insira seu provedor de transferência',
      cryptoCurrency: 'Criptomoeda',
      cryptoCurrencyTooltip: 'Insira sua criptomoeda',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'Destaque sua melhor mídia e vídeo do Instagram ou venda seus produtos com um feed de compras do Instagram',
      blockShortText: 'Sua melhor mídia do Instagram',
      blockConnectTitle: 'Instagram não está conectado',
      blockConnectText: 'Parece que seus produtos do Instagram ainda não foram importados. Conecte sua conta agora',
      blockConnectButton: 'Adicionar Instagram',
      emptyList: 'Você ainda não tem mídia do Instagram.',
      addInstagramUsername: 'Adicionar nome de usuário do Instagram',
      username: 'Nome de usuário',
      downloadTakes: 'O download leva até 2 minutos',
      displayPost: 'Exibir publicação no seu site',
      view: 'Visualizar',
      redirect: 'Redirecionamento de URL',
      text: 'Texto e Botão',
      actionType: 'Tipo de ação',
      url: 'URL',
      openInNewTab: 'Abrir em nova aba',
      delete: 'Excluir',
      cancel: 'Cancelar',
      save: 'Salvar',
      editMedia: 'Editar Mídia',
      title: 'Título',
      automation: 'Automação',
      automationText: 'Automatize sua conta com recursos de Piloto Automático',
      autopilot: 'Piloto Automático',
      autopilotTooltip: 'Envie uma publicação com a legenda de exemplo e suas tags de produtos/links serão gerados automaticamente',
      switchTitle: 'Detectar automaticamente título, preço, links',
      sampleCaption: 'Legenda de exemplo: #49.99 #VestidoLindo https://google.com',
      integrations: 'Integrações',
      integrationsText: 'Adicione Instagram ao seu site',
      connectInstagram: 'Conectar Instagram',
      connectInstagramText: 'Conecte sua conta do Instagram para exibir as publicações ou reels de sua escolha.',
      selectAccount: 'Selecionar conta',
      connectNewInstagram: 'Conectar uma nova conta do Instagram',
      continue: 'Continuar',
      disconnectInstagram: 'Desconectar Instagram',
      addTag: 'Adicionar tag',
      tagClickHint: 'Clique na imagem para posicionar a tag',
      tagPositionSet: 'Posição definida. Preencha os detalhes abaixo.',
      tagTypeLink: 'Link',
      tagTypeProduct: 'Produto',
      tagLabel: 'Rótulo',
      tagSelectProduct: 'Selecionar produto',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'Destaque seu melhor vídeo do TikTok ou venda seus produtos com um feed de compras do TikTok',
      blockShortText: 'Seu melhor vídeo do TikTok',
      addTikTok: 'Adicionar conta TikTok',
      individualVideo: 'Vídeo individual',
      videoCollection: 'Coleção de vídeos',
      add: 'Adicionar',
      blockConnectTitle: 'TikTok não está conectado',
      blockConnectText: 'Parece que seus produtos do TikTok ainda não foram importados. Conecte sua conta agora',
      blockConnectButton: 'Conectar TikTok',
      enterUsername: 'Insira o nome de usuário',
      enterVideo: 'Insira a URL de um vídeo do TikTok',
      emptyList: 'Você ainda não tem mídia do TikTok.',
      editMedia: 'Editar Mídia',
      addTikTokVideo: 'Adicionar vídeo do TikTok',
      displayPost: 'Exibir publicação no seu site',
      delete: 'Excluir',
      cancel: 'Cancelar',
      save: 'Salvar',
      integrations: 'Integrações',
      integrationsText: 'Adicione TikTok ao seu site',
      connectTikTok: 'Conectar TikTok',
      disconnectTikTok: 'Desconectar TikTok',
      individualText: `Você não pode conectar a conta TikTok a este tipo de bloco ('individual').`,
      individualText2: 'Por favor, adicione um único vídeo do TikTok em vez disso.',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'Destaque um vídeo ou transmissão do YouTube na sua página. Marque produtos no vídeo do YouTube',
      blockShortText: 'Destaque um vídeo do YouTube',
      enterYouTubeLink: 'Insira a URL do YouTube',
      enterYouTubeLinkTooltip: 'Cole a URL do YouTube',
    },
    overview: {
      blockTitle: 'Visão Geral',
      blockText: 'Destaque um vídeo ou transmissão na sua página. Marque produtos no vídeo',
      blockShortText: 'Marque produtos no vídeo',
    },
    video: {
      blockTitle: 'Vídeo',
      blockText: 'Destaque um vídeo ou transmissão na sua página',
      blockShortText: 'Destaque um vídeo',
    },
    short: {
      blockTitle: 'Shorts / Reels',
      blockText: 'Adicione vídeos verticais curtos — Shorts, Reels, TikToks',
      blockShortText: 'Vídeos verticais',
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: 'Exiba seus Tweets na sua página UniLink para aumentar o engajamento',
      blockShortText: 'Exiba seus Tweets',
      twitterURL: 'URL do Twitter',
      twitterURLTooltip: 'Adicione a URL do Twitter para gerar o código incorporado',
      enterTwitterURL: 'Insira a URL do Twitter',
    },
    music: {
      templates: {
        nowPlaying: 'Player',
        nowPlayingCaption: 'Um cartão escuro com a capa, a barra de progresso e os controles — percorre as faixas do bloco',
        compact: 'Player compacto',
        compactCaption: 'O mesmo player com um terço da altura, para uma música que não é o destaque',
        tracklist: 'Lista de faixas',
        tracklistCaption: 'Linhas numeradas com a duração e um botão de play, como o verso de um disco',
        queue: 'Fila de reprodução',
        queueCaption: 'O que está tocando e o que vem depois: um pequeno player de álbum com a fila',
        featured: 'Faixa em destaque',
        featuredCaption: 'A capa em tamanho grande, o título sobre ela e um botão de play',
        waveform: 'Forma de onda',
        waveformCaption: 'Uma gravação desenhada como onda que preenche ao tocar — para uma demo ou mixagem',
        mix: 'Set de DJ',
        mixCaption: 'Uma foto sangrada, a duração do set e a lista de faixas atrás de um botão',
        release: 'Lançamento com links',
        releaseCaption: 'A capa, o título e uma linha por serviço de streaming — o cartão smart-link',
        streaming: 'Links de streaming',
        streamingCaption: 'Só os serviços, sem capa: leva o visitante à plataforma que ele já usa',
        presave: 'Pré-save',
        presaveCaption: 'Um disco que ainda não saiu e os toques que o colocam na biblioteca no lançamento',
        shelf: 'Prateleira de álbuns',
        shelfCaption: 'Cada lançamento como capa, com rolagem lateral. Um toque abre seus links',
        playlistCard: 'Cartão de playlist',
        playlistCardCaption: 'Um mosaico do que há na playlist, a duração e um botão para ouvir',
        record: 'Comprar o disco',
        recordCaption: 'A capa, o preço e dois botões — comprar ou ouvir primeiro',
        classic: 'Abas',
        classicCaption: 'O bloco original: Faixas, Playlists e Lançamentos em abas com os cartões de sempre',
        showcase: 'Vitrine',
        showcaseCaption: 'A visão editorial — cartões grandes de lançamentos e um trilho com o resto abaixo',
      },
      blockTitle: 'Música',
      blockText: 'Incorpore músicas do Spotify, SoundCloud, playlist ou envie seu próprio arquivo de áudio',
      blockShortText: 'Adicionar sua música',
      brand: 'Marca',
      brandTooltip: 'Escolha o tipo para adicionar sua música',
      url: 'URL',
      embed: 'Código embed',
      custom: 'Personalizado',
      musicUrl: 'URL da música',
      musicUrlTooltip: 'Insira a URL da música',
      embedCodeTitle: 'Código embed',
      embedCodeTooltip: 'Cole o código embed da sua música da plataforma escolhida',
      audioFile: 'Arquivo de áudio',
      uploadAudios: 'Você só pode enviar áudio aqui',
      title: 'Título',
      titleTooltip: 'Insira o título da sua música',
      artist: 'Artista',
      artistTooltip: 'Insira o artista da sua música',
      audioFileTitle: 'Arquivo de áudio',
      audioFileTooltip: 'Nome do seu arquivo de áudio',
      coverImage: 'Imagem de capa',
      coverImageTooltip: 'Envie uma imagem para sua música',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'Incorpore vídeo ou transmissão do Twitch na sua página',
      blockShortText: 'Incorporar vídeo do Twitch',
      twitchURL: 'URL do Twitch',
      twitchURLTooltip: 'Cole a URL do canal ou nome do canal',
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Exibir meu canal Twitch',
      displayChat: 'Exibir meu canal Twitch e chat',
    },
    splash: {
      blockTitle: 'Pop-up',
      blockText: 'Banner em tela cheia com texto e botão que aparece antes do carregamento do site para promover qualquer produto ou evento',
      blockShortText: 'Banner em tela cheia',
    },
    pageList: {
      templates: {
        classic: 'Lista simples',
        classicCaption: 'O bloco original: uma página por linha com seta. Bom até cinco páginas',
        described: 'Lista com descrições',
        describedCaption: 'Linhas numeradas, cada página com uma linha a explicar para onde leva',
        icons: 'Grelha de ícones',
        iconsCaption: 'Duas colunas com o ícone sobre o nome. Bom a partir de seis páginas',
        covers: 'Cartões com capa',
        coversCaption: 'Uma imagem ao lado de cada página, para secções que vale mostrar',
        groups: 'Secções agrupadas',
        groupsCaption: 'Um mapa do site: páginas sob as etiquetas de grupo que definir',
        headline: 'Linhas grandes',
        headlineCaption: 'Linhas enormes num painel preenchido, para quatro ou cinco destinos',
        tiles: 'Mosaicos com foto',
        tilesCaption: 'Mosaicos de dois por linha; o último sozinho ocupa toda a largura',
        tags: 'Etiquetas',
        tagsCaption: 'Cada página como cápsula. A escolha compacta quando são dez ou mais',
        prevNext: 'Anterior e seguinte',
        prevNextCaption: 'As duas páginas ao lado desta, para o fim de uma página longa',
      },
    },
    promo: {
      blockTitle: 'Barra promocional',
      blockText: 'Destaque que permite exibir promoções',
      blockShortText: 'Destaque suas promoções',
    },
    welcome: {
      blockTitle: 'Mensagem de boas-vindas',
      blockText:
        'Escreva mensagens de boas-vindas que convidam os visitantes a iniciar uma conversa. Aparece na parte inferior da página para receber visitantes e oferecer assistência',
      blockShortText: 'Escreva mensagens de boas-vindas',
    },
    review: {
      blockTitle: 'Avaliações',
      blockText: 'Avaliações ajudam os clientes a aprender mais sobre o produto e decidir se é o produto certo para eles',
      blockShortText: 'Avaliações ajudam clientes',
      name: 'Nome',
      nameTooltip: 'Insira o nome do avaliador',
      comment: 'Comentário',
      commentTooltip: 'Insira o comentário do avaliador',
      date: 'Data',
      dateTooltip: 'Insira a data da avaliação',
      rate: 'Nota',
      rateTooltip: 'Definir nota da avaliação',
      image: 'Imagem',
      imageTooltip: 'Enviar imagem do avaliador',
    },
    coupon: {
      blockTitle: 'Cupons',
      blockText: 'Um cupom online refere-se a um código de desconto ou número que pode ser resgatado em um site',
      blockShortText: 'Cupom online refere-se',
    },
    timer: {
      blockTitle: 'Countdown',
      blockText:
        'Um temporizador de contagem regressiva é um relógio virtual em uma página que conta de um certo número ou data para indicar o início ou fim de um evento ou oferta',
      blockShortText: 'Temporizador de contagem regressiva',
    },
    outfit: {
      blockTitle: 'Looks',
      blockText: 'Crie sua própria lista de produtos',
      blockShortText: 'Criar lista de produtos',
    },
    spacer: {
      blockTitle: 'Espaçador',
      blockText: 'Adicione espaço vertical vazio à sua página',
      blockShortText: 'Adicione espaço vazio',
    },
    html: {
      blockTitle: 'Embed',
      blockText:
        'Você pode colar seu próprio código HTML na página UniLink. HTML é uma linguagem de marcação padrão para criação de páginas web. Permite iframes, seções, parágrafos e links.',
      blockShortText: 'Cole seu próprio HTML',
      markupCode: 'Código de marcação',
      markupCodeTooltip: 'Cole o código de marcação do seu HTML',
      strippedWarning: 'Removido por segurança ao apresentar:',
    },
    unlock: {
      blockTitle: 'Desbloquear',
      blockText: 'Você pode adicionar seu conteúdo desbloqueável à página UniLink.',
      blockShortText: 'Cole seu arquivo desbloqueável',
    },
    file: {
      blockTitle: 'Arquivo',
      blockText:
        'Este bloco permite enviar e compartilhar arquivos como documentos, imagens ou áudio. Os visitantes podem facilmente visualizar ou baixá-los diretamente da sua página.',
      blockShortText: 'Envie e compartilhe seus arquivos.',
      addNewItem: 'Adicionar novo arquivo',
      editFile: 'Editar Arquivo',
      fileName: 'Insira o nome do arquivo',
      fileDescription: 'Descrição do arquivo (opcional)',
      coverImage: 'Imagem de capa (opcional)',
      templates: {
        classic: 'Lista clássica',
        classicCaption: 'O bloco original: uma linha por arquivo com ícone, peso e selo de acesso',
        list: 'Lista de arquivos',
        listCaption: 'Linhas com o formato numa placa e o botão de download à direita',
        single: 'Download único',
        singleCaption: 'Um cartão, um botão grande. Para o bloco que publica uma só coisa',
        cover: 'Prévia de capa',
        coverCaption: 'A primeira página como imagem, com o texto e o botão abaixo',
        folders: 'Pastas',
        foldersCaption: 'Arquivos agrupados por tipo; cada pasta mostra quantos e quanto pesam',
        formats: 'Formatos',
        formatsCaption: 'Um material em todos os formatos, como chips para tocar',
        versions: 'Versões',
        versionsCaption: 'O arquivo atual em destaque no topo, os antigos acessíveis abaixo',
        gate: 'Arquivo por e-mail',
        gateCaption: 'O download abre depois que a pessoa deixa um e-mail',
        transfer: 'Transferência grande',
        transferCaption: 'Um cartão escuro para entregas pesadas, com aviso de tamanho',
      },
    },
    stat: {
      templates: {
        grid: 'Quatro números',
        gridCaption: 'Dois por linha, cada um com uma legenda dizendo o que conta',
        hero: 'Um número grande',
        heroCaption: 'Um único número preenchendo o bloco, na tinta da página',
        row: 'Linha de três',
        rowCaption: 'Três números curtos em uma linha, separados por fios',
        change: 'Com variação',
        changeCaption: 'Um número e como ele mudou, vindo do campo extra de cada dado',
        bars: 'Gráfico de barras',
        barsCaption: 'Uma coluna por dado, a mais alta na sua cor de destaque',
        progress: 'Barras de progresso',
        progressCaption: 'Uma divisão em barras preenchidas: nome, número, barra',
        photo: 'Com foto',
        photoCaption: 'A imagem do título do bloco sobre uma linha de números',
        live: 'Contador ao vivo',
        liveCaption: 'Um número com um ponto pulsante ao lado',
        source: 'Nota de fonte',
        sourceCaption: 'Dois números e uma linha dizendo de onde vieram',
        trend: 'Tendência',
        trendCaption: 'Os dados como uma linha no tempo, o número mais recente no topo',
        share: 'Participação',
        shareCaption: 'Como um todo se divide, em anel com legenda',
        ranked: 'Lista ranqueada',
        rankedCaption: 'Um top cinco numerado com uma barra sob cada linha',
        feed: 'Feed',
        feedCaption: 'O bloco original — cartões de dados que quebram em linhas',
        slider: 'Slider',
        sliderCaption: 'Os mesmos cartões em um trilho que o visitante desliza',
      },
      blockTitle: 'Estatísticas',
      blockText:
        'Este bloco permite exibir insights importantes sobre sua página, como visualizações, visitantes ou engajamento. Ajuda você a monitorar seu público e entender o desempenho da sua página.',
      blockShortText: 'Adicionar estatísticas à sua página.',
      addNewItem: 'Adicionar nova estatística',
      editItem: 'Editar estatística',
      statName: 'Insira o nome da estatística',
      statValue: 'Insira o valor da estatística',
      statDescription: 'Insira a descrição da estatística',
      statProgress: 'Barra de progresso, % (opcional)',
      statLabel: 'Variação ou nota de fonte',
      statLabelTooltip: 'A etiqueta ao lado do número em “Com variação” e “Tendência” (“+18%”, “−1,1”), ou a linha sob os números em “Nota de fonte”',
      matchScreenshot: 'Copiar de uma captura',
      matchScreenshotRunning: 'A ler o design…',
      matchScreenshotSkipped: 'A cor do bloco e a fonte não foram alteradas',
      compose: 'Desenhar',
      composePlaceholder: 'Descreve o visual — «claro e moderno», «mais ousado»',
      composeHint: 'A cor vem da paleta; o contraste do texto é garantido',
      composeDone: 'Design atualizado',
      review: 'Rever',
      reviewClean: 'Revisto — nada a corrigir',
      reviewFixed: 'Revisto e corrigido',
      statItemFields: 'Selecione os campos para exibir.',
      columns: 'Colunas',
      subtitleColumns: 'Quantas estatísticas cabem numa linha',
      feed: 'Feed',
      slider: 'Slider',
      titleSize: 'Tamanho do título',
      subtitleTitleSize: 'Você pode alterar o tamanho do título',
    },
    listing: {
      blockTitle: 'Listagem',
      blockText: 'Exiba imóveis ou anúncios de itens com imagens, detalhes e preços.',
      blockShortText: 'Adicione listagens à sua página.',
    },
    rental: {
      blockTitle: 'Aluguel',
      blockText: 'Liste imóveis ou itens para alugar com disponibilidade e preços por período.',
      blockShortText: 'Adicione aluguéis à sua página.',
    },
    'single-product': {
      blockTitle: 'Produto único',
      blockText: 'Destaque um único produto com imagem, descrição e botão de compra.',
      blockShortText: 'Destaque um produto.',
    },
    team: {
      blockTitle: 'Equipe',
      blockText: 'Apresente os membros da sua equipe com fotos, nomes, cargos e redes sociais.',
      blockShortText: 'Mostre sua equipe.',
    },
    timetable: {
      blockTitle: 'Agenda',
      blockText: 'Exiba uma agenda semanal com aulas, eventos ou sessões.',
      blockShortText: 'Adicione uma agenda semanal.',
    },
    wall: {
      blockTitle: 'Mural',
      blockShortText: 'Recolhe mensagens dos visitantes',
      blockText: 'Mostra um mural público onde os visitantes podem deixar mensagens e interagir com o teu conteúdo',
    },
    'live-stream': {
      blockTitle: 'Transmissão em direto',
      blockShortText: 'Transmite em direto na tua página',
      blockText: 'Transmite em direto para a tua audiência — nativamente através da nossa plataforma, ou incorpora o YouTube / Twitch',
    },
    workout: {
      blockTitle: 'Treino',
      blockShortText: 'Partilha e vende treinos',
      blockText: 'Publica um treino estruturado — exercícios com séries, repetições e vídeos de demonstração. Vende-o ou partilha-o gratuitamente',
      templates: {
        sessionCard: 'Cartão da sessão',
        sessionCardCaption: 'Capa, nome e uma linha de detalhes sobre um botão de início',
        exerciseList: 'Lista de exercícios',
        exerciseListCaption: 'Cada exercício com miniatura, séries e carga',
        setTracker: 'Registo de séries',
        setTrackerCaption: 'Uma linha por série — feita, atual, a fazer',
        restTimer: 'Cronómetro de descanso',
        restTimerCaption: 'Uma contagem grande entre séries e o que vem a seguir',
        weekPlan: 'Plano semanal',
        weekPlanCaption: 'Os dias da semana, com hoje pronto a começar',
        videoExercise: 'Vídeo do exercício',
        videoExerciseCaption: 'Um vídeo de técnica vertical com as dicas por baixo',
        progress: 'Progresso',
        progressCaption: 'As sessões do mês em barras, mais dois totais',
        circuit: 'Circuito',
        circuitCaption: 'Rondas de trabalho e descanso, com o exercício atual aceso',
        sessionDone: 'Sessão concluída',
        sessionDoneCaption: 'O que acabaste de terminar, a sequência e um lugar para registar como foi',
      },
      defaults: {
        mon: 'Seg',
        tue: 'Ter',
        wed: 'Qua',
        thu: 'Qui',
        fullBody: 'Corpo inteiro',
        legsAndCore: 'Pernas e core',
        upperBody: 'Parte superior',
        restDay: 'Descanso',
      },
    },
    videoFeedback: {
      blockTitle: 'Feedback em vídeo',
      blockShortText: 'Recolhe testemunhos em vídeo',
      blockText: 'Recolhe testemunhos e feedback curtos em vídeo da tua audiência',
    },
    'premium-inbox': {
      blockTitle: 'Caixa de entrada premium',
      blockShortText: 'Mensagens pagas de fãs',
      blockText: 'Permite aos fãs enviarem-te mensagens e pedidos pagos diretamente para a tua caixa de entrada premium',
    },
    'order-form': {
      blockTitle: 'Formulário de encomenda',
      blockShortText: 'Recolhe encomendas na tua página',
      blockText: 'Recolhe encomendas diretamente na tua página com um formulário de encomenda personalizável',
    },
  },
  pinnedDock: {
    title: 'Blocos fixados',
    label: 'FIXADO',
    expand: 'Expandir blocos fixados',
    collapse: 'Recolher blocos fixados',
  },
  reviewButton: {
    title: 'Botão «Deixar uma avaliação»',
    desc: 'Mostra sob as avaliações um botão que leva os visitantes para onde podem deixar uma avaliação.',
    buttonText: 'Texto do botão',
    link: 'Link',
    leaveReview: 'Deixar uma avaliação',
    googleHint: 'Deixe em branco para usar a sua página de avaliações do Google.',
    design: 'Design do botão',
    background: 'Fundo',
    textColor: 'Texto',
  },
  themeTokens: {
    title: 'Estilo do tema',
    subtitle: 'Tipografia, cantos e espaçamento',
    typography: 'Tipografia',
    corners: 'Cantos',
    density: 'Densidade',
  },
  headingDesign: {
    colors: 'Cores',
    title: 'Cabeçalho',
    subtitle: 'Herda a cor do texto do bloco',
    hint: 'Uma cor não alterada segue a cor de texto do bloco. Ao definir uma, ela vale só para essa parte.',
    titleColor: 'Título',
    descriptionColor: 'Descrição',
    inherited: 'herdado',
    reset: 'Repor',
    custom: 'próprias',
  },
  advancedDesign: {
    inherited: 'herdado',
    reset: 'Repor',
    title: 'Avançado',
    subtitle: 'Ajuste cada parte com precisão',
    slot_title: 'Título',
    slot_description: 'Descrição',
    slot_label: 'Sobretítulo',
    fontSize: 'Tamanho da fonte',
    fontWeight: 'Espessura',
    textTransform: 'Maiúsculas/minúsculas',
    textAlign: 'Alinhamento',
    color: 'Cor',
  },
  layoutPicker: {
    title: 'Layout',
    tooltip: 'Escolha como os itens são dispostos',
    layout_list: 'Lista',
    layout_grid: 'Grelha',
    layout_cards: 'Cartões',
  },
  importDesign: {
    title: 'Importar design',
    subtitle: 'Recrie um design a partir de uma captura de ecrã',
    upload: 'Carregar uma captura de ecrã',
    extracting: 'A analisar…',
    apply: 'Aplicar à página',
    applying: 'A aplicar…',
    blocksCount: '+{n} blocos',
    applied: 'Design aplicado — {n} blocos adicionados',
  },
  adminUi: {
    podcastEnterShowTitle: 'Introduz o título do programa',
    podcastMaximum: 'Máximo',
    podcastCharacters: 'caracteres',
    podcastShowTitleExists: 'Já existe um programa com este título',
    podcastEditShow: 'Editar programa',
    podcastNewShow: 'Novo programa',
    podcastCover: 'Capa',
    podcastTitle: 'Título',
    podcastShowTitlePlaceholder: 'Título do programa',
    podcastCategory: 'Categoria',
    podcastCategoryPlaceholder: 'ex.: True Crime',
    podcastDescription: 'Descrição',
    podcastDescriptionPlaceholder: 'Sobre o que é este programa…',
    podcastSubscribeButtons: 'Botões “Subscrever”',
    podcastAddPlatform: 'Adicionar plataforma',
    podcastSave: 'Guardar',
    podcastCreate: 'Criar',
    episodeOne: 'episódio',
    episodeFew: 'episódios',
    episodeMany: 'episódios',
    edit: 'Editar',
    delete: 'eliminar',
    addShow: 'Adicionar programa',
    importFromRss: 'Importar de RSS',
    importFromRssFeed: 'Importar de feed RSS',
    importFromRssHint: 'Cola um link RSS do podcast — os episódios serão importados automaticamente para um novo programa.',
    import: 'Importar',
    trackWordOne: 'faixa',
    trackWordFew: 'faixas',
    trackWordMany: 'faixas',
    albumLabel: 'Álbum',
    pause: 'Pausar',
    play: 'Reproduzir',
    emptyTracks: 'Ainda não há faixas neste álbum',
    untitled: 'Sem título',
    show: 'Programa',
    audioFileNotAttached: 'Ficheiro de áudio não anexado',
    paypalConnectionTitle: 'Escolhe o método de ligação do PayPal',
    paypalConnectionSubtitle: 'Seleciona o método de ligação mais conveniente para ti',
    paypalRecommendedBadge: 'Recomendado',
    paypalPartnerTitle: 'Via PayPal Partner',
    paypalPartnerFeatureQuickConnect: 'Ligação rápida com 1 clique',
    paypalPartnerFeatureAutoTokens: 'Renovação automática de tokens',
    paypalPartnerFeatureMostSecure: 'Método mais seguro',
    paypalPartnerFeatureNoApiKeys: 'Não é preciso copiar chaves API',
    paypalPartnerButton: 'Ligar via Partner',
    paypalDirectTitle: 'Diretamente (Credenciais API)',
    paypalDirectFeatureClientIdSecret: 'Requer Client ID e Secret',
    paypalDirectFeatureManualSetup: 'Configuração manual',
    paypalDirectFeatureFullControl: 'Controlo total sobre a API',
    paypalDirectFeatureAdvancedUsers: 'Para utilizadores avançados',
    paypalDirectButton: 'Ligar diretamente',
    clientIdRequired: 'Client ID é um campo obrigatório',
    clientSecretRequired: 'Client Secret é um campo obrigatório',
    invalidPaypalCredentials: 'Credenciais do PayPal inválidas',
    connectPaypalDirectly: 'Ligar PayPal diretamente',
    paypalConnectedSuccessfully: 'PayPal ligado com sucesso!',
    yourPaypalClientId: 'O teu Client ID do PayPal no Dashboard',
    yourPaypalClientSecret: 'O teu Client Secret do PayPal no Dashboard',
    chooseOperatingMode: 'Escolhe o modo de funcionamento',
    sandboxTest: 'Sandbox (Teste)',
    liveProduction: 'Live (Produção)',
    whereToFindCredentials: '💡 Onde encontrar as credenciais?',
    goTo: 'Vai a',
    createOrSelectApp: 'Cria uma nova App ou seleciona uma existente',
    copyClientIdAndSecret: 'Copia o Client ID e o Secret',
    cancel: 'Cancelar',
    connected: 'Ligado!',
    connect: 'Ligar',
    monobankTokenTooltip: 'Token do Monobank Business Acquiring',
    monobankTokenPlaceholder: 'Introduz o token do Monobank',
    whereToGetToken: 'Onde obter o token?',
    statusChangedTo: 'Estado alterado para',
    all: 'Todos',
    loading: 'A carregar...',
    noBookingsYet: 'Ainda não há reservas',
    noBookingsWithStatus: 'Não há reservas com este estado',
    nightsAbbr: 'noites',
    uah: 'UAH',
    oneNightDeposit: 'Depósito de uma noite',
    fullPrepayment: 'Pré-pagamento total',
    online: 'Online',
    confirm: 'Confirmar',
    complete: 'Concluir',
    restore: 'Restaurar',
    bookingCalendarBooked: 'Reservado',
    bookingCalendarBlockedManually: 'Bloqueado manualmente',
    bookingCalendarAvailable: 'Disponível',
    bookingCalendarNoSettings: 'Sem definições',
    bookingCalendarSaveItemFirst: 'Guarda o item primeiro',
    bookingCalendarLoading: 'A carregar...',
    bookingCalendarBlocked: 'Bloqueado',
    bookingCalendarSelected: 'Selecionado',
    bookingCalendarSelectedDates: 'Datas selecionadas',
    bookingCalendarPricePerDay: 'Preço/dia',
    bookingCalendarOpen: 'Abrir',
    bookingCalendarBlock: 'Bloquear',
    bookingCalendarCancel: 'Cancelar',
    responseDeleted: 'Resposta eliminada',
    deleteAllConfirm: 'Eliminar todas as respostas? Esta ação não pode ser anulada.',
    allResponsesDeleted: 'Todas as respostas eliminadas',
    responseOne: 'resposta',
    responseFew: 'respostas',
    responseMany: 'respostas',
    deleteAll: 'Eliminar todas',
    allForms: 'Todos os formulários',
    noResponsesYet: 'Ainda não há respostas',
    fieldName: 'Nome',
    fieldPhone: 'Telefone',
    fieldAddress: 'Morada',
    fieldComment: 'Comentário',
    customFields: 'Campos adicionais',
    more: 'Mais',
    view: 'Ver',
    track: 'Acompanhar',
    showing: 'A mostrar',
    of: 'de',
    ordersLower: 'encomendas',
    ordersEmpty: 'Ainda não há registos',
    ordersCountLabel: 'registos',
    ordersName: 'Nome',
    ordersPhone: 'Telefone',
    ordersLoading: 'A carregar...',
    ordersComment: 'Comentário',
    ordersPayment: 'Pagamento',
    ordersPrev: 'Anterior',
    ordersNext: 'Seguinte',
    revokeAccessConfirm: 'Revogar acesso?',
    accessRevoked: 'Acesso revogado',
    activeGrants: 'concessões ativas',
    noActiveGrants: 'Não há concessões ativas',
    type: 'Tipo',
    grantedBy: 'Concedido por',
    started: 'Iniciado',
    until: 'Até',
    revoke: 'Revogar',
    deleted: 'Eliminado',
    subscribers: 'subscritores',
    noSubscribersYet: 'Ainda não há subscritores',
    phone: 'Telefone',
    name: 'Nome',
    step: 'Passo',
    done: 'concluído',
    stepFailedSingular: 'passo falhou',
    stepFailedPlural: 'passos falharam',
    done2: 'Concluído.',
    actionFailed: 'Não foi possível executar a ação.',
    starterCoffeeSite: 'Cria um site para uma cafetaria',
    starterFaq: 'Adiciona um bloco de FAQ com 5 perguntas',
    starterTranslate: 'Traduz todo o site para inglês',
    starterBrandColors: 'Escolhe cores que combinem com a minha marca',
    stopped: 'Parado.',
    scopeSite: 'Site',
    scopePage: 'Página',
    followUpAddPhoto: 'Adiciona mais uma foto',
    followUpAddQuestion: 'Adiciona outra pergunta',
    followUpAddPlan: 'Adiciona outro plano de preços',
    followUpAddService: 'Adiciona outro serviço',
    followUpAddBlock: 'Adiciona mais um bloco',
    followUpMakeBetter: 'Torna-o ainda melhor',
    followUpTweakColors: 'Ajusta as cores à minha marca',
    followUpChangeColors: 'Alterar cores',
    followUpTranslateEnglish: 'Traduzir para inglês',
    undoneDeletedPrefix: 'Anulado — removidos',
    undoneOf: 'de',
    undoneCreatedBlocks: 'blocos criados',
    planAnalyzing: 'A analisar o pedido',
    planCheckingSite: 'A verificar o estado do site',
    planChoosingBlocks: 'A escolher blocos',
    planPreparing: 'A preparar o plano',
    hideDetails: 'Ocultar detalhes',
    details: 'Detalhes',
    emptyStateTitle: 'Como posso ajudar?',
    emptyStateSubtitle: 'Descreve o que fazer — ou escolhe um exemplo abaixo',
    undoing: 'A anular…',
    undo: 'Anular',
    blockSingular: 'bloco',
    blockPlural: 'blocos',
    usageCostTitle: 'Custo deste pedido',
    tokens: 'tokens',
    stop: 'Parar',
    scopeSiteTitle: 'Alterações em todo o site',
    scopePageTitle: 'Alterações apenas na página atual',
    customDesign: 'Design personalizado',
    appointmentEmbedTitle: 'URL de incorporação',
    appointmentEmbedSubtitle: 'Incorporar o Calendly como iframe em linha',
    appointmentEmbedCaption: 'URL do Calendly',
    appointmentEmbedTooltip: 'Cole o URL do seu evento do Calendly (ex.: https://calendly.com/you/30min)',
    appointmentEmbedInvalid: 'Introduza um URL do Calendly válido (ex.: https://calendly.com/you/30min)',
  },
  ama: {
    questions: 'perguntas',
    all: 'Todas',
    unanswered: 'Sem resposta',
    answered: 'Respondidas',
    loading: 'A carregar...',
    noQuestions: 'Ainda não há perguntas',
    anonymous: 'Anónimo',
    noName: 'Sem nome',
    yourAnswer: 'A tua resposta',
    edit: 'Editar',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    enterAnswer: 'Introduz a tua resposta...',
    saveAnswer: 'Guardar resposta',
    confirmDelete: 'Eliminar esta pergunta?',
    answerSaved: 'Resposta guardada',
    deleted: 'Eliminada',
  },
  adsManager: {
    estimatedAudience: 'Tamanho estimado da audiência',
    audienceTooLarge: 'A tua audiência é muito ampla — considera restringi-la.',
    audienceTooNarrow: 'A tua audiência é muito pequena — considera alargá-la.',
    audience: 'Audiência',
    suggestedAudience: 'Usar audiência sugerida',
    suggestedAudienceHint: 'Segmentação ampla, ideal para alcance',
    buildYourOwn: 'Criar a tua própria',
    buildYourOwnHint: 'Define idade, género e países',
    expectedViewers: 'Espectadores esperados do anúncio',
    totalBudget: 'Orçamento total da campanha',
    duration: 'Duração',
    days: 'dias',
    advancedSchedule: 'Agendamento avançado',
    hideAdvanced: 'Ocultar agendamento avançado',
    adPreview: 'Pré-visualização do anúncio',
    sponsored: 'Patrocinado',
    seeMore: 'Ver mais',
    learnMore: 'Saber mais',
    yourPage: 'A tua página',
  },
  virtualBackgrounds: {
    title: 'Fundos virtuais',
    canvasSize: 'Tamanho da tela',
    fmtCall: 'Zoom · Teams · Meet',
    fmtStories: 'Stories · Reels',
    fmtSquare: 'Quadrado',
    fmtClassic: 'Clássico',
    background: 'Fundo',
    bg_color: 'Cor',
    bg_gradient: 'Gradiente',
    bg_photo: 'Foto',
    bg_pattern: 'Padrão',
    from: 'De',
    to: 'Para',
    angle: 'Ângulo',
    ink: 'Tinta',
    paper: 'Papel',
    blur: 'Desfoque',
    darken: 'Escurecer',
    presets: 'Predefinições',
    uploadImage: 'Carregar imagem',
    removeImage: 'Remover imagem',
    replace: 'Substituir',
    remove: 'Remover',
    photoPlaceholder: 'Carrega uma imagem a partir do painel',
    overlay: 'Sobreposição',
    showName: 'Mostrar nome',
    namePlaceholder: 'O teu nome',
    subtitlePlaceholder: 'Subtítulo / identificador',
    typeface: 'Tipo de letra',
    textColour: 'Cor do texto',
    nameSizeLabel: 'Tamanho do nome',
    position: 'Posição',
    showQr: 'Mostrar código QR',
    qrPlaceholder: 'https://link',
    style: 'Estilo',
    qrCard: 'Cartão',
    qrBrand: 'Marca',
    qrLight: 'Claro',
    qrSolid: 'Sólido',
    qrSizeLabel: 'Tamanho do QR',
    logo: 'Logótipo / avatar',
    uploadLogo: 'Carregar logótipo (PNG)',
    logoSizeLabel: 'Tamanho do logótipo',
    finishing: 'Acabamento',
    vignette: 'Vinheta',
    vignetteHint: 'Bordas escuras suaves para dar profundidade',
    shuffle: 'Baralhar',
    reset: 'Repor',
    dragHint: 'Arrasta o nome, o QR ou o logótipo na tela para reposicionar',
    preparing: 'A preparar…',
    download: 'Descarregar',
    sizeHint: 'Guardado como JPG de 1920 × 1080',
  },
  emailSignatures: {
    signatures: 'Assinaturas',
    signature: 'Assinatura',
    signatureName: 'Rótulo',
    signatureNamePlaceholder: 'Trabalho, Pessoal…',
    newSignature: 'Nova assinatura',
    createSignature: 'Criar assinatura',
    emptyText: 'Crie uma assinatura e todos os e-mails que enviar vão levar à sua página.',
    default: 'Padrão',
    isDefault: 'Assinatura padrão',
    makeDefault: 'Tornar padrão',
    duplicate: 'Duplicar',
    delete: 'Excluir',
    save: 'Salvar',
    saving: 'Salvando…',
    saved: 'Assinatura salva',
    fillFromCard: 'Preencher a partir do cartão',
    noCard: 'Ainda não há cartão de visita — preencha os campos manualmente',
    extras: 'Extras',
    socialLinks: 'Redes sociais',
    logo: 'Logo da empresa',
    upload: 'Enviar',
    uploading: 'Enviando…',
    uploadFailed: 'Falha no envio',
    imageTooLarge: 'A imagem deve ter menos de {size} MB',
    remove: 'Remover',
    ctaText: 'Texto do botão',
    ctaTextPlaceholder: 'Agendar uma call',
    ctaUrl: 'Link do botão',
    banner: 'Banner',
    disclaimer: 'Aviso legal',
    disclaimerPlaceholder: 'Aviso de confidencialidade, dados da empresa…',
    tracking: 'Rastreamento',
    copyLink: 'Copiar link',
    linkCopied: 'Link copiado',
    renewLink: 'Renovar link',
    renewing: 'Renovando…',
    linkRenewed: 'Link renovado',
    renewHint: 'Renovar gera um link novo. As assinaturas já enviadas param de funcionar — os contadores abaixo são mantidos.',
    statClicks: 'Cliques no link',
    statQrScans: 'Leituras de QR',
    statCtaClicks: 'Cliques no botão',
    title: 'Assinaturas de email',
    details: 'Detalhes',
    name: 'Nome',
    jobTitle: 'Cargo',
    company: 'Empresa',
    email: 'Email',
    phone: 'Telefone',
    website: 'Website',
    style: 'Estilo',
    styleModern: 'Moderno',
    styleClassic: 'Clássico',
    styleMinimal: 'Minimalista',
    styleBold: 'Destacado',
    styleCard: 'Cartão',
    accent: 'Cor de destaque',
    showAvatar: 'Mostrar foto',
    showQr: 'Mostrar código QR',
    preview: 'Pré-visualizar',
    copySignature: 'Copiar assinatura',
    copyHtml: 'Copiar HTML',
    copied: 'Assinatura copiada',
    copiedHtml: 'HTML copiado',
    instructions: {
      gmail: 'Gmail: Definições → Ver todas as definições → Geral → Assinatura → Criar nova, depois cola (Ctrl/Cmd+V) e guarda as alterações.',
      outlook:
        'Outlook: Ficheiro → Opções → Correio → Assinaturas → Nova, depois cola. Novo Outlook / web: Definições → Correio → Compor e responder → cola na caixa da assinatura.',
      apple: 'Apple Mail: Mail → Definições → Assinaturas → adiciona uma assinatura, depois cola-a. Desmarca “Utilizar sempre o tipo de letra predefinido das mensagens”.',
    },
  },
  storyEditor: {
    back: 'Voltar',
    general: 'Geral',
    text: 'Texto',
    cta: 'CTA',
    media: 'Mídia',
    items: 'Produtos',
    addOns: 'Complementos',
    stickers: 'Stickers',
    layers: 'Camadas',
    save: 'Salvar',
    delete: 'Excluir',
    addText: 'Adicionar texto',
    addCta: 'Clique aqui',
    unsavedChanges: 'Alterações não salvas',
    leaveConfirm: 'Sair sem salvar? As alterações serão perdidas.',
    title: 'Título',
    enterTitle: 'Digite o título',
    duration: 'Duração',
    durationHint: 'Quanto tempo a story fica na tela',
    kenBurns: 'Ken Burns (zoom lento)',
    content: 'Conteúdo',
    enterContent: 'Digite o conteúdo',
    url: 'URL',
    enterUrl: 'Digite a URL',
    fontSize: 'Tamanho da fonte',
    chooseFontSize: 'Escolha o tamanho',
    stylePreset: 'Estilo',
    stylePresetHint: 'Aplicar um estilo pronto',
    animation: 'Animação',
    animationHint: 'Animação de entrada',
    color: 'Cor',
    chooseColors: 'Escolha as cores',
    filter: 'Filtro',
    cropImage: 'Recortar imagem',
    nothingToAdd: 'Nada para adicionar ainda',
    noLayers: 'Nenhuma camada',
    bringForward: 'Trazer para frente',
    sendBackward: 'Enviar para trás',
    responses: 'Respostas',
    noResponses: 'Ainda sem respostas',
  },
  storyGroups: {
    stories: 'Stories',
    addStoryGroup: '+ Adicionar grupo',
    newStory: '+ Nova story',
    previewGroup: 'Pré-visualizar grupo',
    noStoriesYet: 'Ainda sem stories',
    editGroup: 'Editar grupo',
    duplicate: 'Duplicar',
    delete: 'Excluir',
    preview: 'Pré-visualizar',
    name: 'Nome',
    content: 'Conteúdo',
    views: 'Visualizações',
    behavior: 'Comportamento',
    live: 'Ativa',
    cover: 'Capa',
    groupName: 'Nome',
    enterGroupName: 'Digite o nome do grupo',
    save: 'Salvar',
    behaviour: 'Comportamento',
    behaviourPermanent: 'Permanente',
    behaviourPermanentHint: 'Sempre disponível no widget',
    behaviourDaily: 'Diário',
    behaviourDailyHint: 'Marcado como visto uma vez por dia',
    behaviourOnce: 'Uma vez',
    behaviourOnceHint: 'Oculto após a visualização',
    widgets: 'Widgets',
    widgetsHint: 'Em quais widgets este grupo aparece',
    noWidgets: 'Ainda sem widgets',
  },
};
